<div *ngIf="isLoading" id="spinner">
  <mat-progress-spinner class="mat-spinner-color" mode="indeterminate"></mat-progress-spinner>
</div>
<div class="dashboard">
  <div class="header-section">
    <div class="header-left">
      <h1 data-tour="dashboard-title">Dashboard</h1>
    </div>
        <!-- Organization Dropdown - Fully Customizable -->
    <div class="org-dropdown-section" *ngIf="userOrgList && userOrgList.length > 0 && isSystemSuperAdmin" style="margin-right: 40px; display: flex; align-items: center; gap: 15px;">
      <!-- Multiple Organizations - Custom Dropdown -->

      <div *ngIf="userOrgList && userOrgList.length > 1" class="custom-org-dropdown-wrapper">
        <button class="custom-org-dropdown-btn" 
                (click)="toggleOrgDropdown()"
                [class.active]="showOrgDropdown">
          <span class="org-dropdown-label">
            {{ getSelectedOrgName() }}
          </span>
          <mat-icon class="org-dropdown-arrow" [class.active]="showOrgDropdown">expand_more</mat-icon>
        </button>

        <!-- Dropdown Menu -->
        <div class="custom-org-dropdown-menu" 
             *ngIf="showOrgDropdown" 
             [@.disabled]="true"
             (click)="$event.stopPropagation()">
          <div class="org-dropdown-search">
            <input type="text" 
                   class="org-search-input" 
                   placeholder="Search organization..." 
                   [(ngModel)]="orgSearchTerm"
                   (input)="filterOrgList()">
          </div>
          <div class="org-dropdown-options">
            <div *ngFor="let org of filteredOrgList" 
                 class="org-dropdown-option"
                 [class.selected]="selectedUserOrg === org.org_id"
                 (click)="selectOrganization(org)">
              <span class="org-option-name">{{ org.org_name }}</span>
            </div>
            <div *ngIf="filteredOrgList.length === 0" class="org-no-options">
              No organizations found
            </div>
          </div>
        </div>
      </div>

      <!-- Single Organization - Display Only -->
      <div *ngIf="userOrgList && userOrgList.length == 1" class="org-display-single">
        <span class="org-single-name">{{ userOrgList[0].org_name }}</span>
      </div>
       <!-- Global Download Button -->
      <button class="global-download-btn" 
              (click)="downloadGlobalReport()"
              matTooltip="Download all dashboard data as PDF report">
        <mat-icon>download</mat-icon>
      </button>
      
    </div>
  </div>
  <div class="header-right">


    <div class="view-as">
      <span>Viewing: </span>
      <div class="view-options">
        <button *ngFor="let viewType of availableViewTypes" class="view-btn"
          [class.active]="selectedViewType === viewType.value" (click)="selectViewType(viewType.value)">
          {{ viewType.label }}
        </button>
      </div>
    </div>
    
  </div>

  <!-- Summary Section -->
  <div class="summary-section header-right" data-tour="summary-section">
    <div class="summary-header">
      <h2 class="summary-title">Summary</h2>
    </div>
    <!-- Date Range Filter Moved Here -->
    <div class="date-filter-header">
      <div class="date-range-dropdown" data-tour="date-filter">
        <button class="dropdown-btn" (click)="toggleDateDropdown()" style="margin-left: 60px !important;">
          <span>{{ selectedRange }}</span>
          <span class="dropdown-arrow"><mat-icon>expand_more</mat-icon></span>
        </button>

        <!-- Quick Options Dropdown (5 Options with Radio Button Style) -->
        <div class="dropdown-menu calendar-dropdown" style="margin-left: -200px;"
          [class.show]="showDateDropdown && !showCustomCalendar">
          <div class="quick-options" style="width: 100%; padding: 0; margin: 0;">
            <div class="quick-options-list">
              <button class="quick-option radio-option" [class.active]="selectedRange === 'This month'"
                (click)="selectRange('This month')">
                <span class="radio-button" [class.selected]="selectedRange === 'This month'"></span>
                <span class="option-label">This month</span>
              </button>
              <button class="quick-option radio-option" [class.active]="selectedRange === 'Last 30 days'"
                (click)="selectRange('Last 30 days')">
                <span class="radio-button" [class.selected]="selectedRange === 'Last 30 days'"></span>
                <span class="option-label">Last 30 days</span>
              </button>
              <button class="quick-option radio-option" [class.active]="selectedRange === 'Last 6 months'"
                (click)="selectRange('Last 6 months')">
                <span class="radio-button" [class.selected]="selectedRange === 'Last 6 months'"></span>
                <span class="option-label">Last 6 months</span>
              </button>
              <button class="quick-option radio-option" [class.active]="selectedRange === 'Last 1 year'"
                (click)="selectRange('Last 1 year')">
                <span class="radio-button" [class.selected]="selectedRange === 'Last 1 year'"></span>
                <span class="option-label">Last 1 year</span>
              </button>
              <button class="quick-option radio-option" [class.active]="selectedRange === 'Custom'"
                (click)="selectRange('Custom')">
                <span class="radio-button" [class.selected]="selectedRange === 'Custom'"></span>
                <span class="option-label">Custom</span>
              </button>
            </div>
          </div>
        </div>

        <!-- Calendar Section (Full Width when Custom is selected) -->
        <div class="dropdown-menu calendar-dropdown" style="margin-left: -200px;"
          [class.show]="showDateDropdown && showCustomCalendar">
          <div class="calendar-section">
            <div class="calendar-header">
              <div class="month-year-selector">
                <button class="nav-btn" (click)="previousMonth()">‹</button>

                <!-- Combined Month-Year Dropdown (Compact Version) -->
                <div class="compact-picker-container">
                  <button class="compact-picker-btn" (click)="toggleCompactPicker()">
                    {{ monthNames[currentMonth.getMonth()] }} {{ currentMonth.getFullYear() }}
                  </button>
                  <div class="compact-picker-dropdown" *ngIf="showCompactPicker">
                    <div class="compact-picker-content">
                      <!-- Years Grid -->
                      <div class="compact-years">
                        <button *ngFor="let year of getAvailableYears()" class="compact-year-item"
                          [class.active]="year === currentMonth.getFullYear()" (click)="selectYear(year)">
                          {{ year }}
                        </button>
                      </div>

                      <!-- Months Grid -->
                      <div class="compact-months">
                        <button *ngFor="let month of monthNames; let i = index" class="compact-month-item"
                          [class.active]="i === currentMonth.getMonth()" (click)="selectMonth(i)">
                          {{ month }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <button class="nav-btn" (click)="nextMonth()">›</button>
              </div>
            </div>

            <!-- Calendar Grid -->
            <div class="calendar-grid">
              <div class="day-header">S</div>
              <div class="day-header">M</div>
              <div class="day-header">T</div>
              <div class="day-header">W</div>
              <div class="day-header">T</div>
              <div class="day-header">F</div>
              <div class="day-header">S</div>

              <div *ngFor="let day of calendarDays" class="calendar-day" [class.empty]="!day"
                [class.selected]="day && isDateSelected(day)" [class.in-range]="day && isDateInRange(day)"
                [class.today]="day && isToday(day)" (click)="day && selectDate(day)">
                {{ day?.getDate() || '' }}
              </div>
            </div>

            <!-- Selected Range Display -->
            <div class="selected-range-display" *ngIf="startDate || endDate">
              <div class="from-to-section">
                <div class="date-field">
                  <label>From</label>
                  <div class="selected-date">{{ startDate | date: 'dd/MM/yyyy' }}</div>
                </div>
                <div class="date-field">
                  <label>To</label>
                  <div class="selected-date" [class.empty]="!endDate">
                    {{ endDate ? (endDate | date:'dd/MM/yyyy') : 'Select end date' }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="calendar-actions">
              <button class="btn-cancel" (click)="cancelDateSelection()">Cancel</button>
              <button class="btn-apply" [class.disabled]="!startDate || !endDate"
                (click)="applyDateSelection()">Apply</button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <button class="dropdown-btn" (click)="clearAllFilters()">
          <span>Clear Filters</span>
        </button>
      </div>
    </div>
  </div>

  <!-- All Sections Displayed Without Accordion -->
  <div class="sections-container">
    <!-- All Data Section (Only visible when "All" is selected) -->
    <div class="section" *ngIf="selectedViewType === 'all'">
      <div class="summarypone">
        <div class="summary-wrapper mt-3 mb-2">
          <div class="librarysummary">
            <div class="header-summary">
              <span class="innertitle">Question Paper Insights</span>
              <button class="filter-toggle-btn" (click)="toggleQuestionPaperInsightFilterPanel($event)" style="margin-top: -17px !important;margin-left: 13px;">
                <svg width="20" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                </svg>
              </button>
            </div>
            <div class="boxes">
              <div class="details">
                <div class="detaileds">
                    <div class="row-items">
                      <span class="title-rows"><mat-icon class="insight-icon insight-active" matTooltip="Total number of active questions available">question_mark</mat-icon>Active Questions</span>
                      <span class="count count-active">{{ getDisplayActiveQuestions() }}</span>
                    </div>
                </div>
                <div style="margin-bottom: -6px !important;">
                  <div class="tl-row">
                    <span class="title-rows"><mat-icon class="insight-icon insight-underperforming" style="margin-left: 4px !important;" matTooltip="Inactive questions in the question bank">question_mark</mat-icon>Inactive Questions</span>
                    <span class="count count-underperforming" style="margin-right: 3px !important;">{{ getDisplayInactiveQuestions() }}</span>
                  </div>
                </div>
                <div class="detaileds">
                    <div class="row-items">
                      <span class="title-rows"><mat-icon class="insight-icon insight-flagged" matTooltip="Questions marked as flagged">question_mark</mat-icon>Flagged Questions</span>
                      <span class="count count-flagged">{{ getDisplayQuestionPaperFlaggedQuestions() }}</span>
                    </div>
                </div>
                <div class="detaileds">
                    <div class="row-items">
                      <span class="title-rows"><mat-icon class="insight-icon insight-total" matTooltip="Total number of questions">question_mark</mat-icon>Total Questions</span>
                      <span class="count">{{ getDisplayTotalQuestions() }}</span>
                    </div>
                </div>
              </div>
              <div class="detailed-item-divide" style="margin-top: 20px;">
                <div class="detailed-c">
                  <div class="row-item-s">
                    <div [hidden]="!showQuestionPaperInsightsDonutChart" style="flex: 1; min-height: 140px; max-width: 140px;">
                      <canvas id="questionPaperInsightsChart" style="display: block;"></canvas>
                    </div>
                  </div>
                </div>
                <!--<div class="detailed-arrow">
                  <div class="trend-indicator-box" 
                    *ngIf="getPlannedAssessmentsTrendDirection() !== 'neutral'">
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'down'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                      <path d="M10.614013888888888 10.612652777777777c-0.48176944444444436 0 -0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221s0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221h4.354988888888888c0.48176944444444436 0 0.8709972222222221 -0.389225 0.8709972222222221 -0.8709972222222221V7.128661111111111c0 -0.48176944444444436 -0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222221s-0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221v2.250986111111111L9.48716111111111 4.771525c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0L5.388027777777777 7.63765 1.6481805555555553 3.900527777777778c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0s-0.34023333333333333 0.8927722222222222 0 1.2330055555555555l4.354988888888888 4.354988888888888c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l2.8688499999999997 -2.8688499999999997 3.9929777777777775 3.992980555555555h-2.250983333333333Z" fill="#ef4444" stroke-width="0.0278"></path>
                    </svg>
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'up'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                      <path d="M5.385986111111112 5.387347222222222c0.48176944444444436 0 0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221s-0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222222221H1.031998823c-0.48176944444444436 0 -0.8709972222222221 0.389225 -0.8709972222222221 0.8709972222222221v7.737679555555556c0 0.48176944444444436 0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221s0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221v-2.250986111111111l1.126688888888889 1.126688888888889c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l4.099 -4.099 3.739947222222223 3.739947222222223c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0s0.34023333333333333 -0.8927722222222222 0 -1.2330055555555555l-4.354988888888888 -4.354988888888888c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0l-2.8688499999999997 2.8688499999999997 -3.9929777777777775 -3.992980555555556h2.250983333333333Z" fill="#10b981" stroke-width="0.0278"></path>
                    </svg>
                    
                    <span class="trend-percentage">{{ getPlannedAssessmentsTrendPercentage() }}% executed vs last month</span>
                  </div>
                </div>-->
              </div>
              
            </div>
            <!-- Question Paper Insights Filter Panel -->
          <div class="filter-panel-container" style="margin-right: 60px; margin-top: 0px;" [class.active]="showQuestionPaperInsightFilterPanel">
            <div class="filter-panel">
              <div class="filter-columns-container">
                <!-- Left Column - Filter Headers -->
                <div class="filter-headers-column">
                  <!-- Filter Header with Icon -->
                  <div class="filter-headers-header">
                    <mat-icon class="filter-icon">tune</mat-icon>
                    <span class="filter-title">Filter</span>
                  </div>
                  
                  <div class="filter-headers-list">
                    <div *ngFor="let header of questionPaperInsightFilterHeaders; let i = index" 
                      class="filter-header-item" 
                      [class.active]="activeQuestionPaperInsightFilterHeader === header.key">
                      <label class="filter-header-checkbox-label" [for]="'question-paper-insight-header-' + i">
                        <input type="checkbox" class="filter-checkbox-input" 
                          [id]="'question-paper-insight-header-' + i"
                          [checked]="activeQuestionPaperInsightFilterHeader === header.key"
                          (click)="setActiveQuestionPaperInsightFilterHeader(header.key)"
                          (change)="setActiveQuestionPaperInsightFilterHeader(header.key)"
                          style="display: none;">
                        <span class="filter-checkmark"></span>
                        <span class="filter-header-name">{{ header.name }}</span>
                      </label>
                    </div>
                  </div>
                  
                  <!-- Clear Button -->
                  <button class="filter-clear-button" (click)="clearQuestionPaperInsightFilters()">
                    Clear
                  </button>
                </div>

                <!-- Right Column - Filter Content -->
                <div class="filter-content-column">
                  <!-- Search Input -->
                  <div class="filter-search" *ngIf="activeQuestionPaperInsightFilterHeader === 'courses'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search courses" 
                        [(ngModel)]="questionPaperInsightCourseSearchTerm"
                        (keyup)="filterQuestionPaperInsightCoursesFromApi()">
                    </div>

                  <div class="filter-search" *ngIf="activeQuestionPaperInsightFilterHeader === 'geography'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search geography" 
                        [(ngModel)]="questionPaperInsightFilterSearchTerm"
                        (keyup)="filterQuestionPaperInsightGeography()">
                    </div>

                  <!-- Search Input - Customer -->
                  <div class="filter-search" *ngIf="activeQuestionPaperInsightFilterHeader === 'customer'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search customer" 
                        [(ngModel)]="questionPaperInsightCustomerSearchTerm"
                        (keyup)="filterQuestionPaperInsightCustomersFromApi()">
                    </div>

                  <!-- Date Range Selector -->
                  <div class="filter-search" *ngIf="activeQuestionPaperInsightFilterHeader === 'date'">
                    <div class="date-dropdown-row">
                      <button class="dropdown-btny" type="button" (click)="toggleQuestionPaperInsightYearDropdown()">
                        {{ selectedQuestionPaperInsightYearRange }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showQuestionPaperInsightYearDropdown">
                        <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                          [class.active]="selectedQuestionPaperInsightYearRange === yearRange.value"
                          (click)="selectQuestionPaperInsightYearRange(yearRange.value)">
                          {{ yearRange.display }}
                        </button>
                      </div>
                    </div>

                    <div class="date-dropdown-row" style="margin-top: 10px;">
                      <button class="dropdown-btny" type="button" (click)="toggleQuestionPaperInsightMonthDropdown()">
                        {{ selectedQuestionPaperInsightMonth ? getMonthName(selectedQuestionPaperInsightMonth) : 'All Months' }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showQuestionPaperInsightMonthDropdown">
                        <button *ngFor="let month of availableMonths" class="dropdown-item"
                          [class.active]="selectedQuestionPaperInsightMonth === month.value"
                          (click)="selectQuestionPaperInsightMonth(month.value)">
                          {{ month.name }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Filter Options - Courses -->
                  <div class="filter-options-container" style="margin-top: 5px;" *ngIf="activeQuestionPaperInsightFilterHeader === 'courses'">
                    <div class="filter-options-list">
                      <label class="filter-option-item" *ngFor="let course of filteredQuestionPaperInsightCourseApiList" >
                        <input type="checkbox" class="filter-checkbox-input" 
                          [checked]="selectedQuestionPaperInsightCourseValues.includes(course.name)"
                          (change)="toggleQuestionPaperInsightFilter('courses', course.name)">
                        <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                        <span class="filter-option-name">{{ course.name }}</span>
                      </label>
                    </div>
                  </div>

                  <!-- Filter Options - Geography -->
                  <div class="filter-options-container" *ngIf="activeQuestionPaperInsightFilterHeader === 'geography'">
                    <div class="filter-options-list">
                      <label class="filter-option-item" *ngFor="let geo of filteredQuestionPaperInsightGeographyList" >
                        <input type="checkbox" class="filter-checkbox-input" 
                          [checked]="selectedQuestionPaperInsightGeographyValues.includes(geo.state)"
                          (change)="toggleQuestionPaperInsightFilter('geography', geo.state)">
                        <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                        <span class="filter-option-name">{{ geo.state }}</span>
                      </label>
                    </div>
                  </div>

                  <!-- Filter Options - Customer -->
                  <div class="filter-options-container" *ngIf="activeQuestionPaperInsightFilterHeader === 'customer'">
                    <div class="filter-options-list">
                      <label class="filter-option-item" *ngFor="let customer of filteredQuestionPaperInsightCustomerApiList">
                        <input type="checkbox" class="filter-checkbox-input" 
                          [checked]="selectedQuestionPaperInsightCustomerValues.includes(customer.name)"
                          (change)="toggleQuestionPaperInsightFilter('customer', customer.name)">
                        <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                        <span class="filter-option-name">{{ customer.name }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          
          <div class="tl-card">
            <div class="tl-header">Tag & Label Usage Insights</div>
             <div class="tl-body">

              <!-- TAGGING -->
              <div class="tl-block">
                <div class="tl-heading">Tagging</div>

                <div class="tl-row">
                  <span>Questions tagged properly:</span>
                  <span class="tl-num">{{ getDisplayQuestionsWithTag() }}</span>
                </div>

                <div class="tl-row">
                  <span>Untagged Questions:</span>
                  <span class="tl-num tl-red">{{ getDisplayQuestionsWithoutTag() }}</span>
                </div>

                <div class="detailed-arrow">
                  <div class="trend-indicator-box" 
                    *ngIf="getTaggingTrendDirection() !== 'neutral'">
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'down'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                      <path d="M10.614013888888888 10.612652777777777c-0.48176944444444436 0 -0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221s0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221h4.354988888888888c0.48176944444444436 0 0.8709972222222221 -0.389225 0.8709972222222221 -0.8709972222222221V7.128661111111111c0 -0.48176944444444436 -0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222221s-0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221v2.250986111111111L9.48716111111111 4.771525c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0L5.388027777777777 7.63765 1.6481805555555553 3.900527777777778c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0s-0.34023333333333333 0.8927722222222222 0 1.2330055555555555l4.354988888888888 4.354988888888888c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l2.8688499999999997 -2.8688499999999997 3.9929777777777775 3.992980555555555h-2.250983333333333Z" fill="#ef4444" stroke-width="0.0278"></path>
                    </svg>
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'up'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                      <path d="M5.385986111111112 5.387347222222222c-0.48176944444444436 0 0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221s-0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222222221H1.031998823c-0.48176944444444436 0 -0.8709972222222221 0.389225 -0.8709972222222221 0.8709972222222221v7.737679555555556c0 0.48176944444444436 0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221s0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221v-2.250986111111111l1.126688888888889 1.126688888888889c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l4.099 -4.099 3.739947222222223 3.739947222222223c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0s0.34023333333333333 -0.8927722222222222 0 -1.2330055555555555l-4.354988888888888 -4.354988888888888c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0l-2.8688499999999997 2.8688499999999997 -3.9929777777777775 -3.992980555555556h2.250983333333333Z" fill="#10b981" stroke-width="0.0278"></path>
                    </svg>
                    
                    <span class="trend-percentage">{{ getPlannedAssessmentsTrendPercentage() }}% executed vs last month</span>
                  </div>
                </div>
              </div>
              <!-- LABELLING -->
              <div class="tl-block">
                <div class="tl-heading">Labelling</div>

                <div class="tl-row">
                  <span>Questions labelled properly:</span>
                  <span class="tl-num">{{ getDisplayQuestionsWithLabel() }}</span>
                </div>

                <div class="tl-row">
                  <span>Unlabelled Questions:</span>
                  <span class="tl-num tl-red">{{ getDisplayQuestionsWithoutLabel() }}</span>
                </div>

                <div class="detailed-arrow">
                  <div class="trend-indicator-box" 
                    *ngIf="getPlannedAssessmentsTrendDirection() !== 'neutral'">
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'down'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                      <path d="M10.614013888888888 10.612652777777777c-0.48176944444444436 0 -0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221s0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221h4.354988888888888c0.48176944444444436 0 0.8709972222222221 -0.389225 0.8709972222222221 -0.8709972222222221V7.128661111111111c0 -0.48176944444444436 -0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222221s-0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221v2.250986111111111L9.48716111111111 4.771525c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0L5.388027777777777 7.63765 1.6481805555555553 3.900527777777778c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0s-0.34023333333333333 0.8927722222222222 0 1.2330055555555555l4.354988888888888 4.354988888888888c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l2.8688499999999997 -2.8688499999999997 3.9929777777777775 3.992980555555555h-2.250983333333333Z" fill="#ef4444" stroke-width="0.0278"></path>
                    </svg>
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'up'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                      <path d="M5.385986111111112 5.387347222222222c0.48176944444444436 0 0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221s-0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222222221H1.031998823c-0.48176944444444436 0 -0.8709972222222221 0.389225 -0.8709972222222221 0.8709972222222221v7.737679555555556c0 0.48176944444444436 0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221s0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221v-2.250986111111111l1.126688888888889 1.126688888888889c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l4.099 -4.099 3.739947222222223 3.739947222222223c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0s0.34023333333333333 -0.8927722222222222 0 -1.2330055555555555l-4.354988888888888 -4.354988888888888c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0l-2.8688499999999997 2.8688499999999997 -3.9929777777777775 -3.992980555555556h2.250983333333333Z" fill="#10b981" stroke-width="0.0278"></path>
                    </svg>
                    
                    <span class="trend-percentage">{{ getPlannedAssessmentsTrendPercentage() }}% executed vs last month</span>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
         <div class="summary-wrapper mt-3 mb-2">

          <div class="librarysummary">
            <div class="header-summary">
              <span class="innertitle">Candidate Insights</span>
              <!--<button class="filter-toggle-btn" (click)="toggleCandidateInsightFilterPanel($event)" style="margin-top: -17px !important;margin-left: 13px;">
                <svg width="20" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                </svg>
              </button>-->
            </div>
            <div class="boxes">
              <div class="details">
                <div class="detaileds">
                    <div class="row-items">
                      <span class="title-rows" ><mat-icon style="margin-top: -2px;">person</mat-icon>Candidates assessed</span>
                      <span class="count">{{ getDisplayTotalAttempts() }}</span>
                    </div>
                </div>
                <div class="detaileds">
                    <div class="row-items">
                      <span class="title-rows" ><mat-icon style="margin-top: -2px;">check_circle</mat-icon>Pass:</span>
                      <span class="count">{{ getDisplayTotalPassCandidates() }}</span>
                    </div>
                </div>
                <div class="detaileds">
                    <div class="row-items">
                      <span class="title-rows" ><mat-icon style="margin-top: -2px;">cancel</mat-icon>Fail:</span>
                      <span class="count" style="color: red;">{{ getDisplayTotalFailCandidates() }}</span>
                    </div>
                </div>
                <div class="detaileds" style="background-color: transparent;border: none;margin-top: -10px;margin-left: -10px;">
                    <div class="row-items">
                      <span class="title-rows" ><span style="color: red;">{{ getDisplayTotalReassessedCandidates() }}</span> Reassessed</span>
                    </div>
                </div>
              </div>
               <div class="detailed-item-divide">
                <div class="detailed-c">
                  <div class="row-item-s">
                    <div *ngIf="showCandidateInsightsDonutChart" style="flex: 1; min-height: 140px; max-width: 140px;">
                      <canvas id="candidateInsightsChart" style="display: block;"></canvas>
                    </div>
                  </div>
                </div>
                <!--<div class="detailed-arrow">
                  <div class="trend-indicator-box" 
                    *ngIf="getPlannedAssessmentsTrendDirection() !== 'neutral'">
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'down'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                      <path d="M10.614013888888888 10.612652777777777c-0.48176944444444436 0 -0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221s0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221h4.354988888888888c0.48176944444444436 0 0.8709972222222221 -0.389225 0.8709972222222221 -0.8709972222222221V7.128661111111111c0 -0.48176944444444436 -0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222221s-0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221v2.250986111111111L9.48716111111111 4.771525c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0L5.388027777777777 7.63765 1.6481805555555553 3.900527777777778c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0s-0.34023333333333333 0.8927722222222222 0 1.2330055555555555l4.354988888888888 4.354988888888888c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l2.8688499999999997 -2.8688499999999997 3.9929777777777775 3.992980555555555h-2.250983333333333Z" fill="#ef4444" stroke-width="0.0278"></path>
                    </svg>
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'up'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                      <path d="M5.385986111111112 5.387347222222222c0.48176944444444436 0 0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221s-0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222222221H1.031998823c-0.48176944444444436 0 -0.8709972222222221 0.389225 -0.8709972222222221 0.8709972222222221v7.737679555555556c0 0.48176944444444436 0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221s0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221v-2.250986111111111l1.126688888888889 1.126688888888889c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l4.099 -4.099 3.739947222222223 3.739947222222223c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0s0.34023333333333333 -0.8927722222222222 0 -1.2330055555555555l-4.354988888888888 -4.354988888888888c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0l-2.8688499999999997 2.8688499999999997 -3.9929777777777775 -3.992980555555556h2.250983333333333Z" fill="#10b981" stroke-width="0.0278"></path>
                    </svg>
                    
                    <span class="trend-percentage">{{ getPlannedAssessmentsTrendPercentage() }}% executed vs last month</span>
                  </div>
                </div>-->
              </div>
              
            </div>
           <div class="legends-visibility">
              <div class="legend-item">
                <span class="legend-color" style="background-color: #005068;"></span>
                <span class="legend-title" style="margin-top: 10px !important;">Pass</span>
              </div>
              <div class="legend-item">
                <span class="legend-color" style="background-color: #C71E1D;"></span>
                <span class="legend-title" style="margin-top: 10px !important;">Fail</span>
              </div>
              <div class="legend-item" style="display: flex; align-items: center; gap: 20px;">
                 <div style="display: flex; align-items: center;">
                  <span style="width: 12px; height: 12px; background-color: #A0A0FF; border-radius: 50%; display: inline-block; margin-right: 5px;"></span>
                  <span>Reassessed</span>
                </div>
                <div style="display: flex; align-items: center; gap: 4px;" *ngIf="getReassessedCandidatesTrendDirection() !== 'neutral'" class="indicator-trend">
                  <svg *ngIf="getReassessedCandidatesTrendDirection() === 'down'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                    <path d="M10.614013888888888 10.612652777777777c-0.48176944444444436 0 -0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221s0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221h4.354988888888888c0.48176944444444436 0 0.8709972222222221 -0.389225 0.8709972222222221 -0.8709972222222221V7.128661111111111c0 -0.48176944444444436 -0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222221s-0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221v2.250986111111111L9.48716111111111 4.771525c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0L5.388027777777777 7.63765 1.6481805555555553 3.900527777777778c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0s-0.34023333333333333 0.8927722222222222 0 1.2330055555555555l4.354988888888888 4.354988888888888c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l2.8688499999999997 -2.8688499999999997 3.9929777777777775 3.992980555555555h-2.250983333333333Z" fill="#ef4444" stroke-width="0.0278"></path>
                  </svg>
                  <svg *ngIf="getReassessedCandidatesTrendDirection() === 'up'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                    <path d="M5.385986111111112 5.387347222222222c0.48176944444444436 0 0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221s-0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222222221H1.031998823c-0.48176944444444436 0 -0.8709972222222221 0.389225 -0.8709972222222221 0.8709972222222221v7.737679555555556c0 0.48176944444444436 0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221s0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221v-2.250986111111111l1.126688888888889 1.126688888888889c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l4.099 -4.099 3.739947222222223 3.739947222222223c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0s0.34023333333333333 -0.8927722222222222 0 -1.2330055555555555l-4.354988888888888 -4.354988888888888c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0l-2.8688499999999997 2.8688499999999997 -3.9929777777777775 -3.992980555555556h2.250983333333333Z" fill="#10b981" stroke-width="0.0278"></path>
                  </svg>
                  <span class="trend-percentage">{{ getReassessedCandidatesTrendPercentage() }}% vs last month</span>
                </div>
              </div>
              <!--<div class="legend-item" style="display: none;">
                <div class="trend-indicator-box" 
                  *ngIf="getReassessedCandidatesTrendDirection() !== 'neutral'">
                  <svg *ngIf="getReassessedCandidatesTrendDirection() === 'down'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                    <path d="M10.614013888888888 10.612652777777777c-0.48176944444444436 0 -0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221s0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221h4.354988888888888c0.48176944444444436 0 0.8709972222222221 -0.389225 0.8709972222222221 -0.8709972222222221V7.128661111111111c0 -0.48176944444444436 -0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222221s-0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221v2.250986111111111L9.48716111111111 4.771525c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0L5.388027777777777 7.63765 1.6481805555555553 3.900527777777778c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0s-0.34023333333333333 0.8927722222222222 0 1.2330055555555555l4.354988888888888 4.354988888888888c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l2.8688499999999997 -2.8688499999999997 3.9929777777777775 3.992980555555555h-2.250983333333333Z" fill="#ef4444" stroke-width="0.0278"></path>
                  </svg>
                  <svg *ngIf="getReassessedCandidatesTrendDirection() === 'up'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                    <path d="M5.385986111111112 5.387347222222222c0.48176944444444436 0 0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221s-0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222222221H1.031998823c-0.48176944444444436 0 -0.8709972222222221 0.389225 -0.8709972222222221 0.8709972222222221v7.737679555555556c0 0.48176944444444436 0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221s0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221v-2.250986111111111l1.126688888888889 1.126688888888889c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l4.099 -4.099 3.739947222222223 3.739947222222223c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0s0.34023333333333333 -0.8927722222222222 0 -1.2330055555555555l-4.354988888888888 -4.354988888888888c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0l-2.8688499999999997 2.8688499999999997 -3.9929777777777775 -3.992980555555556h2.250983333333333Z" fill="#10b981" stroke-width="0.0278"></path>
                  </svg>
                  
                  <span class="trend-percentage">{{ getReassessedCandidatesTrendPercentage() }}% vs last month</span>
                </div>
              </div>-->
            </div>
            <!-- Candidate Insights Filter Panel -->
          <div class="filter-panel-container" style="margin-right: 60px;" [class.active]="showCandidateInsightFilterPanel">
            <div class="filter-panel">
              <div class="filter-columns-container">
                <!-- Left Column - Filter Headers -->
                <div class="filter-headers-column">
                  <!-- Filter Header with Icon -->
                  <div class="filter-headers-header">
                    <mat-icon class="filter-icon">tune</mat-icon>
                    <span class="filter-title">Filter</span>
                  </div>
                  
                  <div class="filter-headers-list">
                    <div *ngFor="let header of candidateInsightFilterHeaders; let i = index" 
                      class="filter-header-item" 
                      [class.active]="activeCandidateInsightFilterHeader === header.key">
                      <label class="filter-header-checkbox-label" [for]="'candidate-insight-header-' + i">
                        <input type="checkbox" class="filter-checkbox-input" 
                          [id]="'candidate-insight-header-' + i"
                          [checked]="activeCandidateInsightFilterHeader === header.key"
                          (click)="setActiveCandidateInsightFilterHeader(header.key)"
                          (change)="setActiveCandidateInsightFilterHeader(header.key)"
                          style="display: none;">
                        <span class="filter-checkmark"></span>
                        <span class="filter-header-name">{{ header.name }}</span>
                      </label>
                    </div>
                  </div>
                  
                  <!-- Clear Button -->
                  <button class="filter-clear-button" (click)="clearCandidateInsightFilters()">
                    Clear
                  </button>
                </div>

                <!-- Right Column - Filter Content -->
                <div class="filter-content-column">
                  <!-- Search Input -->
                  <div class="filter-search" *ngIf="activeCandidateInsightFilterHeader === 'courses'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search courses" 
                        [(ngModel)]="candidateInsightCourseSearchTerm"
                        (keyup)="filterCandidateInsightCoursesFromApi()">
                    </div>

                  <div class="filter-search" *ngIf="activeCandidateInsightFilterHeader === 'geography'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search geography" 
                        [(ngModel)]="candidateInsightFilterSearchTerm"
                        (keyup)="filterCandidateInsightGeography()">
                    </div>

                  <!-- Search Input - Customer -->
                  <div class="filter-search" *ngIf="activeCandidateInsightFilterHeader === 'customer'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search customer" 
                        [(ngModel)]="candidateInsightCustomerSearchTerm"
                        (keyup)="filterCandidateInsightCustomersFromApi()">
                    </div>

                  <!-- Date Range Selector -->
                  <div class="filter-search" *ngIf="activeCandidateInsightFilterHeader === 'date'">
                    <div class="date-dropdown-row">
                      <button class="dropdown-btny" type="button" (click)="toggleCandidateInsightYearDropdown()">
                        {{ selectedCandidateInsightYearRange }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showCandidateInsightYearDropdown">
                        <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                          [class.active]="selectedCandidateInsightYearRange === yearRange.value"
                          (click)="selectCandidateInsightYearRange(yearRange.value)">
                          {{ yearRange.display }}
                        </button>
                      </div>
                    </div>

                    <div class="date-dropdown-row" style="margin-top: 10px;">
                      <button class="dropdown-btny" type="button" (click)="toggleCandidateInsightMonthDropdown()">
                        {{ selectedCandidateInsightMonth ? getMonthName(selectedCandidateInsightMonth) : 'All Months' }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showCandidateInsightMonthDropdown">
                        <button *ngFor="let month of availableMonths" class="dropdown-item"
                          [class.active]="selectedCandidateInsightMonth === month.value"
                          (click)="selectCandidateInsightMonth(month.value)">
                          {{ month.name }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Filter Options - Courses -->
                  <div class="filter-options-container" style="margin-top: 5px;" *ngIf="activeCandidateInsightFilterHeader === 'courses'">
                    <div class="filter-options-list">
                      <label class="filter-option-item" *ngFor="let course of filteredCandidateInsightCourseApiList" >
                        <input type="checkbox" class="filter-checkbox-input" 
                          [checked]="selectedCandidateInsightCourseValues.includes(course.name)"
                          (change)="toggleCandidateInsightFilter('courses', course.name)">
                        <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                        <span class="filter-option-name">{{ course.name }}</span>
                      </label>
                    </div>
                  </div>

                  <!-- Filter Options - Geography -->
                  <div class="filter-options-container" *ngIf="activeCandidateInsightFilterHeader === 'geography'">
                    <div class="filter-options-list">
                      <label class="filter-option-item" *ngFor="let geo of filteredCandidateInsightGeographyList" >
                        <input type="checkbox" class="filter-checkbox-input" 
                          [checked]="selectedCandidateInsightGeographyValues.includes(geo.state)"
                          (change)="toggleCandidateInsightFilter('geography', geo.state)">
                        <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                        <span class="filter-option-name">{{ geo.state }}</span>
                      </label>
                    </div>
                  </div>

                  <!-- Filter Options - Customer -->
                  <div class="filter-options-container" *ngIf="activeCandidateInsightFilterHeader === 'customer'">
                    <div class="filter-options-list">
                      <label class="filter-option-item" *ngFor="let customer of filteredCandidateInsightCustomerApiList">
                        <input type="checkbox" class="filter-checkbox-input" 
                          [checked]="selectedCandidateInsightCustomerValues.includes(customer.name)"
                          (change)="toggleCandidateInsightFilter('customer', customer.name)">
                        <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                        <span class="filter-option-name">{{ customer.name }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>

          

          <!--<div class="librarysummary">
            <span class="innertitle">Assessment Status</span>
            <div class="details">
              <div class="row-item">
                <span>Published</span>
                <span class="count">{{ getDisplayAssessmentPublish() }}</span>
              </div>

              <div class="row-item">
                <span>Draft</span>
                <span class="count">{{ getDisplayAssessmentDraft() }}</span>
              </div>
            </div>
          </div>

          <div class="librarysummary">
            <span class="innertitle">Candidate Status</span>
            <div class="details">
              <div class="row-item">
                <span>Active Candidates</span>
                <span class="count">{{ getDisplayCandidateActive() }}</span>
              </div>

              <div class="row-item">
                <span>Inactive Candidates</span>
                <span class="count">{{ getDisplayCandidateInactive() }}</span>
              </div>
            </div>
          </div>-->

          <div class="librarysummary">
            <div class="header-summary">
              <span class="innertitle">Assessment Insights</span>
              <button class="filter-toggle-btn" (click)="toggleAssessmentInsightFilterPanel($event)" style="margin-top: -17px !important;margin-left: 13px;">
                <svg width="20" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                </svg>
              </button>
            </div>
            <div class="boxes">
              <div class="details">
                <div class="detailed">
                  <div class="row-item">
                    <span class="title-row">Planned: </span>
                    <span class="count">{{ getDisplayTotalPlannedAssessments() }}</span>
                  </div>
                </div>
                <div class="detailed">
                  <div class="row-item">
                    <span class="title-row">Executed: </span>
                    <span class="count">{{ getDisplayTotalExecutedAssessments() }}</span>
                  </div>
                </div>
                <div class="detailed">
                  <div class="row-item">
                    <span class="title-row">Evaluated: </span>
                    <span class="count">{{ getDisplayTotalEvaluatedAssessments() }}</span>
                  </div>
                </div>
                <div class="detailed">
                  <div class="row-item">
                    <span class="title-row">Published: </span>
                    <span class="count">{{ getDisplayAssessmentPublish() }}</span>
                  </div>
                </div>
              </div>
              <div class="detailed-item-divide">
                <div class="detailed-s">
                  <div class="row-item-s">
                    <span class="title-row">Planned for this month: </span>
                    <span class="count-s">{{ getDisplayCurrentMonthPlannedAssessments() }}</span>
                  </div>
                  <!--<div class="trend-indicator-box" 
                    *ngIf="getPlannedAssessmentsTrendDirection() !== 'neutral'">
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'down'" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M7 10l5 5 5-5z"/>
                    </svg>
                    <span class="trend-percentage">{{ getPlannedAssessmentsTrendPercentage() }}% executed vs last month</span>
                  </div>-->
                </div>
                <div class="detailed-s">
                  <div class="row-item-s">
                    <span class="title-row">Planned for next month: </span>
                    <span class="count-s">{{ getDisplayNextMonthPlannedAssessments() }}</span>
                  </div>
                </div>
                <div class="detailed-arrow">
                  <div class="trend-indicator-box" 
                    *ngIf="getPlannedAssessmentsTrendDirection() !== 'neutral'">
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'down'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                      <path d="M10.614013888888888 10.612652777777777c-0.48176944444444436 0 -0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221s0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221h4.354988888888888c0.48176944444444436 0 0.8709972222222221 -0.389225 0.8709972222222221 -0.8709972222222221V7.128661111111111c0 -0.48176944444444436 -0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222221s-0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221v2.250986111111111L9.48716111111111 4.771525c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0L5.388027777777777 7.63765 1.6481805555555553 3.900527777777778c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0s-0.34023333333333333 0.8927722222222222 0 1.2330055555555555l4.354988888888888 4.354988888888888c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l2.8688499999999997 -2.8688499999999997 3.9929777777777775 3.992980555555555h-2.250983333333333Z" fill="#ef4444" stroke-width="0.0278"></path>
                    </svg>
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'up'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                      <path d="M5.385986111111112 5.387347222222222c0.48176944444444436 0 0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221s-0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222222221H1.031998823c-0.48176944444444436 0 -0.8709972222222221 0.389225 -0.8709972222222221 0.8709972222222221v7.737679555555556c0 0.48176944444444436 0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221s0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221v-2.250986111111111l1.126688888888889 1.126688888888889c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l4.099 -4.099 3.739947222222223 3.739947222222223c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0s0.34023333333333333 -0.8927722222222222 0 -1.2330055555555555l-4.354988888888888 -4.354988888888888c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0l-2.8688499999999997 2.8688499999999997 -3.9929777777777775 -3.992980555555556h2.250983333333333Z" fill="#10b981" stroke-width="0.0278"></path>
                    </svg>
                    
                    <span class="trend-percentage">{{ getPlannedAssessmentsTrendPercentage() }}% executed vs last month</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Assessment Insights Filter Panel -->
          <div class="filter-panel-container" style="margin-right: 60px; margin-top: 0px;" [class.active]="showAssessmentInsightFilterPanel">
            <div class="filter-panel">
              <div class="filter-columns-container">
                <!-- Left Column - Filter Headers -->
                <div class="filter-headers-column">
                  <!-- Filter Header with Icon -->
                  <div class="filter-headers-header">
                    <mat-icon class="filter-icon">tune</mat-icon>
                    <span class="filter-title">Filter</span>
                  </div>
                  
                  <div class="filter-headers-list">
                    <div *ngFor="let header of assessmentInsightFilterHeaders; let i = index" 
                      class="filter-header-item" 
                      [class.active]="activeAssessmentInsightFilterHeader === header.key">
                      <label class="filter-header-checkbox-label" [for]="'assessment-insight-header-' + i">
                        <input type="checkbox" class="filter-checkbox-input" 
                          [id]="'assessment-insight-header-' + i"
                          [checked]="activeAssessmentInsightFilterHeader === header.key"
                          (click)="activeAssessmentInsightFilterHeader = header.key"
                          (change)="activeAssessmentInsightFilterHeader = header.key"
                          style="display: none;">
                        <span class="filter-checkmark"></span>
                        <span class="filter-header-name">{{ header.name }}</span>
                      </label>
                    </div>
                  </div>
                  
                  <!-- Clear Button -->
                  <button class="filter-clear-button" (click)="clearAssessmentInsightFilters()">
                    Clear
                  </button>
                </div>

                <!-- Right Column - Filter Content -->
                <div class="filter-content-column">
                  <!--<div class="filter-content-header">
                    <h4>{{ activeAssessmentInsightFilterHeader === 'language' ? 'Languages' : activeAssessmentInsightFilterHeader === 'courses' ? 'Courses' : 'Customer Names' }}</h4>
                    <div class="filter-actions">
                      <button class="filter-action-btn" (click)="clearAssessmentInsightFilters()">Clear</button>
                      <button class="filter-action-btn" (click)="showAssessmentInsightFilterPanel = false">Done</button>
                    </div>
                  </div>-->

                  <!-- Search Input -->
                  <div class="filter-search" *ngIf="activeAssessmentInsightFilterHeader === 'courses'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search courses" 
                        [(ngModel)]="assessmentInsightCourseSearchTerm"
                        (keyup)="filterAssessmentInsightCoursesFromApi()">
                    </div>


                  <!-- Search Input - Customer -->
                  <div class="filter-search" *ngIf="activeAssessmentInsightFilterHeader === 'customer'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search customer" 
                        [(ngModel)]="assessmentInsightCustomerSearchTerm"
                        (keyup)="filterAssessmentInsightCustomersFromApi()">
                    </div>


                  <!-- Filter Options - Courses -->
                  <div class="filter-options-container" style="margin-top: 5px;" *ngIf="activeAssessmentInsightFilterHeader === 'courses'">
                    
                    <div class="filter-options-list">
                      <label class="filter-option-item" *ngFor="let course of filteredAssessmentInsightCourseApiList" >
                        <input type="checkbox" class="filter-checkbox-input" 
                          [checked]="selectedAssessmentInsightCourseValues.includes(course.name)"
                          (change)="toggleAssessmentInsightFilter('course', course.name)">
                        <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                        <span class="filter-option-name">{{ course.name }}</span>
                      </label>
                    </div>
                  </div>


                  <!-- Filter Options - Customer -->
                  <div class="filter-options-container" *ngIf="activeAssessmentInsightFilterHeader === 'customer'">
                    <div class="filter-options-list">
                      <label class="filter-option-item" *ngFor="let customer of filteredAssessmentInsightCustomerApiList">
                        <input type="checkbox" class="filter-checkbox-input" 
                          [checked]="selectedAssessmentInsightCustomerValues.includes(customer.name)"
                          (change)="toggleAssessmentInsightFilter('customer', customer.name)">
                        <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                        <span class="filter-option-name">{{ customer.name }}</span>
                      </label>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          </div>

          

        </div>
      </div>
      <div class="summary-section" style="margin-top: 10px;">
        <div class="summary-header">
          <h2 class="summary-title">Analytics Snapshot</h2>
        </div>
      </div>
      <div class="section-content">
        <!-- Show message when no filter is applied -->
        <div *ngIf="!isFilterApplied()" class="no-filter-message">
          <p>Please select a date range to view data</p>
        </div>

        <!-- Charts for All View -->
        <div class="charts-grid" *ngIf="isFilterApplied()">

          <!--Questions by Course/Job Role Section -->
          <div class="chart-container" *ngIf="selectedViewType === 'library' || selectedViewType === 'all'">
          <div>
              <div class="chart-filters-row">
                <div class="month-year-filters">
                  <div class="filter-group">
                    <div class="year-dropdown">
                      <button class="dropdown-btny" style="width: 40px !important;"
                        (click)="toggleCourseYearDropdown()">
                        {{ selectedCourseYearRange }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showCourseYearDropdown">
                        <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                          [class.active]="selectedCourseYearRange === yearRange.value"
                          (click)="selectCourseYearRange(yearRange.value)">
                          {{ yearRange.display }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="filter-group">
                    <div class="month-dropdown">
                      <button class="dropdown-btny" style="width: 80px !important;"
                        (click)="toggleCourseMonthDropdown()">
                        {{ getMonthName(selectedCourseMonth) }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showCourseMonthDropdown">
                        <button *ngFor="let month of availableMonths" class="dropdown-item"
                          [class.active]="selectedCourseMonth === month.value" (click)="selectCourseMonth(month.value)">
                          {{ month.name }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="chart-actions-right">
                  <div class="filter-button-container">
                    <button class="filter-toggle-btn" (click)="toggleCourseFilterPanel($event)">
                      <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                      </svg>
                    </button>
                  </div>

                  <div class="chart-menu-container">
                    <button class="chart-menu-btn" (click)="toggleCourseChartMenu()">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <circle cx="12" cy="6" r="2"></circle>
                        <circle cx="12" cy="12" r="2"></circle>
                        <circle cx="12" cy="18" r="2"></circle>
                      </svg>
                    </button>

                    <div class="chart-menu-dropdown" [class.show]="showCourseChartMenu">
                      <button class="chart-menu-close-btn" (click)="showCourseChartMenu = false" style="color: black !important;">×</button>
                      <button class="chart-menu-item" (click)="showCourseTableModal()">
                        <span>Show as Table</span>
                      </button>

                      <button class="chart-menu-item" (click)="openCourseCompareDialog()">
                        <span>Compare</span>
                      </button>

                      <div class="menu-item-with-submenu" (mouseenter)="showCourseDownloadSubMenu = true"
                        (mouseleave)="showCourseDownloadSubMenu = false">
                        <button class="chart-menu-item submenu-trigger">
                          <span>Download</span>
                            <span class="submenu-arrow">›</span>
                        </button>

                        <div class="submenu" [class.show]="showCourseDownloadSubMenu">
                          <button class="chart-menu-close-btn" (click)="showCourseDownloadSubMenu = false" style="color: black !important;">×</button>
                          <button class="submenu-item" (click)="exportCourseChartAsPDF(); showCourseChartMenu=false;">
                            <span>Export as PDF</span>
                          </button>
                          <button class="submenu-item" (click)="exportCourseChartAsPNG(); showCourseChartMenu=false;">
                            <span>Export as PNG</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showCourseFilterPanel">
                <div class="filter-panel">
                  <div class="filter-columns-container">
                    <!-- Left Column - Filter Headers -->
                    <div class="filter-headers-column">
                      <!-- Filter Header with Icon -->
                      <div class="filter-headers-header">
                        <mat-icon class="filter-icon">tune</mat-icon>
                        <span class="filter-title">Filter</span>
                      </div>
                      
                      <div class="filter-headers-list">
                        <div *ngFor="let filter of courseFilterHeaders; let i = index" 
                          class="filter-header-item" 
                          [class.active]="activeCourseFilterHeader === filter.key">
                          <label class="filter-header-checkbox-label" [for]="'course-lib-header-' + i">
                            <input type="checkbox" class="filter-checkbox-input" 
                              [id]="'course-lib-header-' + i"
                              [checked]="activeCourseFilterHeader === filter.key"
                              (click)="activeCourseFilterHeader = filter.key"
                              (change)="activeCourseFilterHeader = filter.key"
                              style="display: none;">
                            <span class="filter-checkmark"></span>
                            <span class="filter-header-name">{{ filter.name }}</span>
                          </label>
                        </div>
                      </div>
                      
                      <!-- Clear Button -->
                      <button class="filter-clear-button" (click)="clearCourseFilters()">
                        Clear
                      </button>
                    </div>

                    <!-- Right Column - Filter Content -->
                    <div class="filter-content-column">
                      <div class="filter-search" *ngIf="activeCourseFilterHeader === 'courses'">
                        <input type="text" placeholder="Search courses..." class="filter-search-input"
                          [(ngModel)]="courseSearchTerm" (input)="filterCourseFilterCourses()">
                      </div>

                      <div class="filter-search" *ngIf="activeCourseFilterHeader === 'difficulty'">
                        <input type="text" placeholder="Search difficulty levels..." class="filter-search-input"
                          [(ngModel)]="courseDifficultySearchTerm" (input)="filterCourseDifficultyLevels()">
                      </div>

                      <div class="filter-search" *ngIf="activeCourseFilterHeader === 'types'">
                        <input type="text" placeholder="Search types..." class="filter-search-input"
                          [(ngModel)]="courseTypeSearchTerm" (input)="filterCourseTypes()">
                      </div>

                      <div class="filter-search" *ngIf="activeCourseFilterHeader === 'evaluationMode'">
                        <input type="text" placeholder="Search evaluation modes..." class="filter-search-input"
                          [(ngModel)]="courseEvaluationModeSearchTerm" (input)="filterCourseEvaluationModes()">
                      </div>

                      <div class="filter-search" *ngIf="activeCourseFilterHeader === 'language'">
                        <input type="text" placeholder="Search languages..." class="filter-search-input"
                          [(ngModel)]="courseLanguageSearchTerm" (input)="filterCourseLanguages()">
                      </div>

                      <div class="filter-options-container" style="margin-top: 5px;">
                        <div class="filter-options-list">
                          <div *ngIf="activeCourseFilterHeader === 'courses'" class="filter-options-group">
                            <div *ngFor="let course of filteredCourseFilterList" >
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="isCourseSelectedForCourseFilter(course.course_id)"
                                  (change)="toggleCourseSelectionForCourseFilter(course.course_id)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ course.course_name }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredCourseFilterList.length === 0 && courseSearchTerm"
                              class="no-results-message">
                              No Data Found
                            </div>
                          </div>

                          <!-- Course Chart - Difficulty Level Section -->
                          <div *ngIf="activeCourseFilterHeader === 'difficulty'" class="filter-options-group">
                            <div *ngFor="let level of filteredCourseDifficultyList" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="selectedCourseFilterDifficultyLevels.includes(level.value)"
                                  (change)="toggleCourseDifficultyFilter(level.value)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ level.label }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredCourseDifficultyList?.length === 0 && courseDifficultySearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>

                          <!-- Course Chart - Type Section -->
                          <div *ngIf="activeCourseFilterHeader === 'types'" class="filter-options-group">
                            <div *ngFor="let type of filteredCourseTypeList" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="selectedCourseFilterTypes.includes(type.value)"
                                  (change)="toggleCourseTypeFilter(type.value)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ type.label }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredCourseTypeList?.length === 0 && courseTypeSearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>

                          <!-- Course Chart - Evaluation Mode Section -->
                          <div *ngIf="activeCourseFilterHeader === 'evaluationMode'" class="filter-options-group">
                            <div *ngFor="let mode of filteredCourseEvaluationModeList" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="selectedCourseFilterEvaluationModes.includes(mode)"
                                  (change)="toggleCourseEvaluationModeFilter(mode)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ mode }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredCourseEvaluationModeList?.length === 0 && courseEvaluationModeSearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Course Table Modal -->
            <div *ngIf="showCourseTableModalFlag" class="table-modal-overlay" (click)="closeCourseTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Question Course Distribution</h3>
                  <button class="table-modal-close" (click)="closeCourseTableModal()">×</button>
                </div>

                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table course-modal-table">
                      <thead>
                        <tr>
                          <th>Course Name</th>
                          <th>Question Count</th>
                          <th>Percentage</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of courseBarChartData; let i = index" [class.zero-data]="item.value === 0">
                          <td>{{ item.name }}</td>
                          <td>{{ item.value }}</td>
                          <td>{{ getCoursePercentage(item) }}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportCourseTableAsPDF()">
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="showCourseCompareDialog" class="compare-dialog-overlay" (click)="closeCourseCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Course Distribution</h3>
                  <button class="compare-dialog-close" (click)="closeCourseCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <div class="compare-section">
                    <h4 class="compare-section-title">Select Financial Year</h4>
                    <div class="compare-year-range">
                      <div class="year-range-dropdown">
                        <button class="dropdown-btn" (click)="toggleCourseCompareYearDropdown()">
                          {{ selectedCourseCompareYearRange || 'Select Year Range' }}
                          <span class="dropdown-arrow">▼</span>
                        </button>
                        <div class="dropdown-menu" [class.show]="showCourseCompareYearDropdown">
                          <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                            [class.active]="selectedCourseCompareYearRange === yearRange.value"
                            (click)="selectCourseCompareYearRange(yearRange.value)">
                            {{ yearRange.display }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="compare-section">
                    <h4 class="compare-section-title">Select Month</h4>
                    <div class="compare-month-selection">
                      <div class="month-dropdown">
                        <button class="dropdown-btn" (click)="toggleCourseCompareMonthDropdown()">
                          {{ getMonthName(selectedCourseCompareMonth) || 'All Months' }}
                          <span class="dropdown-arrow">▼</span>
                        </button>
                        <div class="dropdown-menu" [class.show]="showCourseCompareMonthDropdown">
                          <button class="dropdown-item" [class.active]="selectedCourseCompareMonth === null"
                            (click)="selectCourseCompareMonth(null)">
                            All Months
                          </button>
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedCourseCompareMonth === month.value"
                            (click)="selectCourseCompareMonth(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="compare-results" *ngIf="showCourseComparisonResults">
                    <h4 class="results-title">Comparison Results</h4>

                    <div class="comparison-row">
                      <div class="comparison-item current">
                        <div class="comparison-header">
                          <span class="comparison-label">Current</span>
                          <span class="comparison-period">{{ selectedCourseYearRange }} • {{
                            getMonthName(selectedCourseMonth) }}</span>
                        </div>
                        <div class="comparison-stats">
                          <div class="stat-item" *ngFor="let item of currentCourseComparisonData">
                            <span class="stat-label">{{ item.name }}</span>
                            <span class="stat-value">{{ item.value }}</span>
                            <span class="stat-percentage">{{ item.percentage }}%</span>
                          </div>
                        </div>
                        <div class="total-questions">
                          Total: {{ getCurrentCourseTotalQuestions() }}
                        </div>
                      </div>

                      <div class="vs-separator">
                        <span>VS</span>
                      </div>

                      <div class="comparison-item compare">
                        <div class="comparison-header">
                          <span class="comparison-label">Compare</span>
                          <span class="comparison-period">{{ selectedCourseCompareYearRange }} • {{
                            getMonthName(selectedCourseCompareMonth) }}</span>
                        </div>
                        <div class="comparison-stats">
                          <div class="stat-item" *ngFor="let item of compareCourseComparisonData"
                            [class.positive]="item.trend === 'positive'" [class.negative]="item.trend === 'negative'"
                            [class.neutral]="item.trend === 'neutral'">
                            <span class="stat-label">{{ item.name }}</span>
                            <span class="stat-value">{{ item.value }}</span>
                            <span class="stat-percentage">{{ item.percentage }}%</span>
                            <span class="trend-indicator" *ngIf="item.trend !== 'neutral'">
                              {{ item.trend === 'positive' ? '↗' : '↘' }}
                            </span>
                          </div>
                        </div>
                        <div class="total-questions">
                          Total: {{ getCompareCourseTotalQuestions() }}
                        </div>
                      </div>
                    </div>

                    <div class="trend-summary" *ngIf="courseTrendSummary">
                      <h5>Summary</h5>
                      <div class="trend-item" *ngFor="let trend of courseTrendSummary">
                        <span class="trend-category">{{ trend.category }}</span>
                        <span class="trend-value" [class.positive]="trend.trend === 'positive'"
                          [class.negative]="trend.trend === 'negative'">
                          {{ trend.value }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="no-comparison-results"
                    *ngIf="showCourseComparisonResults && (!currentCourseComparisonData.length || !compareCourseComparisonData.length)">
                    <p>No data available for comparison with selected period.</p>
                  </div>
                </div>

                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeCourseCompareDialog()">
                    Cancel
                  </button>
                  <button class="compare-action-btn primary" (click)="loadCourseComparisonData()"
                    [disabled]="!selectedCourseCompareYearRange">
                    Compare
                  </button>
                </div>
              </div>
            </div>
            <div class="bar-chart-container" *ngIf="showCourseBarChart" style="margin-left: -20px;">
              <div class="chart-wrapper">
                <canvas id="courseBarChart"></canvas>
              </div>
              <div class="chart-legend">
                <div *ngFor="let item of courseBarChartData" class="legend-item" [class.zero-data]="item.value === 0">
                  <span class="legend-color" [style.background-color]="item.color"></span>
                  <span class="legend-label">{{ item.name }}</span>
                  <span class="legend-count" [class.zero-count]="item.value === 0">
                    {{ item.value }} ({{ getCoursePercentage(item) }}%)
                  </span>
                </div>
              </div>
            </div>

            <div *ngIf="!showCourseBarChart" class="no-data-message">
              <p>No question paper data available for the selected filters.</p>
            </div>

            <div class="chart-header-new" style="margin-top:35px;">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">Questions by Course/Job Role</span>
                </div>
              </div>
            </div>
          </div>
          <!-- Course Table Modal -->
          <div *ngIf="showCourseTableModalFlag" class="table-modal-overlay" (click)="closeCourseTableModal()">
            <div class="table-modal" (click)="$event.stopPropagation()">
              <div class="table-modal-header">
                <h3 class="table-modal-title">Questions by Course/Job Role - Detailed View</h3>
                <button class="table-modal-close" (click)="closeCourseTableModal()">×</button>
              </div>

              <div class="table-modal-content">
                <div class="modal-table-container">
                  <table class="modal-table">
                    <thead>
                      <tr>
                        <th>Course/Job Role</th>
                        <th>Question Count</th>
                        <th>Percentage</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of newCourseBarChartData" [class.zero-data]="item.value === 0">
                        <td>{{ item.name }}</td>
                        <td>{{ item.value }}</td>
                        <td>{{ getCoursePercentage(item) }}%</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="modal-table-actions">
                <button class="modal-export-btn secondary" (click)="exportCourseTableAsPDF()">
                  Export as PDF
                </button>
              </div>
            </div>
          </div>
          <!-- Questions by Course Table Modal -->
          <div *ngIf="showNewCourseTableModalFlag" class="table-modal-overlay" (click)="closeNewCourseTableModal()">
            <div class="table-modal" (click)="$event.stopPropagation()">
              <div class="table-modal-header">
                <h3 class="table-modal-title">Questions by Course/Job Role - Detailed Report</h3>
                <button class="table-modal-close" (click)="closeNewCourseTableModal()">×</button>
              </div>

              <div class="table-modal-content">
                <div class="modal-table-container">
                  <table class="modal-table">
                    <thead>
                      <tr>
                        <th>Course/Job Role</th>
                        <th>Question Count</th>
                        <th>Percentage</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of newCourseBarChartData">
                        <td>{{ item.originalName || item.name }}</td>
                        <td>{{ item.value }}</td>
                        <td>{{ getNewCoursePercentage(item) }}%</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="modal-table-actions">
                <button class="modal-export-btn secondary" (click)="exportNewCourseTableAsPDF()">Export as PDF</button>
                <button class="modal-export-btn secondary" (click)="exportNewCourseTableAsPNG()">Export as PNG</button>
                <button class="modal-export-btn" (click)="closeNewCourseTableModal()">Close</button>
              </div>
            </div>
          </div>

          <!-- Questions Compare Dialog -->
          <div *ngIf="showNewCourseCompareDialog" class="compare-dialog-overlay"
            (click)="closeNewCourseCompareDialog()">
            <div class="compare-dialog" (click)="$event.stopPropagation()">
              <div class="compare-dialog-header">
                <h3 class="compare-dialog-title">Compare Questions by Course</h3>
                <button class="compare-dialog-close" (click)="closeNewCourseCompareDialog()">×</button>
              </div>
              <div class="compare-dialog-content">
                <div class="compare-filters">
                  <div class="filter-group">
                    <label>Select Month 1:</label>
                    <div class="month-dropdown">
                      <button class="dropdown-btny" (click)="toggleNewCourseCompareMonth1Dropdown()">
                        {{ selectedNewCourseCompareMonth1 ? getMonthName(selectedNewCourseCompareMonth1) : 'Select Month' }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showNewCourseCompareMonth1Dropdown">
                        <button *ngFor="let month of availableMonths" class="dropdown-item"
                          [class.active]="selectedNewCourseCompareMonth1 === month.value"
                          (click)="selectNewCourseCompareMonth1(month.value)">
                          {{ month.name }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="filter-group">
                    <label>Select Month 2:</label>
                    <div class="month-dropdown">
                      <button class="dropdown-btny" (click)="toggleNewCourseCompareMonth2Dropdown()">
                        {{ selectedNewCourseCompareMonth2 ? getMonthName(selectedNewCourseCompareMonth2) : 'Select Month' }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showNewCourseCompareMonth2Dropdown">
                        <button *ngFor="let month of availableMonths" class="dropdown-item"
                          [class.active]="selectedNewCourseCompareMonth2 === month.value"
                          (click)="selectNewCourseCompareMonth2(month.value)">
                          {{ month.name }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <button class="btn-compare" (click)="loadNewCourseComparisonData()" [disabled]="!selectedNewCourseCompareMonth1 || !selectedNewCourseCompareMonth2">Compare</button>
                </div>

                <div *ngIf="showNewCourseComparisonResults" class="comparison-results">
                  <!-- Chart View Only -->
                  <div class="chart-container-comparison">
                    <canvas id="newCourseComparisonChart"></canvas>
                  </div>
                </div>
              </div>
            </div>

            <!-- No Data Message -->
            <div *ngIf="!showCourseBarChart" class="no-data-message">
              <p>No data available for the selected filters.</p>
            </div>
          </div>

          <div class="chart-container" *ngIf="selectedViewType === 'library' || selectedViewType === 'all'">
            <div>
              <div class="chart-filters-row">
                <div class="month-year-filters">
                  <div class="filter-group">
                    <div class="year-dropdown">
                      <button class="dropdown-btny" style="width: 40px !important;"
                        (click)="toggleQuestionPaperCourseYearDropdown()">
                        {{ selectedQuestionPaperCourseYearRange }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showQuestionPaperCourseYearDropdown">
                        <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                          [class.active]="selectedQuestionPaperCourseYearRange === yearRange.value"
                          (click)="selectQuestionPaperCourseYearRange(yearRange.value)">
                          {{ yearRange.display }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="filter-group">
                    <div class="month-dropdown">
                      <button class="dropdown-btny" style="width: 80px !important;"
                        (click)="toggleQuestionPaperCourseMonthDropdown()">
                        {{ getMonthName(selectedQuestionPaperCourseMonth) }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showQuestionPaperCourseMonthDropdown">
                        <button *ngFor="let month of availableMonths" class="dropdown-item"
                          [class.active]="selectedQuestionPaperCourseMonth === month.value"
                          (click)="selectQuestionPaperCourseMonth(month.value)">
                          {{ month.name }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="chart-actions-right">
                  <div class="filter-button-container">
                    <button class="filter-toggle-btn" (click)="toggleQuestionPaperCourseFilterPanel($event)">
                      <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                      </svg>
                    </button>
                  </div>

                  <div class="chart-menu-container">
                    <button class="chart-menu-btn" (click)="toggleQuestionPaperCourseChartMenu()">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <circle cx="12" cy="6" r="2"></circle>
                        <circle cx="12" cy="12" r="2"></circle>
                        <circle cx="12" cy="18" r="2"></circle>
                      </svg>
                    </button>

                    <div class="chart-menu-dropdown" [class.show]="showQuestionPaperCourseChartMenu">
                      <button class="chart-menu-close-btn" (click)="showQuestionPaperCourseChartMenu = false" style="color: black !important;">×</button>
                      <button class="chart-menu-item" (click)="showQuestionPaperCourseTableModal()">
                        <span>Show as Table</span>
                      </button>

                      <button class="chart-menu-item" (click)="openQuestionPaperCourseCompareDialog()">
                        <span>Compare</span>
                      </button>

                      <div class="menu-item-with-submenu" (mouseenter)="showQuestionPaperCourseDownloadSubMenu = true"
                        (mouseleave)="showQuestionPaperCourseDownloadSubMenu = false">
                        <button class="chart-menu-item submenu-trigger">
                          <span>Download</span>
                            <span class="submenu-arrow">›</span>
                        </button>

                        <div class="submenu" [class.show]="showQuestionPaperCourseDownloadSubMenu">
                          <button class="chart-menu-close-btn" (click)="showQuestionPaperCourseDownloadSubMenu = false">×</button>
                          <button class="submenu-item"
                            (click)="exportQuestionPaperByCourseChartAsPDF(); showQuestionPaperCourseChartMenu=false;">
                            <span>Export as PDF</span>
                          </button>
                          <button class="submenu-item"
                            (click)="exportQuestionPaperByCourseChartAsPNG(); showQuestionPaperCourseChartMenu=false;">
                            <span>Export as PNG</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showQuestionPaperCourseFilterPanel">
                <div class="filter-panel">
                  <div class="filter-columns-container">
                    <div class="filter-headers-column">
                      <div class="filter-headers-header">
                        <mat-icon class="filter-icon">tune</mat-icon>
                        <span class="filter-title">Filter</span>
                      </div>

                      <div class="filter-headers-list">
                        <div *ngFor="let filter of questionPaperCourseFilterHeaders; let i = index" class="filter-header-item"
                          [class.active]="activeQuestionPaperCourseFilterHeader === filter.key">
                          <label class="filter-header-checkbox-label" [for]="'question-paper-course-filter-header-' + i">
                            <input type="checkbox" class="filter-checkbox-input"
                              [id]="'question-paper-course-filter-header-' + i"
                              [checked]="activeQuestionPaperCourseFilterHeader === filter.key"
                              (click)="setActiveQuestionPaperCourseFilterHeader(filter.key)"
                              (change)="setActiveQuestionPaperCourseFilterHeader(filter.key)"
                              style="display: none;">
                            <span class="filter-checkmark"></span>
                            <span class="filter-header-name">{{ filter.name }}</span>
                          </label>
                        </div>
                      </div>

                      <button class="filter-clear-button" (click)="clearQuestionPaperCourseFilters()">
                        Clear
                      </button>
                    </div>

                    <div class="filter-content-column">
                      <div class="filter-search" *ngIf="activeQuestionPaperCourseFilterHeader === 'courses'">
                        <input type="text" class="filter-search-input" placeholder="Search courses..."
                          [(ngModel)]="questionPaperCourseSearchTerm" (input)="filterQuestionPaperCourses()">
                      </div>

                      <div class="filter-search" *ngIf="activeQuestionPaperCourseFilterHeader === 'customers'">
                        <input type="text" class="filter-search-input" placeholder="Search customers..."
                          [(ngModel)]="questionPaperCustomerSearchTerm" (input)="filterQuestionPaperCustomers()">
                      </div>

                      <div class="filter-search" *ngIf="activeQuestionPaperCourseFilterHeader === 'products'">
                        <input type="text" class="filter-search-input" placeholder="Search products..."
                          [(ngModel)]="questionPaperProductSearchTerm" (input)="filterQuestionPaperProducts()">
                      </div>

                      <div class="filter-options-container">
                        <div class="filter-options-list">
                          <div *ngIf="activeQuestionPaperCourseFilterHeader === 'courses'" class="filter-options-group">

                            <div *ngFor="let course of filteredQuestionPaperCourseList">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="isCourseSelectedForQuestionPaperFilter(course.course_id)"
                                  (change)="toggleCourseSelectionForQuestionPaperFilter(course.course_id)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ course.course_name }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredQuestionPaperCourseList.length === 0 && questionPaperCourseSearchTerm"
                              class="no-options">
                              No matching courses found.
                            </div>
                          </div>

                          <div *ngIf="activeQuestionPaperCourseFilterHeader === 'customers'" class="filter-options-group">
                            

                            <div *ngFor="let customer of filteredQuestionPaperCustomerList">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="isCustomerSelectedForQuestionPaperFilter(customer.id)"
                                  (change)="toggleCustomerSelectionForQuestionPaperFilter(customer.id)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ customer.name }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredQuestionPaperCustomerList.length === 0 && questionPaperCustomerSearchTerm"
                              class="no-options">
                              No matching customers found.
                            </div>
                          </div>

                          <div *ngIf="activeQuestionPaperCourseFilterHeader === 'products'" class="filter-options-group">
                            

                            <div *ngFor="let product of filteredQuestionPaperProductList" >
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="isProductSelectedForQuestionPaperFilter(product.id)"
                                  (change)="toggleProductSelectionForQuestionPaperFilter(product.id)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ product.name }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredQuestionPaperProductList.length === 0 && questionPaperProductSearchTerm"
                              class="no-options">
                              No matching products found.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Question Paper Table Modal -->
            <div *ngIf="showQuestionPaperCourseTableModalFlag" class="table-modal-overlay"
              (click)="closeQuestionPaperCourseTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Question Papers Distribution</h3>
                  <button class="table-modal-close" (click)="closeQuestionPaperCourseTableModal()">×</button>
                </div>

                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table questionpaper-course-modal-table">
                      <thead>
                        <tr>
                          <th>Course Name</th>
                          <th>Question Papers</th>
                          <th>Percentage</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of questionPaperByCourseChartData" [class.zero-data]="item.value === 0">
                          <td>{{ item.name }}</td>
                          <td>{{ item.value }}</td>
                          <td>{{ getQuestionPaperCoursePercentage(item) }}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportQuestionPaperByCourseTableAsPDF()">
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="showQuestionPaperCourseCompareDialog" class="compare-dialog-overlay"
              (click)="closeQuestionPaperCourseCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Question Papers by Course/Job Role</h3>
                  <button class="compare-dialog-close" (click)="closeQuestionPaperCourseCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <div class="compare-filters">
                    <div class="filter-group">
                      <label>Select Month 1:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleQuestionPaperCompareMonth1Dropdown()">
                          {{ selectedQuestionPaperCompareMonth1 ? getMonthName(selectedQuestionPaperCompareMonth1) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showQuestionPaperCompareMonth1Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedQuestionPaperCompareMonth1 === month.value"
                            (click)="selectQuestionPaperCompareMonth1(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="filter-group">
                      <label>Select Month 2:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleQuestionPaperCompareMonth2Dropdown()">
                          {{ selectedQuestionPaperCompareMonth2 ? getMonthName(selectedQuestionPaperCompareMonth2) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showQuestionPaperCompareMonth2Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedQuestionPaperCompareMonth2 === month.value"
                            (click)="selectQuestionPaperCompareMonth2(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <button class="btn-compare" (click)="loadQuestionPaperCourseComparisonData()" [disabled]="!selectedQuestionPaperCompareMonth1 || !selectedQuestionPaperCompareMonth2">Compare</button>
                  </div>

                  <div class="compare-results" *ngIf="showQuestionPaperCourseComparisonResults">
                    <h4 class="results-title">Comparison Results</h4>

                    <!-- Chart View Only -->
                    <div class="chart-container-comparison" style="position: relative; height: 400px; width: 100%; margin-bottom: 20px;">
                      <canvas id="questionPaperComparisonChart"></canvas>
                    </div>
                  </div>

                  <div class="no-comparison-results"
                    *ngIf="showQuestionPaperCourseComparisonResults && (!currentQuestionPaperCourseComparisonData.length || !compareQuestionPaperCourseComparisonData.length)">
                    <p>No data available for comparison with selected period.</p>
                  </div>
                </div>

                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeQuestionPaperCourseCompareDialog()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <div class="donut-chart-container" *ngIf="showQuestionPaperDonutChart">
              <div class="chart-wrapper">
                <canvas id="questionPaperByCourseDonutChart"></canvas>
              </div>
              <div class="chart-legend">
                <div *ngFor="let item of questionPaperDonutChartData" class="legend-item">
                  <span class="legend-color" [style.background-color]="item.color"></span>
                  <span class="legend-label">{{ item.name }}</span>
                  <span class="legend-count">{{ item.value }} ({{ getQuestionPaperCoursePercentage(item) }}%)</span>
                </div>
              </div>
            </div>

            <!-- No Data Message -->
            <div *ngIf="!showQuestionPaperDonutChart" class="no-data-message" style="margin-bottom: 30px;">
              <p>No question paper data available for the selected filters.</p>
            </div>

            <div class="chart-header-new" style="margin-top: 35px;">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">Question Papers by Course/Job Role</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Top 10 Courses/Job Roles Chart - For All View -->
          <div class="chart-container" *ngIf="selectedViewType === 'library' || selectedViewType === 'all'">
            <div>
              <div class="chart-filters-row">
                <div class="month-year-filters">
                  <div class="filter-group">
                    <div class="year-dropdown">
                      <button class="dropdown-btny" style="width: 40px !important;"
                        (click)="toggleTop10CourseYearDropdown()">
                        {{ selectedTop10CourseYearRange }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showTop10CourseYearDropdown">
                        <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                          [class.active]="selectedTop10CourseYearRange === yearRange.value"
                          (click)="selectTop10CourseYearRange(yearRange.value)">
                          {{ yearRange.display }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="filter-group">
                    <div class="month-dropdown">
                      <button class="dropdown-btny" style="width: 80px !important;"
                        (click)="toggleTop10CourseMonthDropdown()">
                        {{ getMonthName(selectedTop10CourseMonth) }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showTop10CourseMonthDropdown">
                        <button *ngFor="let month of availableMonths" class="dropdown-item"
                          [class.active]="selectedTop10CourseMonth === month.value"
                          (click)="selectTop10CourseMonth(month.value)">
                          {{ month.name }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="chart-actions-right">
                  <div class="filter-button-container">
                    <button class="filter-toggle-btn" (click)="toggleTop10CourseFilterPanel($event)">
                      <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                      </svg>
                      <span class="active-filter-indicator" *ngIf="selectedTop10CourseFilterValues.length > 0">
                        {{ selectedTop10CourseFilterValues.length }}
                      </span>
                    </button>
                  </div>

                  <div class="chart-menu-container">
                    <button class="chart-menu-btn" (click)="toggleTop10CourseChartMenu()">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <circle cx="12" cy="6" r="2"></circle>
                        <circle cx="12" cy="12" r="2"></circle>
                        <circle cx="12" cy="18" r="2"></circle>
                      </svg>
                    </button>

                    <div class="chart-menu-dropdown" [class.show]="showTop10CourseChartMenu">
                      <button class="chart-menu-item" (click)="showTop10CourseTableModal()">
                        <span>Show as Table</span>
                      </button>

                      <button class="chart-menu-item" (click)="openTop10CourseCompareDialog()">
                        <span>Compare</span>
                      </button>

                      <div class="menu-item-with-submenu" (mouseenter)="showTop10CourseDownloadSubMenu = true"
                        (mouseleave)="showTop10CourseDownloadSubMenu = false">
                        <button class="chart-menu-item submenu-trigger">
                          <span>Download</span>
                          <span class="submenu-arrow">›</span>
                        </button>

                        <div class="submenu" [class.show]="showTop10CourseDownloadSubMenu">
                          <button class="submenu-item"
                            (click)="exportTop10CourseChartAsPDF(); showTop10CourseChartMenu=false;">
                            <span>Export as PDF</span>
                          </button>
                          <button class="submenu-item"
                            (click)="exportTop10CourseChartAsPNG(); showTop10CourseChartMenu=false;">
                            <span>Export as PNG</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Top 10 Course Filter Panel -->
             <div class="top-filter-dropdown" style="margin-right: 110px;" [class.show]="showTop10CourseFilterPanel">

  <!-- Search -->
  <div class="top-filter-header">
    <input type="text" placeholder="Search Filter">
  </div>

  <!-- Options -->
  <div class="top-filter-body">

    <div class="top-filter-item">
      <label class="top-filter-label">
        <input
          type="radio"
          name="top10Metric"
          [checked]="selectedTop10Metric === 'questions'"
          (change)="selectTop10Metric('questions')">
        Questions
      </label>
    </div>

    <div class="top-filter-item">
      <label class="top-filter-label">
        <input
          type="radio"
          name="top10Metric"
          [checked]="selectedTop10Metric === 'questionPapers'"
          (change)="selectTop10Metric('questionPapers')">
        Question Papers
      </label>
    </div>

    <div class="top-filter-item">
      <label class="top-filter-label multi-line">
        <input
          type="radio"
          name="top10Metric"
          [checked]="selectedTop10Metric === 'assessments'"
          (change)="selectTop10Metric('assessments')">
        <span>
          Count of Assessments
          <small>(Most Assessments)</small>
        </span>
      </label>
    </div>

    <div class="top-filter-item">
      <label class="top-filter-label multi-line">
        <input
          type="radio"
          name="top10Metric"
          [checked]="selectedTop10Metric === 'least-assessments'"
          (change)="selectTop10Metric('least-assessments')">
        <span>
          Count of Assessments
          <small>(Least Assessments)</small>
        </span>
      </label>
    </div>

    <div class="top-filter-item">
      <label class="top-filter-label multi-line">
        <input
          type="radio"
          name="top10Metric"
          [checked]="selectedTop10Metric === 'language-breakdown'"
          (change)="selectTop10Metric('language-breakdown')">
        <span>
          Language by Regional Language
        </span>
      </label>
    </div>

    <!--<div class="top-filter-item">
      <label class="top-filter-label">
        <input type="checkbox" disabled>
        Average Pass %
      </label>
    </div>

    <div class="top-filter-item">
      <label class="top-filter-label">
        <input type="checkbox" disabled>
        Average Fail %
      </label>
    </div>-->

  </div>
</div>
            </div>

            <!-- Top 10 Course Table Modal -->
            <div *ngIf="showTop10CourseTableModalFlag" class="table-modal-overlay"
              (click)="closeTop10CourseTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Top 10 Courses/Job Roles</h3>
                  <button class="table-modal-close" (click)="closeTop10CourseTableModal()">×</button>
                </div>

                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table top10-course-modal-table">
                      <thead>
                        <tr>
                          <th (click)="sortTop10CourseTable('rank')" class="sortable">
                            Rank
                          </th>
                          <th (click)="sortTop10CourseTable('courseName')" class="sortable">
                            Course/Job Role
                          </th>
                          <th (click)="sortTop10CourseTable('questionCount')" class="sortable">
                            {{ selectedTop10Metric === 'language-breakdown' ? 'Total Questions' : 'Question Count' }}
                          </th>
                          <th *ngIf="selectedTop10Metric === 'language-breakdown'" class="sortable">
                            Primary Language
                          </th>
                          <th (click)="sortTop10CourseTable('percentage')" class="sortable">
                            Percentage
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of getTop10CourseTableData()" (click)="onTop10CourseTableRowClick(item)"
                          class="clickable-row">
                          <td class="rank-cell">
                            <span class="rank-badge" [style.background-color]="getRankColor(item.rank)">
                              {{ item.rank }}
                            </span>
                          </td>
                          <td class="course-name-cell">{{ item.courseName }}</td>
                          <td class="count-cell">{{ item.questionCount }}</td>
                          <td *ngIf="selectedTop10Metric === 'language-breakdown'" class="language-breakdown-cell"
                              [title]="item.languageBreakdown">
                            {{ item.dominantLanguage }}
                          </td>
                          <td class="percentage-cell">{{ item.percentage }}%</td>
                        </tr>
                      </tbody>
                      <tfoot *ngIf="getTop10CourseTableData().length > 0">
                        <tr class="table-total-row">
                          <td [attr.colspan]="selectedTop10Metric === 'language-breakdown' ? '3' : '2'"><strong>Total</strong></td>
                          <td><strong>{{ getTotalTop10CourseQuestions() }}</strong></td>
                          <td *ngIf="selectedTop10Metric === 'language-breakdown'"><strong>Primary Language</strong></td>
                          <td><strong>100%</strong></td>
                        </tr>
                      </tfoot>
                    </table>

                    <div *ngIf="getTop10CourseTableData().length === 0" class="empty-table-message">
                      <div class="empty-state">
                        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                          <polyline points="9 22 9 12 15 12 15 22"></polyline>
                        </svg>
                        <h4>No Data Available</h4>
                        <p>No course data found for the selected filters and date range.</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportTop10CourseTableAsPDF()">
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>

            <!-- Top 10 Course Compare Dialog -->
            <div *ngIf="showTop10CourseCompareDialog" class="compare-dialog-overlay" (click)="closeTop10CourseCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Top 10 Courses</h3>
                  <button class="compare-dialog-close" (click)="closeTop10CourseCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <div class="compare-filters">
                    <div class="filter-group">
                      <label>Select Month 1:</label>
                      <div class="month-dropdown">
                        <!-- सुधार: 0 (January) को Falsy होने से बचाने के लिए explicit null/undefined चेक जोड़ा गया है -->
                        <button class="dropdown-btny" (click)="toggleTop10CourseCompareMonth1Dropdown()">
                          {{ (selectedTop10CourseCompareMonth1 !== null && selectedTop10CourseCompareMonth1 !== undefined) ? getMonthName(selectedTop10CourseCompareMonth1) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showTop10CourseCompareMonth1Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedTop10CourseCompareMonth1 === month.value"
                            (click)="selectTop10CourseCompareMonth1(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="filter-group">
                      <label>Select Month 2:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleTop10CourseCompareMonth2Dropdown()">
                          {{ (selectedTop10CourseCompareMonth2 !== null && selectedTop10CourseCompareMonth2 !== undefined) ? getMonthName(selectedTop10CourseCompareMonth2) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showTop10CourseCompareMonth2Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedTop10CourseCompareMonth2 === month.value"
                            (click)="selectTop10CourseCompareMonth2(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <button class="btn-compare" (click)="loadTop10CourseComparisonDataMonthWise()" [disabled]="selectedTop10CourseCompareMonth1 === null || selectedTop10CourseCompareMonth1 === undefined || selectedTop10CourseCompareMonth2 === null || selectedTop10CourseCompareMonth2 === undefined">Compare</button>
                  </div>

                  <div class="compare-results" *ngIf="showTop10CourseComparisonResults">
                    <h4 class="results-title">Comparison Results</h4>

                    <!-- Chart View Only -->
                    <div class="chart-container-comparison" style="position: relative; height: 400px; width: 100%; margin-bottom: 20px;">
                      <canvas id="top10CourseComparisonChart"></canvas>
                    </div>
                  </div>

                  <div class="no-comparison-results"
                    *ngIf="showTop10CourseComparisonResults && (!currentTop10CourseComparisonData.length || !compareTop10CourseComparisonData.length)">
                    <p>No data available for comparison with selected period.</p>
                  </div>
                </div>

                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeTop10CourseCompareDialog()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <div class="bar-chart-container" [class.language-breakdown-chart]="selectedTop10Metric === 'language-breakdown'" *ngIf="showTop10CourseBarChart">
              <div class="chart-wrapper">
                <canvas id="top10CourseBarChart"></canvas>
              </div>
              <div class="chart-legend" *ngIf="selectedTop10Metric !== 'language-breakdown'">
                <div *ngFor="let item of top10CourseBarChartData" class="legend-item"
                  [class.zero-data]="item.value === 0">
                  <span class="legend-color" [style.background-color]="item.color"></span>
                  <span class="legend-label">#{{ item.rank }} - {{ item.name }}</span>
                  <span class="legend-count" [class.zero-count]="item.value === 0">
                    {{ item.value }} ({{ getTop10CoursePercentage(item) }}%)
                  </span>
                </div>
              </div>
            </div>

            <!-- No Data Message -->
            <div *ngIf="!showTop10CourseBarChart" class="no-data-message">
              <p>No question data available for the selected filters.</p>
            </div>

            <div class="chart-header-new" style="margin-top: 10px;">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">Top 10 Courses/Job Roles</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Questions by Type Chart - For All View -->
          <div class="chart-container" *ngIf="selectedViewType === 'library' || selectedViewType === 'all'">
            <div>
              <div class="chart-filters-row">

                <!-- Left: Month/Year Filters -->
                <div class="month-year-filters">
                  <div class="filter-group">
                    <div class="year-dropdown">
                      <button class="dropdown-btny" style="width: 40px !important;" (click)="toggleTypeYearDropdown()">
                        {{ selectedTypeYearRange }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showTypeYearDropdown">
                        <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                          [class.active]="selectedTypeYearRange === yearRange.value"
                          (click)="selectTypeYearRange(yearRange.value)">
                          {{ yearRange.display }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="filter-group">
                    <div class="month-dropdown">
                      <button class="dropdown-btny" style="width:80px !important;" (click)="toggleTypeMonthDropdown()">
                        {{ getMonthName(selectedTypeMonth) }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showTypeMonthDropdown">
                        <button *ngFor="let month of availableMonths" class="dropdown-item"
                          [class.active]="selectedTypeMonth === month.value" (click)="selectTypeMonth(month.value)">
                          {{ month.name }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="chart-actions-right">

                  <!-- Filter Button -->
                  <div class="filter-button-container">
                    <button class="filter-toggle-btn" (click)="toggleTypeFilterPanel($event)">
                      <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                      </svg>
                    </button>
                  </div>

                  <!-- Three Dot Menu -->
                  <div class="chart-menu-container">
                    <button class="chart-menu-btn" (click)="toggleTypeChartMenu()">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <circle cx="12" cy="6" r="2"></circle>
                        <circle cx="12" cy="12" r="2"></circle>
                        <circle cx="12" cy="18" r="2"></circle>
                      </svg>
                    </button>

                    <div class="chart-menu-dropdown" [class.show]="showTypeChartMenu">
                      <button class="chart-menu-close-btn" (click)="showTypeChartMenu = false">×</button>
                      <button class="chart-menu-item" (click)="showTypeTableModal()">
                        <span>Show as Table</span>
                      </button>

                      <button class="chart-menu-item" (click)="openTypeMonthCompareDialog()">
                        <span>Compare</span>
                      </button>

                      <div class="menu-item-with-submenu" (mouseenter)="showTypeDownloadSubMenu = true"
                        (mouseleave)="showTypeDownloadSubMenu = false">

                        <button class="chart-menu-item submenu-trigger">
                          <span>Download</span>
                            <span class="submenu-arrow">›</span>
                        </button>

                        <div class="submenu" [class.show]="showTypeDownloadSubMenu">
                          <button class="chart-menu-close-btn" (click)="showTypeDownloadSubMenu = false">×</button>
                          <button class="submenu-item" (click)="exportTypeChartAsPDF(); showTypeChartMenu=false;">
                            <span>Export as PDF</span>
                          </button>
                          <button class="submenu-item" (click)="exportTypeChartAsPNG(); showTypeChartMenu=false;">
                            <span>Export as PNG</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <!-- Type Filter Panel -->
              <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showTypeFilterPanel">
                <div class="filter-panel">
                  <div class="filter-columns-container">
                    <!-- Left Column - Filter Headers -->
                    <div class="filter-headers-column">
                      <!-- Filter Header with Icon -->
                      <div class="filter-headers-header">
                        <mat-icon class="filter-icon">tune</mat-icon>
                        <span class="filter-title">Filter</span>
                      </div>
                      
                      <div class="filter-headers-list">
                        <div *ngFor="let filter of typeFilterHeaders; let i = index" 
                          class="filter-header-item" 
                          [class.active]="activeTypeFilterHeader === filter.key">
                          <label class="filter-header-checkbox-label" [for]="'type-filter-header-' + i">
                            <input type="checkbox" class="filter-checkbox-input" 
                              [id]="'type-filter-header-' + i"
                              [checked]="activeTypeFilterHeader === filter.key"
                              (click)="setActiveTypeFilterHeader(filter.key)"
                              (change)="setActiveTypeFilterHeader(filter.key)"
                              style="display: none;">
                            <span class="filter-checkmark"></span>
                            <span class="filter-header-name">{{ filter.name }}</span>
                          </label>
                        </div>
                      </div>
                      
                      <!-- Clear Button -->
                      <button class="filter-clear-button" (click)="clearTypeFilters()">
                        Clear
                      </button>
                    </div>

                    <!-- Right Column - Filter Content -->
                    <div class="filter-content-column">
                      <!-- Search for Courses -->
                      <div class="filter-search" *ngIf="activeTypeFilterHeader === 'courses'">
                        <input type="text" placeholder="Search courses..." class="filter-search-input"
                          [(ngModel)]="typeCourseSearchTerm" (input)="filterTypeCourses()">
                      </div>

                      <!-- Search for Question Types -->
                      <div class="filter-search" *ngIf="activeTypeFilterHeader === 'questionTypes'">
                        <input type="text" placeholder="Search question types..." class="filter-search-input"
                          [(ngModel)]="questionTypeSearchTerm" (input)="filterQuestionTypes()">
                      </div>

                      <!-- Search for Language -->
                      <div class="filter-search" *ngIf="activeTypeFilterHeader === 'language'">
                        <input type="text" placeholder="Search language..." class="filter-search-input"
                          [(ngModel)]="typeLanguageSearchTerm" (input)="filterTypeLanguages()">
                      </div>

                      <!-- Search for Evaluation Mode -->
                      <div class="filter-search" *ngIf="activeTypeFilterHeader === 'evaluationMode'">
                        <input type="text" placeholder="Search evaluation mode..." class="filter-search-input"
                          [(ngModel)]="typeEvaluationModeSearchTerm" (input)="filterTypeEvaluationModes()">
                      </div>

                      <div class="filter-options-container" style="margin-top: 5px;">
                        <div class="filter-options-list">
                          <!-- Type Chart - Courses Section -->
                          <div *ngIf="activeTypeFilterHeader === 'courses'" class="filter-options-group">
                            <div *ngFor="let course of filteredTypeCourseList">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="isCourseSelectedForType(course.course_id)"
                                  (change)="toggleCourseSelectionForType(course.course_id)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ course.course_name }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredTypeCourseList?.length === 0 && typeCourseSearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>

                          <!-- Type Chart - Question Types Section -->
                          <div *ngIf="activeTypeFilterHeader === 'questionTypes'">
                            <div *ngFor="let type of filteredQuestionTypeList" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="isQuestionTypeSelectedForType(type.value)"
                                  (change)="toggleQuestionTypeSelectionForType(type.value)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ type.label }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredQuestionTypeList?.length === 0 && questionTypeSearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>

                          <!-- Type Chart - Language Section -->
                          <div *ngIf="activeTypeFilterHeader === 'language'">
                            <div *ngFor="let language of filteredTypeLanguagesList" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="selectedTypeLanguages.includes(language.name)"
                                  (change)="toggleTypeLanguageFilter(language.name)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ language.name }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredTypeLanguagesList?.length === 0 && typeLanguageSearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>

                          <!-- Type Chart - Evaluation Mode Section -->
                          <div *ngIf="activeTypeFilterHeader === 'evaluationMode'">
                            <div *ngFor="let mode of filteredTypeEvaluationModesList" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="selectedTypeEvaluationModes.includes(mode)"
                                  (change)="toggleTypeEvaluationModeFilter(mode)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ mode }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredTypeEvaluationModesList?.length === 0 && typeEvaluationModeSearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>

                          <!-- Type Chart - Difficulty Level Section -->
                          <div *ngIf="activeTypeFilterHeader === 'difficultyLevel'">
                            <div *ngFor="let level of filteredTypeDifficultyLevels" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="selectedTypeDifficultyLevels.includes(level.value)"
                                  (change)="toggleTypeDifficultyLevelFilter(level.value)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ level.label }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredTypeDifficultyLevels?.length === 0 && typeDifficultyLevelSearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Type Table Modal -->
            <div *ngIf="showTypeTableModalFlag" class="table-modal-overlay" (click)="closeTypeTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Question Type Breakdown</h3>
                  <button class="table-modal-close" (click)="closeTypeTableModal()">×</button>
                </div>

                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table type-modal-table">
                      <thead>
                        <tr>
                          <th>Course Name</th>
                          <th>Question Type</th>
                          <th>Question Count</th>
                          <th>Percentage</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of typeBarChartData; let i = index" [class.zero-data]="item.value === 0">
                          <td>{{ item.courseName || 'All Courses' }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.value }}</td>
                          <td>{{ getTypePercentage(item) }}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportTypeTableAsPDF()">
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
            <!-- Type Month Compare Dialog -->
            <div *ngIf="showTypeMonthCompareDialog" class="compare-dialog-overlay"
              (click)="closeTypeMonthCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Questions by Type</h3>
                  <button class="compare-dialog-close" (click)="closeTypeMonthCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <div class="compare-filters">
                    <div class="filter-group">
                      <label>Select Month 1:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleTypeCompareMonth1Dropdown()">
                          {{ selectedTypeCompareMonth1 ? getMonthName(selectedTypeCompareMonth1) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showTypeCompareMonth1Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedTypeCompareMonth1 === month.value"
                            (click)="selectTypeCompareMonth1(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="filter-group">
                      <label>Select Month 2:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleTypeCompareMonth2Dropdown()">
                          {{ selectedTypeCompareMonth2 ? getMonthName(selectedTypeCompareMonth2) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showTypeCompareMonth2Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedTypeCompareMonth2 === month.value"
                            (click)="selectTypeCompareMonth2(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <button class="btn-compare" (click)="loadTypeMonthComparisonData()" [disabled]="!selectedTypeCompareMonth1 || !selectedTypeCompareMonth2">Compare</button>
                  </div>

                  <div class="compare-results" *ngIf="showTypeMonthComparisonResults && (currentTypeMonthComparisonData.length > 0 || compareTypeMonthComparisonData.length > 0)">
                    <h4 class="results-title">Comparison Results</h4>

                    <!-- Chart View Only -->
                    <div class="chart-container-comparison" style="position: relative; height: 400px; width: 100%; margin-bottom: 20px;">
                      <canvas id="typeMonthComparisonChart"></canvas>
                    </div>
                  </div>

                  <div class="no-comparison-results"
                    *ngIf="showTypeMonthComparisonResults && currentTypeMonthComparisonData.length === 0 && compareTypeMonthComparisonData.length === 0">
                    <p>No data available for comparison with selected period.</p>
                  </div>
                </div>

                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeTypeMonthCompareDialog()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <!-- Type Bar Chart Container -->
            <div class="bar-chart-container type-bar-chart-container" *ngIf="showTypeBarChart">
              <div class="chart-wrapper">
                <canvas id="typeBarChart"></canvas>
              </div>
              <div class="chart-legend">
                <div *ngFor="let item of typeBarChartData" class="legend-item" [class.zero-data]="item.value === 0">
                  <span class="legend-color" [style.background-color]="item.color"></span>
                  <span class="legend-label">
                    <span class="course-name" *ngIf="!shouldShowOverallType()">{{ item.courseName }} - </span>
                    {{ item.name }}
                  </span>
                  <span class="legend-count" [class.zero-count]="item.value === 0">
                    {{ item.value }} ({{ getTypePercentage(item) }}%)
                  </span>
                </div>
              </div>
            </div>

            <div *ngIf="!showTypeBarChart" class="no-data-message" style="margin-bottom: 60px !important;">
              <p>No question paper data available for the selected filters.</p>
            </div>

            <div class="chart-header-new" style="margin-top: -30px !important;">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">Questions by Type</span>
                </div>
              </div>
            </div>

          </div>

          <!-- Assessments by Location Chart -->
          <div class="chart-container" *ngIf="selectedViewType === 'assessment'">
            <!-- TOP ROW: Month/Year + Filter + Three-dot -->
            <div class="chart-filters-row">
              <div class="month-year-filters">
                <div class="filter-group">
                  <div class="year-dropdown">
                    <button class="dropdown-btny" style="width: 80px !important;"
                      (click)="toggleAssessmentLocationYearDropdown()">
                      {{ selectedAssessmentLocationYearRange }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showAssessmentLocationYearDropdown">
                      <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                        [class.active]="selectedAssessmentLocationYearRange === yearRange.value"
                        (click)="selectAssessmentLocationYearRange(yearRange.value)">
                        {{ yearRange.display }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="filter-group">
                  <div class="month-dropdown">
                    <button class="dropdown-btny" style="width: 100px !important;"
                      (click)="toggleAssessmentLocationMonthDropdown()">
                      {{ getMonthName(selectedAssessmentLocationMonth) }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showAssessmentLocationMonthDropdown">
                      <button *ngFor="let month of availableMonths" class="dropdown-item"
                        [class.active]="selectedAssessmentLocationMonth === month.value"
                        (click)="selectAssessmentLocationMonth(month.value)">
                        {{ month.name }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="chart-actions-right">
                <div class="filter-button-container">
                  <button class="filter-toggle-btn" (click)="toggleAssessmentLocationFilterPanel($event)">
                    <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                    </svg>
                  </button>
                </div>

                <div class="chart-menu-container">
                  <button class="chart-menu-btn" (click)="toggleAssessmentLocationChartMenu()">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <circle cx="12" cy="6" r="2"></circle>
                      <circle cx="12" cy="12" r="2"></circle>
                      <circle cx="12" cy="18" r="2"></circle>
                    </svg>
                  </button>

                  <div class="chart-menu-dropdown" [class.show]="showAssessmentLocationChartMenu">
                    <button class="chart-menu-close-btn" (click)="showAssessmentLocationChartMenu = false">×</button>
                    <button class="chart-menu-item" (click)="openAssessmentLocationTableModal()">
                      <span>Show as Table</span>
                    </button>
                    <button class="chart-menu-item" (click)="openAssessmentLocationCompareDialog()">
                      <span>Compare</span>
                    </button>
                    <div class="menu-item-with-submenu" (mouseenter)="showAssessmentLocationDownloadSubMenu = true"
                      (mouseleave)="showAssessmentLocationDownloadSubMenu = false">
                      <button class="chart-menu-item submenu-trigger">
                        <span>Download</span>
                          <span class="submenu-arrow">›</span>
                      </button>
                      <div class="submenu" [class.show]="showAssessmentLocationDownloadSubMenu">
                        <button class="submenu-item"
                          (click)="exportAssessmentLocationAsPDF(); showAssessmentLocationChartMenu = false;">
                          <span>Export as PDF</span>
                        </button>
                        <button class="submenu-item"
                          (click)="exportAssessmentLocationAsPNG(); showAssessmentLocationChartMenu = false;">
                          <span>Export as PNG</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Filter Panel -->
            <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;"  [class.active]="showAssessmentLocationFilterPanel">
              <div class="filter-panel">
                <div class="filter-columns-container">
                  <div class="filter-headers-column">
                    <div class="filter-headers-list">
                      <div *ngFor="let filter of assessmentLocationFilterHeaders" class="filter-header-item"
                        [class.active]="activeAssessmentLocationFilterHeader === filter.key"
                        (click)="setActiveAssessmentLocationFilterHeader(filter.key)">
                        <span class="filter-header-name">{{ filter.name }}</span>
                        <span class="filter-header-count"
                          *ngIf="getAssessmentLocationFilterHeaderCount(filter.key) > 0">
                          {{ getAssessmentLocationFilterHeaderCount(filter.key) }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="filter-content-column">
                    <div class="filter-search" *ngIf="activeAssessmentLocationFilterHeader === 'locations'">
                      <input type="text" placeholder="Search locations..." class="filter-search-input"
                        [(ngModel)]="assessmentLocationSearchTerm" (input)="filterAssessmentLocations()">
                    </div>

                    <div class="filter-options-container">
                      <div class="filter-options-list">
                        <div *ngIf="activeAssessmentLocationFilterHeader === 'locations'" class="filter-options-group">
                          <div class="filter-option-item all-option">
                            <label class="filter-checkbox-label">
                              <input type="checkbox" class="filter-checkbox-input" [checked]="areAllLocationsSelected()"
                                (change)="toggleAllLocationsSelection()"
                                [indeterminate]="isLocationsSelectionIndeterminate()">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name all-option-name">All Locations</span>
                            </label>
                          </div>

                          <div *ngFor="let location of filteredAssessmentLocationList || allAssessmentLocations"
                            class="filter-option-item">
                            <label class="filter-checkbox-label">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="isLocationSelected(location.id)"
                                (change)="toggleLocationSelection(location.id)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ location.state || 'Unknown' }}</span>
                              <span class="filter-option-count">{{ location.count }}</span>
                            </label>
                          </div>

                          <div
                            *ngIf="(filteredAssessmentLocationList?.length === 0 || (filteredAssessmentLocationList?.length === undefined && assessmentLocationSearchTerm))"
                            class="no-results-message">
                            No Data Found
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- CHART AREA -->
            <div class="doughnut-chart-container" style="overflow: hidden !important;"
              *ngIf="showAssessmentLocationChart && assessmentLocationChartData.length > 0">
              <div class="chart-wrapper">
                <canvas id="assessmentLocationChart"></canvas>
              </div>
              <div class="chart-legend">
                <div *ngFor="let item of assessmentLocationChartData" class="legend-item">
                  <span class="legend-color" [style.background-color]="item.color"></span>
                  <span class="legend-label">{{ item.name }}</span>
                  <span class="legend-count">
                    {{ item.value }} ({{ getAssessmentLocationPercentage(item) }}%)
                  </span>
                </div>
              </div>
            </div>

            <!-- NO DATA MESSAGE -->
            <div *ngIf="!showAssessmentLocationChart || assessmentLocationChartData.length === 0"
              class="no-data-message">
              <p>No assessment location data available for the selected filters.</p>
            </div>

            <!-- TITLE AT BOTTOM -->
            <div class="chart-header-new" style="margin-top: 10px;">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">Assessments by Location</span>
                </div>
              </div>
            </div>

            <!-- Compare Dialog -->
            <div *ngIf="showAssessmentLocationCompareDialog" class="compare-dialog-overlay"
              (click)="closeAssessmentLocationCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Assessments by Location</h3>
                  <button class="compare-dialog-close" (click)="closeAssessmentLocationCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <div class="compare-filters">
                    <div class="filter-group">
                      <label>Select Month 1:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleAssessmentLocationCompareMonth1Dropdown()">
                          {{ selectedAssessmentLocationCompareMonth1 ? getMonthName(selectedAssessmentLocationCompareMonth1) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showAssessmentLocationCompareMonth1Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedAssessmentLocationCompareMonth1 === month.value"
                            (click)="selectAssessmentLocationCompareMonth1(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="filter-group">
                      <label>Select Month 2:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleAssessmentLocationCompareMonth2Dropdown()">
                          {{ selectedAssessmentLocationCompareMonth2 ? getMonthName(selectedAssessmentLocationCompareMonth2) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showAssessmentLocationCompareMonth2Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedAssessmentLocationCompareMonth2 === month.value"
                            (click)="selectAssessmentLocationCompareMonth2(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <button class="btn-compare" (click)="loadAssessmentLocationComparisonData()" [disabled]="!selectedAssessmentLocationCompareMonth1 || !selectedAssessmentLocationCompareMonth2">Compare</button>
                  </div>

                  <div class="compare-results" *ngIf="showAssessmentLocationComparisonResults">
                    <h4 class="results-title">Comparison Results</h4>

                    <!-- Chart View Only -->
                    <div class="chart-container-comparison" style="position: relative; height: 400px; width: 100%; margin-bottom: 20px;">
                      <canvas id="assessmentLocationComparisonChart"></canvas>
                    </div>
                  </div>

                  <div class="no-comparison-results"
                    *ngIf="showAssessmentLocationComparisonResults && (!currentAssessmentLocationComparisonData.length || !compareAssessmentLocationComparisonData.length)">
                    <p>No data available for comparison with selected period.</p>
                  </div>
                </div>

                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeAssessmentLocationCompareDialog()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <!-- Table Modal -->
            <div *ngIf="showAssessmentLocationTableModal" class="table-modal-overlay"
              (click)="closeAssessmentLocationTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Assessments by Location - Detailed Report</h3>
                  <button class="table-modal-close" (click)="closeAssessmentLocationTableModal()">×</button>
                </div>

                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table">
                      <thead>
                        <tr>
                          <th>Location</th>
                          <th>Count</th>
                          <th>Percentage</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of assessmentLocationChartData">
                          <td>{{ item.name }}</td>
                          <td>{{ item.value }}</td>
                          <td>{{ getAssessmentLocationPercentage(item) }}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportAssessmentLocationTableAsPDF()">
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- abAssessments by Course/Job Role Chart - For All View -->
          <div class="chart-container" *ngIf="selectedViewType === 'assessment' || selectedViewType === 'all'">
            <!-- TOP ROW: Month/Year + Filter + Three-dot -->
            <div class="chart-filters-row">
              <div class="month-year-filters">
                <div class="filter-group">
                  <div class="year-dropdown">
                    <button class="dropdown-btny" style="width: 80px !important;"
                      (click)="toggleAssessmentCourseYearDropdown()">
                      {{ selectedAssessmentCourseYearRange }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showAssessmentCourseYearDropdown">
                      <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                        [class.active]="selectedAssessmentCourseYearRange === yearRange.value"
                        (click)="selectAssessmentCourseYearRange(yearRange.value)">
                        {{ yearRange.display }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="filter-group">
                  <div class="month-dropdown">
                    <button class="dropdown-btny" style="width: 100px !important;"
                      (click)="toggleAssessmentCourseMonthDropdown()">
                      {{ getMonthName(selectedAssessmentCourseMonth) }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showAssessmentCourseMonthDropdown">
                      <button *ngFor="let month of availableMonths" class="dropdown-item"
                        [class.active]="selectedAssessmentCourseMonth === month.value"
                        (click)="selectAssessmentCourseMonth(month.value)">
                        {{ month.name }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="chart-actions-right">
                <div class="filter-button-container ">
                  <button class="filter-toggle-btn" 
                    (click)="toggleAssessmentCourseFilterPanel($event)">
                    <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                    </svg>
                  </button>
                </div>

                <div class="chart-menu-container chart-menu-button">
                  <button class="chart-menu-btn" (click)="toggleAssessmentCourseChartMenu()">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <circle cx="12" cy="6" r="2"></circle>
                      <circle cx="12" cy="12" r="2"></circle>
                      <circle cx="12" cy="18" r="2"></circle>
                    </svg>
                  </button>

                  <div class="chart-menu-dropdown" [class.show]="showAssessmentCourseChartMenu">
                    <button class="chart-menu-close-btn" (click)="showAssessmentCourseChartMenu = false">×</button>
                    <button class="chart-menu-item" (click)="openAssessmentCourseTableModal()">
                      <span>Show as Table</span>
                    </button>
                    <button class="chart-menu-item" (click)="openAssessmentCourseCompareDialog()">
                      <span>Compare</span>
                    </button>
                    <div class="menu-item-with-submenu" (mouseenter)="showAssessmentCourseDownloadSubMenu = true"
                      (mouseleave)="showAssessmentCourseDownloadSubMenu = false">
                      <button class="chart-menu-item submenu-trigger">
                        <span>Download</span>
                          <span class="submenu-arrow">›</span>
                      </button>
                      <div class="submenu" [class.show]="showAssessmentCourseDownloadSubMenu">
                        <button class="chart-menu-close-btn" (click)="showAssessmentCourseDownloadSubMenu = false">×</button>
                        <button class="submenu-item"
                          (click)="exportAssessmentCourseAsPDF(); showAssessmentCourseChartMenu = false;">
                          <span>Export as PDF</span>
                        </button>
                        <button class="submenu-item"
                          (click)="exportAssessmentCourseAsPNG(); showAssessmentCourseChartMenu = false;">
                          <span>Export as PNG</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Filter Panel -->
            <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showAssessmentCourseFilterPanel">
              <div class="filter-panel">
                <div class="filter-columns-container">
                  <!-- Left Column - Filter Headers -->
                  <div class="filter-headers-column">
                    <!-- Filter Header with Icon -->
                    <div class="filter-headers-header">
                      <mat-icon class="filter-icon">tune</mat-icon>
                      <span class="filter-title">Filter</span>
                    </div>
                    
                    <div class="filter-headers-list">
                      <div *ngFor="let header of assessmentCourseFilterHeaders; let i = index" 
                        class="filter-header-item" 
                        [class.active]="activeAssessmentCourseFilterHeader === header.key">
                        <label class="filter-header-checkbox-label" [for]="'assessment-course-header-' + i">
                          <input type="checkbox" class="filter-checkbox-input" 
                            [id]="'assessment-course-header-' + i"
                            [checked]="activeAssessmentCourseFilterHeader === header.key"
                            (click)="activeAssessmentCourseFilterHeader = header.key"
                            (change)="activeAssessmentCourseFilterHeader = header.key"
                            style="display: none;">
                          <span class="filter-checkmark"></span>
                          <span class="filter-header-name">{{ header.name }}</span>
                        </label>
                      </div>
                    </div>
                    
                    <!-- Clear Button -->
                    <button class="filter-clear-button" (click)="clearAssessmentCourseFilters()">
                      Clear
                    </button>
                  </div>

                  <!-- Right Column - Filter Content -->
                  <div class="filter-content-column">
                    <div class="filter-search" *ngIf="activeAssessmentCourseFilterHeader === 'geography'">
                      <input type="text" placeholder="Search states..." class="filter-search-input"
                        [(ngModel)]="assessmentCourseGeographySearchTerm" (input)="filterAssessmentCourseGeographies()">
                    </div>
                    <div class="filter-search" *ngIf="activeAssessmentCourseFilterHeader === 'customer'">
                      <input type="text" placeholder="Search customers..." class="filter-search-input"
                        [(ngModel)]="assessmentCourseCustomerSearchTerm" (input)="filterAssessmentCourseCustomers()">
                    </div>
                    <div class="filter-search" *ngIf="activeAssessmentCourseFilterHeader === 'language'">
                      <input type="text" placeholder="Search languages..." class="filter-search-input"
                        [(ngModel)]="assessmentCourseLanguageSearchTerm" (input)="filterAssessmentCourseLanguages()">
                    </div>

                    <div class="filter-options-container" style="margin-top: 5px;">
                      <div class="filter-options-list">
                        <div *ngIf="activeAssessmentCourseFilterHeader === 'geography'">
                          <div *ngFor="let state of filteredAssessmentCourseGeographyList?.length ? filteredAssessmentCourseGeographyList : allGeographicInsightGeographies"
                           >
                            <label class="filter-option-item">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="selectedAssessmentCourseGeographyValues.includes(state.state)"
                                (change)="toggleAssessmentCourseFilter('geography', state.state)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ state.state }}</span>
                            </label>
                          </div>

                          <div *ngIf="(filteredAssessmentCourseGeographyList?.length === 0 && assessmentCourseGeographySearchTerm) || (!filteredAssessmentCourseGeographyList?.length && !(allGeographicInsightGeographies?.length))"
                            class="no-results-message">
                            No Data Found
                          </div>
                        </div>

                        <div *ngIf="activeAssessmentCourseFilterHeader === 'customer'" class="filter-options-group">
                          <div *ngFor="let customer of filteredAssessmentCourseCustomerList?.length ? filteredAssessmentCourseCustomerList : customerMasterData"
                            >
                            <label class="filter-option-item">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="selectedAssessmentCourseCustomerValues.includes(customer.name)"
                                (change)="toggleAssessmentCourseFilter('customer', customer.name)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ customer.name }}</span>
                            </label>
                          </div>

                          <div *ngIf="(filteredAssessmentCourseCustomerList?.length === 0 && assessmentCourseCustomerSearchTerm) || (!filteredAssessmentCourseCustomerList?.length && !(customerMasterData?.length))"
                            class="no-results-message">
                            No Data Found
                          </div>
                        </div>

                        <div *ngIf="activeAssessmentCourseFilterHeader === 'language'" class="filter-options-group">
                          <div *ngFor="let language of filteredAssessmentCourseLanguageList?.length ? filteredAssessmentCourseLanguageList : languagesData"
                            >
                            <label class="filter-option-item">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="selectedAssessmentCourseLanguageValues.includes(language.name)"
                                (change)="toggleAssessmentCourseFilter('language', language.name)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ language.name }}</span>
                            </label>
                          </div>

                          <div *ngIf="(filteredAssessmentCourseLanguageList?.length === 0 && assessmentCourseLanguageSearchTerm) || (!filteredAssessmentCourseLanguageList?.length && !(languagesData?.length))"
                            class="no-results-message">
                            No Data Found
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- BAR CHART AREA -->
            <div class="bar-chart-container" *ngIf="showAssessmentCourseChart && assessmentCourseChartData.length > 0">
              <div class="chart-wrapper">
                <canvas id="assessmentCourseChart"></canvas>
              </div>
              <div class="chart-legend">
                <div *ngFor="let item of assessmentCourseChartData" class="legend-item">
                  <span class="legend-color" [style.background-color]="item.color"></span>
                  <span class="legend-label">{{ item.name }}</span>
                  <span class="legend-count">{{ item.value }} ({{ getAssessmentCoursePercentage(item) }}%)</span>
                </div>
              </div>
            </div>

            <!-- NO DATA MESSAGE -->
            <div *ngIf="!showAssessmentCourseChart || assessmentCourseChartData.length === 0" class="no-data-message">
              <p>No assessment course data available for the selected filters.</p>
            </div>

            <!-- TITLE AT BOTTOM -->
            <div class="chart-header-new" style="margin-top: 10px;">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">Assessments by Course/Job Role</span>
                </div>
              </div>
            </div>

            <!-- Compare Dialog -->
            <div *ngIf="showAssessmentCourseCompareDialog" class="compare-dialog-overlay"
              (click)="closeAssessmentCourseCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Assessments by Course</h3>
                  <button class="compare-dialog-close" (click)="closeAssessmentCourseCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <div class="compare-filters">
                    <div class="filter-group">
                      <label>Select Month 1:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleAssessmentCourseCompareMonth1Dropdown()">
                          {{ selectedAssessmentCourseCompareMonth1 ? getMonthName(selectedAssessmentCourseCompareMonth1) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showAssessmentCourseCompareMonth1Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedAssessmentCourseCompareMonth1 === month.value"
                            (click)="selectAssessmentCourseCompareMonth1(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="filter-group">
                      <label>Select Month 2:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleAssessmentCourseCompareMonth2Dropdown()">
                          {{ selectedAssessmentCourseCompareMonth2 ? getMonthName(selectedAssessmentCourseCompareMonth2) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showAssessmentCourseCompareMonth2Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedAssessmentCourseCompareMonth2 === month.value"
                            (click)="selectAssessmentCourseCompareMonth2(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <button class="btn-compare" (click)="loadAssessmentCourseComparisonData()" [disabled]="!selectedAssessmentCourseCompareMonth1 || !selectedAssessmentCourseCompareMonth2">Compare</button>
                  </div>

                  <div class="compare-results" *ngIf="showAssessmentCourseComparisonResults">
                    <h4 class="results-title">Comparison Results</h4>

                    <!-- Chart View Only -->
                    <div class="chart-container-comparison">
                      <canvas id="assessmentCourseComparisonChart"></canvas>
                    </div>
                  </div>

                  <div class="no-comparison-results"
                    *ngIf="showAssessmentCourseComparisonResults && (!currentAssessmentCourseComparisonData.length || !compareAssessmentCourseComparisonData.length)">
                    <p>No data available for comparison with selected period.</p>
                  </div>
                </div>

                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeAssessmentCourseCompareDialog()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <!-- Table Modal -->
            <div *ngIf="showAssessmentCourseTableModal" class="table-modal-overlay"
              (click)="closeAssessmentCourseTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Assessments by Course - Detailed Report</h3>
                  <button class="table-modal-close" (click)="closeAssessmentCourseTableModal()">×</button>
                </div>
                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table">
                      <thead>
                        <tr>
                          <th>Course</th>
                          <th>Count</th>
                          <th>Percentage</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of assessmentCourseChartData">
                          <td>{{ item.name }}</td>
                          <td>{{ item.value }}</td>
                          <td>{{ getAssessmentCoursePercentage(item) }}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportAssessmentCourseTableAsPDF()">Export as
                    PDF</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Candidates by Assessment Chart -->
          <div class="chart-container" *ngIf="selectedViewType === 'assessment'">
            <!-- TOP ROW: Month/Year + Filter + Three-dot -->
            <div class="chart-filters-row">
              <div class="month-year-filters">
                <div class="filter-group">
                  <div class="year-dropdown">
                    <button class="dropdown-btny" style="width: 80px !important;"
                      (click)="toggleCandidateAssessmentYearDropdown()">
                      {{ selectedCandidateAssessmentYearRange }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showCandidateAssessmentYearDropdown">
                      <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                        [class.active]="selectedCandidateAssessmentYearRange === yearRange.value"
                        (click)="selectCandidateAssessmentYearRange(yearRange.value)">
                        {{ yearRange.display }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="filter-group">
                  <div class="month-dropdown">
                    <button class="dropdown-btny" style="width: 100px !important;"
                      (click)="toggleCandidateAssessmentMonthDropdown()">
                      {{ getMonthName(selectedCandidateAssessmentMonth) }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showCandidateAssessmentMonthDropdown">
                      <button *ngFor="let month of availableMonths" class="dropdown-item"
                        [class.active]="selectedCandidateAssessmentMonth === month.value"
                        (click)="selectCandidateAssessmentMonth(month.value)">
                        {{ month.name }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="chart-actions-right">
                <div class="filter-button-container">
                  <button class="filter-toggle-btn" (click)="toggleCandidateAssessmentFilterPanel($event)">
                    <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                    </svg>
                  </button>
                </div>

                <div class="chart-menu-container">
                  <button class="chart-menu-btn" (click)="toggleCandidateAssessmentChartMenu()">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <circle cx="12" cy="6" r="2"></circle>
                      <circle cx="12" cy="12" r="2"></circle>
                      <circle cx="12" cy="18" r="2"></circle>
                    </svg>
                  </button>

                  <div class="chart-menu-dropdown" [class.show]="showCandidateAssessmentChartMenu">
                    <button class="chart-menu-close-btn" (click)="showCandidateAssessmentChartMenu = false" style="color: black !important;">×</button>
                    <button class="chart-menu-item" (click)="openCandidateAssessmentTableModal()">
                      <span>Show as Table</span>
                    </button>
                    <button class="chart-menu-item" (click)="openCandidateAssessmentCompareDialog()">
                      <span>Compare</span>
                    </button>
                    <div class="menu-item-with-submenu" (mouseenter)="showCandidateAssessmentDownloadSubMenu = true"
                      (mouseleave)="showCandidateAssessmentDownloadSubMenu = false">
                      <button class="chart-menu-item submenu-trigger">
                        <span>Download</span>
                          <span class="submenu-arrow">›</span>
                      </button>
                      <div class="submenu" [class.show]="showCandidateAssessmentDownloadSubMenu">
                        <button class="chart-menu-close-btn" (click)="showCandidateAssessmentDownloadSubMenu = false" style="color: black !important;">×</button>
                        <button class="submenu-item"
                          (click)="exportCandidateAssessmentAsPDF(); showCandidateAssessmentChartMenu = false;">
                          <span>Export as PDF</span>
                        </button>
                        <button class="submenu-item"
                          (click)="exportCandidateAssessmentAsPNG(); showCandidateAssessmentChartMenu = false;">
                          <span>Export as PNG</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Filter Panel -->
            <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showCandidateAssessmentFilterPanel">
              <div class="filter-panel">
                <div class="filter-columns-container">
                  <div class="filter-headers-column">
                    <div class="filter-headers-list">
                      <div *ngFor="let filter of candidateAssessmentFilterHeaders" class="filter-header-item"
                        [class.active]="activeCandidateAssessmentFilterHeader === filter.key"
                        (click)="setActiveCandidateAssessmentFilterHeader(filter.key)">
                        <span class="filter-header-name">{{ filter.name }}</span>
                        <span class="filter-header-count"
                          *ngIf="getCandidateAssessmentFilterHeaderCount(filter.key) > 0">
                          {{ getCandidateAssessmentFilterHeaderCount(filter.key) }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="filter-content-column">
                    <div class="filter-search" *ngIf="activeCandidateAssessmentFilterHeader === 'assessment'">
                      <input type="text" placeholder="Search assessments..." class="filter-search-input"
                        [(ngModel)]="candidateAssessmentSearchTerm" (input)="filterCandidateAssessment()">
                    </div>

                    <div class="filter-options-container">
                      <div class="filter-options-list">
                        <div *ngIf="activeCandidateAssessmentFilterHeader === 'assessment'"
                          class="filter-options-group">
                          <div class="filter-option-item all-option">
                            <label class="filter-checkbox-label">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="areAllAssessmentsSelectedForCandidate()"
                                (change)="toggleAllAssessmentsSelectionForCandidate()"
                                [indeterminate]="isAssessmentsSelectionIndeterminateForCandidate()">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name all-option-name">All Assessments</span>
                            </label>
                          </div>

                          <div *ngFor="let assessment of filteredCandidateAssessmentList || allCandidateAssessments"
                            class="filter-option-item">
                            <label class="filter-checkbox-label">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="isAssessmentSelectedForCandidate(assessment.assessment_id || assessment.id)"
                                (change)="toggleAssessmentSelectionForCandidate(assessment.assessment_id || assessment.id)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ assessment.assessment_title || assessment.assessment_name || assessment.name }}</span>
                              <span class="filter-option-count">{{ assessment.value }}</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- CHART AREA -->
            <div class="doughnut-chart-container" style="overflow: hidden !important;"
              *ngIf="showCandidateAssessmentChart && candidateAssessmentChartData.length > 0">
              <div class="chart-wrapper">
                <canvas id="candidateAssessmentChart"></canvas>
              </div>
              <div class="chart-legend">
                <div *ngFor="let item of candidateAssessmentChartData" class="legend-item">
                  <span class="legend-color" [style.background-color]="item.color"></span>
                  <span class="legend-label">{{ item.name }}</span>
                  <span class="legend-count">
                    {{ item.value }} ({{ getCandidateAssessmentPercentage(item) }}%)
                  </span>
                </div>
              </div>
            </div>

            <!-- NO DATA MESSAGE -->
            <div *ngIf="!showCandidateAssessmentChart || candidateAssessmentChartData.length === 0"
              class="no-data-message">
              <p>No candidate assessment data available for the selected filters.</p>
            </div>

            <!-- TITLE AT BOTTOM -->
            <div class="chart-header-new" style="margin-top: 10px;">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">Candidates by Assessment</span>
                </div>
              </div>
            </div>

            <!-- Compare Dialog -->
            <div *ngIf="showCandidateAssessmentCompareDialog" class="compare-dialog-overlay"
              (click)="closeCandidateAssessmentCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Candidates by Assessment</h3>
                  <button class="compare-dialog-close" (click)="closeCandidateAssessmentCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <div class="compare-filters">
                    <div class="filter-group">
                      <label>Select Month 1:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleCandidateAssessmentCompareMonth1Dropdown()">
                          {{ selectedCandidateAssessmentCompareMonth1 ? getMonthName(selectedCandidateAssessmentCompareMonth1) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showCandidateAssessmentCompareMonth1Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedCandidateAssessmentCompareMonth1 === month.value"
                            (click)="selectCandidateAssessmentCompareMonth1(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="filter-group">
                      <label>Select Month 2:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleCandidateAssessmentCompareMonth2Dropdown()">
                          {{ selectedCandidateAssessmentCompareMonth2 ? getMonthName(selectedCandidateAssessmentCompareMonth2) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showCandidateAssessmentCompareMonth2Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedCandidateAssessmentCompareMonth2 === month.value"
                            (click)="selectCandidateAssessmentCompareMonth2(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <button class="btn-compare" (click)="loadCandidateAssessmentComparisonData()" [disabled]="!selectedCandidateAssessmentCompareMonth1 || !selectedCandidateAssessmentCompareMonth2">Compare</button>
                  </div>

                  <div class="compare-results" *ngIf="showCandidateAssessmentComparisonResults">
                    <h4 class="results-title">Comparison Results</h4>

                    <!-- Chart View Only -->
                    <div class="chart-container-comparison">
                      <canvas id="candidateAssessmentComparisonChart"></canvas>
                    </div>
                  </div>

                  <div class="no-comparison-results"
                    *ngIf="showCandidateAssessmentComparisonResults && (!currentCandidateAssessmentComparisonData.length || !compareCandidateAssessmentComparisonData.length)">
                    <p>No data available for comparison with selected period.</p>
                  </div>
                </div>

                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeCandidateAssessmentCompareDialog()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <!-- Table Modal -->
            <div *ngIf="showCandidateAssessmentTableModal" class="table-modal-overlay"
              (click)="closeCandidateAssessmentTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Candidates by Assessment - Detailed Report</h3>
                  <button class="table-modal-close" (click)="closeCandidateAssessmentTableModal()">×</button>
                </div>

                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table">
                      <thead>
                        <tr>
                          <th>Assessment</th>
                          <th>Candidate Count</th>
                          <th>Percentage</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of candidateAssessmentChartData">
                          <td>{{ item.name }}</td>
                          <td>{{ item.value }}</td>
                          <td>{{ getCandidateAssessmentPercentage(item) }}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportCandidateAssessmentTableAsPDF()">
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Assessments by Status Chart - For All View -->
          <div class="chart-container">
            <!-- TOP ROW: Month/Year + Filter + Three-dot -->
            <div class="chart-filters-row">
              <div class="month-year-filters">
                <div class="filter-group">
                  <div class="year-dropdown">
                    <button class="dropdown-btny" style="width: 80px !important;"
                      (click)="toggleAssessmentEvaluationYearDropdown()">
                      {{ selectedAssessmentEvaluationYearRange }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showAssessmentEvaluationYearDropdown">
                      <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                        [class.active]="selectedAssessmentEvaluationYearRange === yearRange.value"
                        (click)="selectAssessmentEvaluationYearRange(yearRange.value)">
                        {{ yearRange.display }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="filter-group">
                  <div class="month-dropdown">
                    <button class="dropdown-btny" style="width: 100px !important;"
                      (click)="toggleAssessmentEvaluationMonthDropdown()">
                      {{ getMonthName(selectedAssessmentEvaluationMonth) }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showAssessmentEvaluationMonthDropdown">
                      <button *ngFor="let month of availableMonths" class="dropdown-item"
                        [class.active]="selectedAssessmentEvaluationMonth === month.value"
                        (click)="selectAssessmentEvaluationMonth(month.value)">
                        {{ month.name }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="chart-actions-right">
                <div class="filter-button-container ">
                  <button class="filter-toggle-btn"  (click)="toggleAssessmentEvaluationFilterPanel($event)">
                    <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                    </svg>
                  </button>
                </div>

                <div class="chart-menu-container">
                  <button class="chart-menu-btn" (click)="toggleAssessmentEvaluationChartMenu()">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <circle cx="12" cy="6" r="2"></circle>
                      <circle cx="12" cy="12" r="2"></circle>
                      <circle cx="12" cy="18" r="2"></circle>
                    </svg>
                  </button>

                  <div class="chart-menu-dropdown" [class.show]="showAssessmentEvaluationChartMenu">
                    <button class="chart-menu-close-btn" (click)="showAssessmentEvaluationChartMenu = false">×</button>
                    <button class="chart-menu-item" (click)="openAssessmentEvaluationTableModal()">
                      <span>Show as Table</span>
                    </button>
                    <button class="chart-menu-item" (click)="openAssessmentEvaluationCompareDialog()">
                      <span>Compare</span>
                    </button>
                    <div class="menu-item-with-submenu" (mouseenter)="showAssessmentEvaluationDownloadSubMenu = true"
                      (mouseleave)="showAssessmentEvaluationDownloadSubMenu = false">
                      <button class="chart-menu-item submenu-trigger">
                        <span>Download</span>
                          <span class="submenu-arrow">›</span>
                      </button>
                      <div class="submenu" [class.show]="showAssessmentEvaluationDownloadSubMenu">
                        <button class="chart-menu-close-btn" (click)="showAssessmentEvaluationDownloadSubMenu = false">×</button>
                        <button class="submenu-item"
                          (click)="exportAssessmentEvaluationAsPDF(); showAssessmentEvaluationChartMenu = false;">
                          <span>Export as PDF</span>
                        </button>
                        <button class="submenu-item"
                          (click)="exportAssessmentEvaluationAsPNG(); showAssessmentEvaluationChartMenu = false;">
                          <span>Export as PNG</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Filter Panel -->
            <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showAssessmentEvaluationFilterPanel">
              <div class="filter-panel">
                <div class="filter-columns-container">
                  <div class="filter-headers-column">
                    <div class="filter-headers-header">
                      <mat-icon class="filter-icon">tune</mat-icon>
                      <span class="filter-title">Filter</span>
                    </div>
                    
                    <div class="filter-headers-list">
                      <div *ngFor="let header of assessmentEvaluationFilterHeaders; let i = index" 
                        class="filter-header-item" 
                        [class.active]="activeAssessmentEvaluationFilterHeader === header.key">
                        <label class="filter-header-checkbox-label" [for]="'assessment-evaluation-header-' + i">
                          <input type="checkbox" class="filter-checkbox-input" 
                            [id]="'assessment-evaluation-header-' + i"
                            [checked]="activeAssessmentEvaluationFilterHeader === header.key"
                            (click)="activeAssessmentEvaluationFilterHeader = header.key"
                            (change)="activeAssessmentEvaluationFilterHeader = header.key"
                            style="display: none;">
                          <span class="filter-checkmark"></span>
                          <span class="filter-header-name">{{ header.name }}</span>
                        </label>
                      </div>
                    </div>
                    
                    <button class="filter-clear-button" (click)="clearAssessmentEvaluationFilters()">
                      Clear
                    </button>
                  </div>

                  <div class="filter-content-column">
                    <div class="filter-search" *ngIf="activeAssessmentEvaluationFilterHeader === 'course'">
                      <input type="text" placeholder="Search courses..." class="filter-search-input"
                        [(ngModel)]="assessmentInsightCourseSearchTerm" (keyup)="filterAssessmentInsightCoursesFromApi()">
                    </div>
                    <div class="filter-search" *ngIf="activeAssessmentEvaluationFilterHeader === 'geography'">
                      <input type="text" placeholder="Search geography..." class="filter-search-input"
                        [(ngModel)]="assessmentEvaluationGeographySearchTerm" (input)="filterAssessmentEvaluationGeographies()">
                    </div>



                    <div class="filter-options-container" style="margin-top: 5px;">
                      <div class="filter-options-list">
                        <div *ngIf="activeAssessmentEvaluationFilterHeader === 'course'">
                          <div *ngFor="let course of filteredAssessmentInsightCourseApiList"
                            >
                            <label class="filter-option-item">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="isAssessmentEvaluationCourseSelected(course.name || course.course || course)"
                                (change)="toggleAssessmentEvaluationFilter('course', course.name || course.course || course)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ course.name || course.course || course }}</span>
                            </label>
                          </div>
                          <div *ngIf="(filteredAssessmentInsightCourseApiList?.length === 0 && assessmentInsightCourseSearchTerm) || (!filteredAssessmentInsightCourseApiList?.length)"
                            class="no-results-message">
                            No Data Found
                          </div>
                        </div>

                        <div *ngIf="activeAssessmentEvaluationFilterHeader === 'geography'">
                          <div *ngFor="let geo of filteredAssessmentEvaluationGeographyList?.length ? filteredAssessmentEvaluationGeographyList : (allGeographicInsightGeographies?.length ? allGeographicInsightGeographies : geographyData)"
                            >
                            <label class="filter-option-item">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="isAssessmentEvaluationGeographySelected(geo.state || geo)"
                                (change)="toggleAssessmentEvaluationFilter('geography', geo.state || geo)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ geo.state || geo }}</span>
                            </label>
                          </div>
                          <div *ngIf="(filteredAssessmentEvaluationGeographyList?.length === 0 && assessmentEvaluationGeographySearchTerm) || (!filteredAssessmentEvaluationGeographyList?.length && !((allGeographicInsightGeographies?.length || geographyData?.length)))"
                            class="no-results-message">
                            No Data Found
                          </div>
                        </div>




                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- CHART AREA -->
            <div class="doughnut-chart-container" style="overflow: hidden !important;"
              *ngIf="showAssessmentEvaluationChart && assessmentEvaluationChartData.length > 0">
              <div class="chart-wrapper">
                <canvas id="assessmentEvaluationChart"></canvas>
              </div>
              <div class="chart-legend">
                <div *ngFor="let item of assessmentEvaluationChartData" class="legend-item">
                  <span class="legend-color" [style.background-color]="item.color"></span>
                  <span class="legend-label">{{ item.name }}</span>
                  <span class="legend-count">{{ item.value }} ({{ getAssessmentEvaluationPercentage(item) }}%)</span>
                </div>
              </div>
            </div>

            <!-- NO DATA MESSAGE -->
            <div *ngIf="!showAssessmentEvaluationChart || assessmentEvaluationChartData.length === 0"
              class="no-data-message">
              <p>No assessment evaluation data available for the selected filters.</p>
            </div>

            <!-- TITLE AT BOTTOM -->
            <div class="chart-header-new" style="margin-top: 10px;">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">Assessments by Status</span>
                </div>
              </div>
            </div>

            <!-- Compare Dialog -->
            <div *ngIf="showAssessmentEvaluationCompareDialog" class="compare-dialog-overlay"
              (click)="closeAssessmentEvaluationCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Assessments by Status</h3>
                  <button class="compare-dialog-close" (click)="closeAssessmentEvaluationCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <div class="compare-filters">
                    <div class="filter-group">
                      <label>Select Month 1:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleAssessmentEvaluationCompareMonth1Dropdown()">
                          {{ selectedAssessmentEvaluationCompareMonth1 ? getMonthName(selectedAssessmentEvaluationCompareMonth1) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showAssessmentEvaluationCompareMonth1Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedAssessmentEvaluationCompareMonth1 === month.value"
                            (click)="selectAssessmentEvaluationCompareMonth1(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="filter-group">
                      <label>Select Month 2:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleAssessmentEvaluationCompareMonth2Dropdown()">
                          {{ selectedAssessmentEvaluationCompareMonth2 ? getMonthName(selectedAssessmentEvaluationCompareMonth2) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showAssessmentEvaluationCompareMonth2Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedAssessmentEvaluationCompareMonth2 === month.value"
                            (click)="selectAssessmentEvaluationCompareMonth2(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <button class="btn-compare" (click)="loadAssessmentEvaluationComparisonDataMonthWise()" [disabled]="!selectedAssessmentEvaluationCompareMonth1 || !selectedAssessmentEvaluationCompareMonth2">Compare</button>
                  </div>

                  <div class="compare-results" *ngIf="showAssessmentEvaluationComparisonResults">
                    <h4 class="results-title">Comparison Results</h4>

                    <!-- Chart View Only -->
                    <div class="chart-container-comparison" style="position: relative; height: 400px; width: 100%; margin-bottom: 20px;">
                      <canvas id="assessmentEvaluationComparisonChart"></canvas>
                    </div>
                  </div>

                  <div class="no-comparison-results"
                    *ngIf="showAssessmentEvaluationComparisonResults && (!currentAssessmentEvaluationComparisonData.length || !compareAssessmentEvaluationComparisonData.length)">
                    <p>No data available for comparison with selected period.</p>
                  </div>
                </div>

                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeAssessmentEvaluationCompareDialog()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <!-- Table Modal -->
            <div *ngIf="showAssessmentEvaluationTableModal" class="table-modal-overlay"
              (click)="closeAssessmentEvaluationTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Assessments by Evaluation Status - Detailed Report</h3>
                  <button class="table-modal-close" (click)="closeAssessmentEvaluationTableModal()">×</button>
                </div>

                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table">
                      <thead>
                        <tr>
                          <th>Evaluation Status</th>
                          <th>Count</th>
                          <th>Percentage</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of assessmentEvaluationChartData">
                          <td>{{ item.name }}</td>
                          <td>{{ item.value }}</td>
                          <td>{{ getAssessmentEvaluationPercentage(item) }}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportAssessmentEvaluationTableAsPDF()">
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Candidate Data by Assessment Chart - For All View 
          <div *ngIf="(selectedViewType === 'assessment' || selectedViewType === 'all')">
            <div class="chart-container">
              <!-- TOP ROW: Month/Year + Filter + Three-dot 
              <div class="chart-filters-row">
                <div class="month-year-filters">
                  <div class="filter-group">
                    <div class="year-dropdown">
                      <button class="dropdown-btny" style="width: 80px !important;"
                        (click)="togglePassFailYearDropdown()">
                        {{ selectedPassFailYearRange }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showPassFailYearDropdown">
                        <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                          [class.active]="selectedPassFailYearRange === yearRange.value"
                          (click)="selectPassFailYearRange(yearRange.value)">
                          {{ yearRange.display }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="filter-group">
                    <div class="month-dropdown">
                      <button class="dropdown-btny" style="width: 100px !important;"
                        (click)="togglePassFailMonthDropdown()">
                        {{ getMonthName(selectedPassFailMonth) }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showPassFailMonthDropdown">
                        <button *ngFor="let month of availableMonths" class="dropdown-item"
                          [class.active]="selectedPassFailMonth === month.value"
                          (click)="selectPassFailMonth(month.value)">
                          {{ month.name }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="chart-actions-right">
                  <div class="filter-button-container ">
                    <button class="filter-toggle-btn"  (click)="togglePassFailFilterPanel($event)">
                      <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                      </svg>
                    </button>
                  </div>

                  <div class="chart-menu-container">
                    <button class="chart-menu-btn" (click)="togglePassFailChartMenu()">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <circle cx="12" cy="6" r="2"></circle>
                        <circle cx="12" cy="12" r="2"></circle>
                        <circle cx="12" cy="18" r="2"></circle>
                      </svg>
                    </button>

                    <div class="chart-menu-dropdown" [class.show]="showPassFailChartMenu">
                      <button class="chart-menu-close-btn" (click)="showPassFailChartMenu = false" style="color: black !important;">×</button>
                      <button class="chart-menu-item" (click)="openPassFailTableModal()">
                        <span>Show as Table</span>
                      </button>
                      <button class="chart-menu-item" (click)="openPassFailCompareDialog()">
                        <span>Compare</span>
                      </button>
                      <div class="menu-item-with-submenu" (mouseenter)="showPassFailDownloadSubMenu = true"
                        (mouseleave)="showPassFailDownloadSubMenu = false">
                        <button class="chart-menu-item submenu-trigger">
                          <span>Download</span>
                            <span class="submenu-arrow">›</span>
                        </button>
                        <div class="submenu" [class.show]="showPassFailDownloadSubMenu">
                          <button class="chart-menu-close-btn" (click)="showPassFailDownloadSubMenu = false">×</button>
                          <button class="submenu-item" (click)="exportPassFailAsPDF()">
                            <span>Export as PDF</span>
                          </button>
                          <button class="submenu-item" (click)="exportPassFailAsPNG()">
                            <span>Export as PNG</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Filter Panel 
              <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showPassFailFilterPanel">
                <div class="filter-panel">
                  <div class="filter-columns-container">
                    <!-- Left Column - Filter Headers 
                    <div class="filter-headers-column">
                      <!-- Filter Header with Icon 
                      <div class="filter-headers-header">
                        <mat-icon class="filter-icon">tune</mat-icon>
                        <span class="filter-title">Filter</span>
                      </div>
                      
                      <div class="filter-headers-list">
                        <div *ngFor="let header of passFailFilterHeaders; let i = index" 
                          class="filter-header-item" 
                          [class.active]="activePassFailFilterHeader === header.key">
                          <label class="filter-header-checkbox-label" [for]="'passfail-header-' + i">
                            <input type="checkbox" class="filter-checkbox-input" 
                              [id]="'passfail-header-' + i"
                              [checked]="activePassFailFilterHeader === header.key"
                              (click)="setActivePassFailFilterHeader(header.key)"
                              (change)="setActivePassFailFilterHeader(header.key)"
                              style="display: none;">
                            <span class="filter-checkmark"></span>
                            <span class="filter-header-name">{{ header.name }}</span>
                          </label>
                        </div>
                      </div>
                      
                      <!-- Clear Button 
                      <button class="filter-clear-button" (click)="clearPassFailFilters()">
                        Clear
                      </button>
                    </div>

                    <!-- Right Column - Filter Content 
                    <div class="filter-content-column">
                      <!-- Search Input - Course 
                      <div class="filter-search" *ngIf="activePassFailFilterHeader === 'course'">
                        <input type="text" placeholder="Search courses..." class="filter-search-input"
                          [(ngModel)]="passFailCourseSearchTerm" (input)="filterPassFailCourse()">
                      </div>

                      <!-- Search Input - Geography 
                      <div class="filter-search" *ngIf="activePassFailFilterHeader === 'geography'">
                        <input type="text" placeholder="Search states..." class="filter-search-input"
                          [(ngModel)]="passFailGeographySearchTerm" (input)="filterPassFailGeography()">
                      </div>

                      <!-- Search Input - Customer 
                      <div class="filter-search" *ngIf="activePassFailFilterHeader === 'customer'">
                        <input type="text" placeholder="Search customers..." class="filter-search-input"
                          [(ngModel)]="passFailCustomerSearchTerm" (input)="filterPassFailCustomer()">
                      </div>

                      <!-- Search Input - Language 
                      <div class="filter-search" *ngIf="activePassFailFilterHeader === 'language'">
                        <input type="text" placeholder="Search languages..." class="filter-search-input"
                          [(ngModel)]="passFailLanguageSearchTerm" (input)="filterPassFailLanguage()">
                      </div>

                      <!-- Filter Options - Course 
                      <div class="filter-options-container" style="margin-top: 5px;" *ngIf="activePassFailFilterHeader === 'course'">
                        <div class="filter-options-list">
                          <label class="filter-option-item" *ngFor="let course of filteredPassFailCourseList || allPassFailCourses">
                            <input type="checkbox" class="filter-checkbox-input"
                              [checked]="isPassFailCourseSelected(course)"
                              (change)="togglePassFailCourseFilter(course)">
                            <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                            <span class="filter-option-name">{{ course.course_name }}</span>
                          </label>
                          <div *ngIf="(filteredPassFailCourseList?.length === 0 && passFailCourseSearchTerm) || (!filteredPassFailCourseList?.length && !(allPassFailCourses?.length))"
                            class="no-results-message">No Data Found</div>
                        </div>
                      </div>

                      <!-- Filter Options - Geography (States) 
                      <div class="filter-options-container" *ngIf="activePassFailFilterHeader === 'geography'">
                        <div class="filter-options-list">
                          <label class="filter-option-item" *ngFor="let geography of filteredPassFailGeographyList || allPassFailGeographies">
                            <input type="checkbox" class="filter-checkbox-input"
                              [checked]="isPassFailGeographySelected(geography)"
                              (change)="togglePassFailGeographyFilter(geography)">
                            <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                            <span class="filter-option-name">{{ geography.state }}</span>
                          </label>
                          <div *ngIf="(filteredPassFailGeographyList?.length === 0 && passFailGeographySearchTerm) || (!filteredPassFailGeographyList?.length && !(allPassFailGeographies?.length))"
                            class="no-results-message">No Data Found</div>
                        </div>
                      </div>

                      <!-- Filter Options - Customer 
                      <div class="filter-options-container" *ngIf="activePassFailFilterHeader === 'customer'">
                        <div class="filter-options-list">
                          <label class="filter-option-item" *ngFor="let customer of filteredPassFailCustomerList || allPassFailCustomers">
                            <input type="checkbox" class="filter-checkbox-input"
                              [checked]="isPassFailCustomerSelected(customer)"
                              (change)="togglePassFailCustomerFilter(customer)">
                            <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                            <span class="filter-option-name">{{ customer.name }}</span>
                          </label>
                          <div *ngIf="(filteredPassFailCustomerList?.length === 0 && passFailCustomerSearchTerm) || (!filteredPassFailCustomerList?.length && !(allPassFailCustomers?.length))"
                            class="no-results-message">No Data Found</div>
                        </div>
                      </div>

                      <!-- Filter Options - Language 
                      <div class="filter-options-container" *ngIf="activePassFailFilterHeader === 'language'">
                        <div class="filter-options-list">
                          <label class="filter-option-item" *ngFor="let language of filteredPassFailLanguageList || allPassFailLanguages">
                            <input type="checkbox" class="filter-checkbox-input"
                              [checked]="isPassFailLanguageSelected(language)"
                              (change)="togglePassFailLanguageFilter(language)">
                            <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                            <span class="filter-option-name">{{ language.name }}</span>
                          </label>
                          <div *ngIf="(filteredPassFailLanguageList?.length === 0 && passFailLanguageSearchTerm) || (!filteredPassFailLanguageList?.length && !(allPassFailLanguages?.length))"
                            class="no-results-message">No Data Found</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- HORIZONTAL STACKED BAR CHART AREA 
              <div id="passFailHorizontalBarChart" class="horizontal-bar-chart-container" style="overflow: hidden !important;"
                *ngIf="showPassFailChart && passFailChartLabels.length > 0">
                <div class="chart-wrapper">
                  <canvas id="passFailChart"></canvas>
                </div>
                <div class="chart-legend" style="margin-top: 330px !important;">
                  <div class="legend-item">
                    <span class="legend-color" style="background-color: #015C96;"></span>
                    <span class="legend-label">Passed</span>
                  </div>
                  <div class="legend-item">
                    <span class="legend-color" style="background-color: #FF6F59;"></span>
                    <span class="legend-label">Failed</span>
                  </div>
                  <div class="legend-item">
                    <span class="legend-color" style="background-color: #FFDB93;"></span>
                    <span class="legend-label">Reassessed</span>
                  </div>
                </div>
              </div>

              <!-- NO DATA MESSAGE 
              <div *ngIf="!showPassFailChart || passFailChartLabels.length === 0" class="no-data-message">
                <p>No assessment data available for the selected filters.</p>
              </div>

              <!-- TITLE AT BOTTOM 
              <div class="chart-header-new" style="margin-top: 30px;">
                <div class="chart-title-bottom">
                  <div class="chart-title-section-center">
                    <span class="analyticslabel">Candidate Data by Assessment</span>
                  </div>
                </div>
              </div>

              <!-- Compare Dialog 
              <div *ngIf="showPassFailCompareDialog" class="compare-dialog-overlay"
                (click)="closePassFailCompareDialog()">
                <div class="compare-dialog" (click)="$event.stopPropagation()">
                  <div class="compare-dialog-header">
                    <h3 class="compare-dialog-title">Compare Pass/Fail by Assessment</h3>
                    <button class="compare-dialog-close" (click)="closePassFailCompareDialog()">×</button>
                  </div>

                  <div class="compare-dialog-content">
                    <div class="compare-filters">
                      <div class="filter-group">
                        <label>Select Month 1:</label>
                        <div class="month-dropdown">
                          <button class="dropdown-btny" (click)="togglePassFailCompareMonth1Dropdown()">
                            {{ selectedPassFailCompareMonth1 ? getMonthName(selectedPassFailCompareMonth1) : 'Select Month' }}
                          </button>
                          <div class="dropdown-menu" [class.show]="showPassFailCompareMonth1Dropdown">
                            <button *ngFor="let month of availableMonths" class="dropdown-item"
                              [class.active]="selectedPassFailCompareMonth1 === month.value"
                              (click)="selectPassFailCompareMonth1(month.value)">
                              {{ month.name }}
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="filter-group">
                        <label>Select Month 2:</label>
                        <div class="month-dropdown">
                          <button class="dropdown-btny" (click)="togglePassFailCompareMonth2Dropdown()">
                            {{ selectedPassFailCompareMonth2 ? getMonthName(selectedPassFailCompareMonth2) : 'Select Month' }}
                          </button>
                          <div class="dropdown-menu" [class.show]="showPassFailCompareMonth2Dropdown">
                            <button *ngFor="let month of availableMonths" class="dropdown-item"
                              [class.active]="selectedPassFailCompareMonth2 === month.value"
                              (click)="selectPassFailCompareMonth2(month.value)">
                              {{ month.name }}
                            </button>
                          </div>
                        </div>
                      </div>

                      <button class="btn-compare" (click)="loadPassFailComparisonDataMonthWise()" [disabled]="!selectedPassFailCompareMonth1 || !selectedPassFailCompareMonth2">Compare</button>
                    </div>

                    <div class="compare-results" *ngIf="showPassFailComparisonResults">
                      <h4 class="results-title">Comparison Results</h4>

                      <!-- Chart View Only 
                      <div class="chart-container-comparison" style="position: relative; height: 400px; width: 100%; margin-bottom: 20px;">
                        <canvas id="passFailComparisonChart"></canvas>
                      </div>
                    </div>

                    <div class="no-comparison-results"
                      *ngIf="showPassFailComparisonResults && (!currentPassFailComparisonData.length || !comparePassFailComparisonData.length)">
                      <p>No data available for comparison with selected period.</p>
                    </div>
                  </div>

                  <div class="compare-dialog-actions">
                    <button class="compare-action-btn secondary" (click)="closePassFailCompareDialog()">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>

              <!-- Table Modal 
              <div *ngIf="showPassFailTableModal" class="table-modal-overlay" (click)="closePassFailTableModal()">
                <div class="table-modal" (click)="$event.stopPropagation()">
                  <div class="table-modal-header">
                    <h3 class="table-modal-title">Pass/Fail by Assessment - Detailed Report</h3>
                    <button class="table-modal-close" (click)="closePassFailTableModal()">×</button>
                  </div>

                  <div class="table-modal-content">
                    <div class="modal-table-container">
                      <table class="modal-table">
                        <thead>
                          <tr>
                            <th>Course</th>
                            <th>Passed</th>
                            <th>Failed</th>
                            <th>Reassessed</th>
                            <th>Total Candidates</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let label of passFailChartLabels; let i = index">
                            <td>{{ label }}</td>
                            <td>{{ passFailPassData[i] || 0 }}</td>
                            <td>{{ passFailFailData[i] || 0 }}</td>
                            <td>{{ passFailReassessedData[i] || 0 }}</td>
                            <td>{{ (passFailPassData[i] || 0) + (passFailFailData[i] || 0) + (passFailReassessedData[i] || 0) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="modal-table-actions">
                    <button class="modal-export-btn secondary" (click)="exportPassFailTableAsPDF()">
                      Export as PDF
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Candidates by Assessment Chart - Bar Chart by Performance -->
          <!--<div class="chart-container">
            <!-- TOP ROW: Month/Year + Pass/Fail Toggles + Filter + Three-dot 
            <div class="chart-filters-row ">
              <div class="month-year-filters">
                <div class="filter-group">
                  <div class="year-dropdown">
                    <button class="dropdown-btny" style="width: 80px !important;"
                      (click)="toggleCandidateAssessmentYearDropdown()">
                      {{ selectedCandidateAssessmentYearRange }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showCandidateAssessmentYearDropdown">
                      <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                        [class.active]="selectedCandidateAssessmentYearRange === yearRange.value"
                        (click)="selectCandidateAssessmentYearRange(yearRange.value)">
                        {{ yearRange.display }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="filter-group">
                  <div class="month-dropdown">
                    <button class="dropdown-btny" style="width: 100px !important;"
                      (click)="toggleCandidateAssessmentMonthDropdown()">
                      {{ getMonthName(selectedCandidateAssessmentMonth) }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showCandidateAssessmentMonthDropdown">
                      <button *ngFor="let month of availableMonths" class="dropdown-item"
                        [class.active]="selectedCandidateAssessmentMonth === month.value"
                        (click)="selectCandidateAssessmentMonth(month.value)">
                        {{ month.name }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              

              <div class="chart-actions-right">
                <div class="filter-button-container ">
                  <button class="filter-toggle-btn"  (click)="toggleCandidatePerformanceFilterPanel($event)">
                    <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                    </svg>
                  </button>
                </div>

                 <div class="chart-menu-container">
                  <button class="chart-menu-btn" (click)="toggleCandidateAssessmentChartMenu()">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <circle cx="12" cy="6" r="2"></circle>
                      <circle cx="12" cy="12" r="2"></circle>
                      <circle cx="12" cy="18" r="2"></circle>
                    </svg>
                  </button>

                  <div class="chart-menu-dropdown" [class.show]="showCandidateAssessmentChartMenu">
                    <button class="chart-menu-close-btn" (click)="showCandidateAssessmentChartMenu = false" style="color: black !important;">×</button>
                    <button class="chart-menu-item" (click)="openCandidateAssessmentTableModal()">
                      <span>Show as Table</span>
                    </button>
                    <button class="chart-menu-item" (click)="openCandidatePerformanceCompareDialog(); showCandidatePerformanceChartMenu = false;">
                      <span>Compare</span>
                    </button>
                    <div class="menu-item-with-submenu" (mouseenter)="showCandidateAssessmentDownloadSubMenu = true"
                      (mouseleave)="showCandidateAssessmentDownloadSubMenu = false">
                      <button class="chart-menu-item submenu-trigger">
                        <span>Download</span>
                          <span class="submenu-arrow">›</span>
                      </button>
                      <div class="submenu" [class.show]="showCandidateAssessmentDownloadSubMenu">
                        <button class="chart-menu-close-btn" (click)="showCandidateAssessmentDownloadSubMenu = false" style="color: black !important;">×</button>
                        <button class="submenu-item"
                          (click)="exportCandidateAssessmentAsPDF(); showCandidateAssessmentChartMenu = false;">
                          <span>Export as PDF</span>
                        </button>
                        <button class="submenu-item" (click)="exportCandidatePerformanceAsPNG(); showCandidatePerformanceChartMenu = false;">
                          <span>Export as PNG</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showCandidatePerformanceFilterPanel">
              <div class="filter-panel">
                <div class="filter-columns-container">
                  <!-- Left Column - Filter Headers 
                  <div class="filter-headers-column">
                    <!-- Filter Header with Icon 
                    <div class="filter-headers-header">
                      <mat-icon class="filter-icon">tune</mat-icon>
                      <span class="filter-title">Filter</span>
                    </div>
                    
                    <div class="filter-headers-list">
                      <div *ngFor="let header of candidatePerformanceFilterHeaders; let i = index" 
                        class="filter-header-item" 
                        [class.active]="activeCandidatePerformanceFilterHeader === header.key">
                        <label class="filter-header-checkbox-label" [for]="'candidate-performance-header-' + i">
                          <input type="checkbox" class="filter-checkbox-input" 
                            [id]="'candidate-performance-header-' + i"
                            [checked]="activeCandidatePerformanceFilterHeader === header.key"
                            (click)="activeCandidatePerformanceFilterHeader = header.key"
                            (change)="activeCandidatePerformanceFilterHeader = header.key"
                            style="display: none;">
                          <span class="filter-checkmark"></span>
                          <span class="filter-header-name">{{ header.name }}</span>
                        </label>
                      </div>
                    </div>
                    
                    <!-- Clear Button 
                    <button class="filter-clear-button" (click)="clearCandidatePerformanceFilters()">
                      Clear
                    </button>
                  </div>

                  <!-- Right Column - Filter Content 
                  <div class="filter-content-column">
                    <!-- Search Input - Courses 
                    <div class="filter-search" *ngIf="activeCandidatePerformanceFilterHeader === 'courses'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search courses" 
                        [(ngModel)]="candidatePerformanceCourseSearchTerm"
                        (keyup)="filterCandidatePerformanceCoursesFromApi()">
                    </div>

                    <!-- Filter Options - Courses
                    <div class="filter-options-container" style="margin-top: 5px;" *ngIf="activeCandidatePerformanceFilterHeader === 'courses'">
                      <div class="filter-options-list">
                        <label class="filter-option-item" *ngFor="let course of filteredCandidatePerformanceCourseApiList" >
                          <input type="checkbox" class="filter-checkbox-input" 
                            [checked]="selectedCandidatePerformanceCourseValues.includes(course.name)"
                            (change)="toggleCandidatePerformanceFilter('course', course)">
                          <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                          <span class="filter-option-name">{{ course.name }}</span>
                        </label>
                      </div>
                    </div>

                    <!-- Search Input - Geography 
                    <div class="filter-search" *ngIf="activeCandidatePerformanceFilterHeader === 'geography'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search geography" 
                        [(ngModel)]="candidatePerformanceGeographySearchTerm"
                        (keyup)="filterCandidatePerformanceGeographyFromApi()">
                    </div>

                    <!-- Filter Options - Geography 
                    <div class="filter-options-container" style="margin-top: 5px;" *ngIf="activeCandidatePerformanceFilterHeader === 'geography'">
                      <div class="filter-options-list">
                        <label class="filter-option-item" *ngFor="let geography of filteredCandidatePerformanceGeographyList" >
                          <input type="checkbox" class="filter-checkbox-input" 
                            [checked]="selectedCandidatePerformanceGeographyValues.includes(geography.state || geography.state_name || geography.name)"
                            (change)="toggleCandidatePerformanceFilter('geography', geography)">
                          <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                          <span class="filter-option-name">{{ geography.state || geography.state_name || geography.name }}</span>
                        </label>
                      </div>
                    </div>

                    <!-- Search Input - Customers 
                    <div class="filter-search" *ngIf="activeCandidatePerformanceFilterHeader === 'customers'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search customers" 
                        [(ngModel)]="candidatePerformanceCustomerSearchTerm"
                        (keyup)="filterCandidatePerformanceCustomersFromApi()">
                    </div>

                    <!-- Filter Options - Customers 
                    <div class="filter-options-container" style="margin-top: 5px;" *ngIf="activeCandidatePerformanceFilterHeader === 'customers'">
                      <div class="filter-options-list">
                        <label class="filter-option-item" *ngFor="let customer of filteredCandidatePerformanceCustomerApiList" >
                          <input type="checkbox" class="filter-checkbox-input" 
                            [checked]="selectedCandidatePerformanceCustomerValues.includes(customer.name)"
                            (change)="toggleCandidatePerformanceFilter('customers', customer)">
                          <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                          <span class="filter-option-name">{{ customer.name }}</span>
                        </label>
                      </div>
                    </div>

                    <!-- Search Input - Languages 
                    <div class="filter-search" *ngIf="activeCandidatePerformanceFilterHeader === 'languages'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search languages" 
                        [(ngModel)]="candidatePerformanceLanguageSearchTerm"
                        (keyup)="filterCandidatePerformanceLanguagesFromApi()">
                    </div>

                    <!-- Filter Options - Languages 
                    <div class="filter-options-container" style="margin-top: 5px;" *ngIf="activeCandidatePerformanceFilterHeader === 'languages'">
                      <div class="filter-options-list">
                        <label class="filter-option-item" *ngFor="let language of filteredCandidatePerformanceLanguageList" >
                          <input type="checkbox" class="filter-checkbox-input" 
                            [checked]="selectedCandidatePerformanceLanguageValues.includes(language.name)"
                            (change)="toggleCandidatePerformanceFilter('languages', language)">
                          <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                          <span class="filter-option-name">{{ language.name }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
              <div class="performance-toggle-group" style="display: flex; gap: 10px; align-items: center; margin: 0 10px;justify-content: flex-end;"
              >
                <button class="performance-toggle-btn" 
                  [class.active]="candidatePerformanceSelectedToggle === 'pass'"
                  (click)="selectCandidatePerformanceToggle('pass')"
                  [style]="candidatePerformanceSelectedToggle === 'pass' ? 'background-color: #E2F0E2; color: #000000; border: 1px solid #CBD8CB;' : 'background-color: #FFFFFF; color: #000000; border: 1px solid #D1D5DB;'"
                  style="padding: 4px 22px; border-radius: 14px; cursor: pointer; font-weight: 600;">
                  Pass
                </button>
                <button class="performance-toggle-btn" 
                  [class.active]="candidatePerformanceSelectedToggle === 'fail'"
                  (click)="selectCandidatePerformanceToggle('fail')"
                  [style]="candidatePerformanceSelectedToggle === 'fail' ? 'background-color: #FBCEB1; color: #000000; border: 1px solid #EF4444;' : 'background-color: #FFFFFF; color: #000000; border: 1px solid #D1D5DB;'"
                  style="padding: 4px 22px; border-radius: 14px; cursor: pointer; font-weight: 600;">
                  Fail
                </button>
              </div>

            <div class="bar-chart-container" style="overflow: hidden !important; margin-top: 15px; position: relative;"
              *ngIf="showCandidatePerformanceChart && candidatePerformanceChartLabels.length > 0">
              <div class="chart-wrapper" style="position: relative; height: 200px;">
                <canvas id="candidatePerformanceChart" 
                  (mousemove)="onCandidatePerformanceChartHover($event)"
                  (mouseleave)="onCandidatePerformanceChartLeave()"></canvas>
              </div>
            </div>

            <div *ngIf="!showCandidatePerformanceChart || candidatePerformanceChartLabels.length === 0" class="no-data-message">
              <p>No candidate performance data available for the selected filters.</p>
            </div>

            <div class="chart-header-new" style="margin-top: 30px;">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">Candidate Data by Performance</span>
                </div>
              </div>
            </div>

            <div *ngIf="showCandidateAssessmentTableModal" class="table-modal-overlay"
              (click)="closeCandidateAssessmentTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Candidate Data by Performance - Detailed Report</h3>
                  <button class="table-modal-close" (click)="closeCandidateAssessmentTableModal()">×</button>
                </div>

                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table">
                      <thead>
                        <tr>
                          <th>Course</th>
                          <th>Total Candidates</th>
                          <th *ngIf="candidatePerformanceSelectedToggle === 'pass'">Pass Count</th>
                          <th *ngIf="candidatePerformanceSelectedToggle === 'pass'">Pass %</th>
                          <th *ngIf="candidatePerformanceSelectedToggle === 'fail'">Fail Count</th>
                          <th *ngIf="candidatePerformanceSelectedToggle === 'fail'">Fail %</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let label of candidatePerformanceChartLabels; let i = index">
                          <td>{{ label }}</td>
                          <td>{{ candidatePerformanceTotalCandidateCounts[i] || 0 }}</td>
                          <td *ngIf="candidatePerformanceSelectedToggle === 'pass'">{{ candidatePerformancePassData[i] || 0 }}</td>
                          <td *ngIf="candidatePerformanceSelectedToggle === 'pass'">
                            {{ candidatePerformanceTotalCandidateCounts[i] > 0 ? ((candidatePerformancePassData[i] || 0) / candidatePerformanceTotalCandidateCounts[i] * 100).toFixed(2) : 0 }}%
                          </td>
                          <td *ngIf="candidatePerformanceSelectedToggle === 'fail'">{{ candidatePerformanceFailData[i] || 0 }}</td>
                          <td *ngIf="candidatePerformanceSelectedToggle === 'fail'">
                            {{ candidatePerformanceTotalCandidateCounts[i] > 0 ? ((candidatePerformanceFailData[i] || 0) / candidatePerformanceTotalCandidateCounts[i] * 100).toFixed(2) : 0 }}%
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportCandidatePerformanceTableAsPDF()">
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
          </div>-->

          <!-- Assessment by Customers Chart -->
          <ng-container *ngIf="canShowAssessmentCustomerChart && (selectedViewType === 'assessment' || selectedViewType === 'all')">
            <div class="chart-container">
              <!-- TOP ROW: Month/Year + Filter + Three-dot -->
            <div class="chart-filters-row">
              <div class="month-year-filters">
                <div class="filter-group">
                  <div class="year-dropdown">
                    <button class="dropdown-btny" style="width: 80px !important;"
                      (click)="toggleAssessmentCustomerYearDropdown()">
                      {{ selectedAssessmentCustomerYearRange }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showAssessmentCustomerYearDropdown">
                      <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                        [class.active]="selectedAssessmentCustomerYearRange === yearRange.value"
                        (click)="selectAssessmentCustomerYearRange(yearRange.value)">
                        {{ yearRange.display }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="filter-group">
                  <div class="month-dropdown">
                    <button class="dropdown-btny" style="width: 100px !important;"
                      (click)="toggleAssessmentCustomerMonthDropdown()">
                      {{ getMonthName(selectedAssessmentCustomerMonth) }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showAssessmentCustomerMonthDropdown">
                      <button *ngFor="let month of availableMonths" class="dropdown-item"
                        [class.active]="selectedAssessmentCustomerMonth === month.value"
                        (click)="selectAssessmentCustomerMonth(month.value)">
                        {{ month.name }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="chart-actions-right">
                <div class="filter-button-container ">
                  <button class="filter-toggle-btn"  (click)="toggleAssessmentCustomerFilterPanel($event)">
                    <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                    </svg>
                  </button>
                </div>

                <div class="chart-menu-container">
                  <button class="chart-menu-btn" (click)="toggleAssessmentCustomerChartMenu()">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <circle cx="12" cy="6" r="2"></circle>
                      <circle cx="12" cy="12" r="2"></circle>
                      <circle cx="12" cy="18" r="2"></circle>
                    </svg>
                  </button>

                  <div class="chart-menu-dropdown" [class.show]="showAssessmentCustomerChartMenu">
                    <button class="chart-menu-close-btn" (click)="showAssessmentCustomerChartMenu = false" style="color: black !important;">×</button>
                    <button class="chart-menu-item" (click)="openAssessmentCustomerTableModal()">
                      <span>Show as Table</span>
                    </button>
                    
                    <!-- Compare - NEW -->
                    <button class="chart-menu-item" (click)="openAssessmentCustomerCompareDialog(); showAssessmentCustomerChartMenu = false;">
                      <span>Compare</span>
                    </button>
                    
                    <!-- Download Submenu -->
                    <div class="menu-item-with-submenu" (mouseenter)="showAssessmentCustomerDownloadSubMenu = true"
                      (mouseleave)="showAssessmentCustomerDownloadSubMenu = false">
                      <button class="chart-menu-item submenu-trigger">
                        <span>Download</span>
                        <span class="submenu-arrow">›</span>
                      </button>
                      <div class="submenu" [class.show]="showAssessmentCustomerDownloadSubMenu">
                        <button class="chart-menu-close-btn" (click)="showAssessmentCustomerDownloadSubMenu = false" style="color: black !important;">×</button>
                        <button class="submenu-item"
                          (click)="exportAssessmentCustomerAsPDF(); showAssessmentCustomerChartMenu = false;">
                          <span>Export as PDF</span>
                        </button>
                        <button class="submenu-item"
                          (click)="exportAssessmentCustomerAsPNG(); showAssessmentCustomerChartMenu = false;">
                          <span>Export as PNG</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Filter Panel -->
            <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showAssessmentCustomerFilterPanel">
              <div class="filter-panel">
                <div class="filter-columns-container">
                  <!-- Left Column - Filter Headers -->
                  <div class="filter-headers-column">
                    <div class="filter-headers-header">
                      <mat-icon class="filter-icon">tune</mat-icon>
                      <span class="filter-title">Filter</span>
                    </div>
                    
                    <div class="filter-headers-list">
                      <div *ngFor="let header of assessmentCustomerFilterHeaders; let i = index" 
                        class="filter-header-item" 
                        [class.active]="activeAssessmentCustomerFilterHeader === header.key">
                        <label class="filter-header-checkbox-label" [for]="'assessment-customer-header-' + i">
                          <input type="checkbox" class="filter-checkbox-input" 
                            [id]="'assessment-customer-header-' + i"
                            [checked]="activeAssessmentCustomerFilterHeader === header.key"
                            (click)="activeAssessmentCustomerFilterHeader = header.key"
                            (change)="activeAssessmentCustomerFilterHeader = header.key"
                            style="display: none;">
                          <span class="filter-checkmark"></span>
                          <span class="filter-header-name">{{ header.name }}</span>
                        </label>
                      </div>
                    </div>
                    
                    <button class="filter-clear-button" (click)="clearAssessmentCustomerFilters()">
                      Clear
                    </button>
                  </div>

                  <!-- Right Column - Filter Content -->
                  <div class="filter-content-column">
                    <div class="filter-search" *ngIf="activeAssessmentCustomerFilterHeader === 'courses'">
                      <input type="text" placeholder="Search courses..." class="filter-search-input"
                        [(ngModel)]="assessmentCustomerCourseSearchTerm" (input)="filterAssessmentCustomerCourses()">
                    </div>
                    <div class="filter-search" *ngIf="activeAssessmentCustomerFilterHeader === 'customer'">
                      <input type="text" placeholder="Search customers..." class="filter-search-input"
                        [(ngModel)]="assessmentCustomerCustomerSearchTerm" (input)="filterAssessmentCustomerCustomers()">
                    </div>

                    <div class="filter-options-container" style="margin-top: 5px;">
                      <div class="filter-options-list">
                        
                        <div *ngIf="activeAssessmentCustomerFilterHeader === 'courses'" class="filter-options-group">
                          <div *ngFor="let course of filteredAssessmentCustomerCourseApiList?.length ? filteredAssessmentCustomerCourseApiList : allAssessmentCourses">
                            <label class="filter-option-item">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="selectedAssessmentCustomerCourseValues.includes(course.course)"
                                (change)="toggleAssessmentCustomerFilter('courses', course.course)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ course.course }}</span>
                            </label>
                          </div>
                          <div *ngIf="(filteredAssessmentCustomerCourseApiList?.length === 0 && assessmentCustomerCourseSearchTerm) || (!filteredAssessmentCustomerCourseApiList?.length && !(allAssessmentCourses?.length))"
                            class="no-results-message">
                            No Data Found
                          </div>
                        </div>

                       <!-- Filter Options - Customer -->
                        <div *ngIf="activeAssessmentCustomerFilterHeader === 'customer'" class="filter-options-group">
                          <div *ngFor="let customer of filteredAssessmentCustomerCustomerApiList?.length ? filteredAssessmentCustomerCustomerApiList : customerMasterData"
                              >
                            <label class="filter-option-item">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="selectedAssessmentCustomerCustomerValues.includes(customer.name)"
                                (change)="toggleAssessmentCustomerFilter('customer', customer.name)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ customer.name }}</span>
                            </label>
                          </div>
                          
                          <div *ngIf="(filteredAssessmentCustomerCustomerApiList?.length === 0 && assessmentCustomerCustomerSearchTerm) || (!filteredAssessmentCustomerCustomerApiList?.length && !(customerMasterData?.length))"
                            class="no-results-message">
                            No Data Found
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- BAR CHART AREA -->
            <div class="bar-chart-container" style="overflow: hidden !important; margin-top: 15px; position: relative;"
              *ngIf="showAssessmentCustomerChart && assessmentCustomerChartLabels.length > 0">
              <div class="chart-wrapper" style="position: relative; height: 200px;">
                <canvas id="assessmentCustomerChart"></canvas>
              </div>
            </div>

            <!-- NO DATA MESSAGE -->
            <div *ngIf="!showAssessmentCustomerChart || assessmentCustomerChartLabels.length === 0" class="no-data-message">
              <p>No assessment customer data available for the selected filters.</p>
            </div>

            <!-- TITLE AT BOTTOM -->
              <div class="chart-header-new" style="margin-top: 30px !important;">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">Assessment by Customers</span>
                </div>
              </div>
            </div>

            <!-- Table Modal -->
            <div *ngIf="showAssessmentCustomerTableModal" class="table-modal-overlay"
              (click)="closeAssessmentCustomerTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Assessment by Customers - Detailed Report</h3>
                  <button class="table-modal-close" (click)="closeAssessmentCustomerTableModal()">×</button>
                </div>

                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table">
                      <thead>
                        <tr>
                          <th>Customer</th>
                          <th>Assessment Count</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let label of assessmentCustomerChartLabels; let i = index">
                          <td>{{ label }}</td>
                          <td>{{ assessmentCustomerChartValues[i] || 0 }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportAssessmentCustomerTableAsPDF()">
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
          </div>
                      <div *ngIf="showAssessmentCustomerCompareDialog" class="compare-dialog-overlay"
              (click)="closeAssessmentCustomerCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Assessment by Customers</h3>
                  <button class="compare-dialog-close" (click)="closeAssessmentCustomerCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <!-- Month Selection Filters -->
                  <div class="compare-filters">
                    <!-- Month 1 -->
                    <div class="filter-group">
                      <label>Select Month 1:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleAssessmentCustomerCompareMonth1Dropdown()">
                          {{ selectedAssessmentCustomerCompareMonth1 ? getMonthName(selectedAssessmentCustomerCompareMonth1) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showAssessmentCustomerCompareMonth1Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedAssessmentCustomerCompareMonth1 === month.value"
                            (click)="selectAssessmentCustomerCompareMonth1(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Month 2 -->
                    <div class="filter-group">
                      <label>Select Month 2:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleAssessmentCustomerCompareMonth2Dropdown()">
                          {{ selectedAssessmentCustomerCompareMonth2 ? getMonthName(selectedAssessmentCustomerCompareMonth2) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showAssessmentCustomerCompareMonth2Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedAssessmentCustomerCompareMonth2 === month.value"
                            (click)="selectAssessmentCustomerCompareMonth2(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Compare Button -->
                    <button class="btn-compare" (click)="loadAssessmentCustomerComparisonData()" 
                      [disabled]="!selectedAssessmentCustomerCompareMonth1 || !selectedAssessmentCustomerCompareMonth2">
                      Compare
                    </button>
                  </div>

                  <!-- Comparison Results -->
                  <div class="compare-results" *ngIf="showAssessmentCustomerComparisonResults">
                    <h4 class="results-title">Comparison Results</h4>

                    <!-- Chart View -->
                    <div class="chart-container-comparison" style="position: relative; height: 400px; width: 100%; margin-bottom: 20px;">
                      <canvas id="assessmentCustomerComparisonChart"></canvas>
                    </div>
                  </div>
                </div>

                <!-- Dialog Actions -->
                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeAssessmentCustomerCompareDialog()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Assessment by Language Chart -->
          <div class="chart-container">
            <div class="chart-filters-row">
              <div class="month-year-filters">
                <div class="filter-group">
                  <div class="year-dropdown">
                    <button class="dropdown-btny" style="width: 80px !important;" (click)="toggleAssessmentLanguageYearDropdown()">
                      {{ selectedAssessmentLanguageYearRange }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showAssessmentLanguageYearDropdown">
                      <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                        [class.active]="selectedAssessmentLanguageYearRange === yearRange.value"
                        (click)="selectAssessmentLanguageYearRange(yearRange.value)">
                        {{ yearRange.display }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="filter-group">
                  <div class="month-dropdown">
                    <button class="dropdown-btny" style="width: 100px !important;" (click)="toggleAssessmentLanguageMonthDropdown()">
                      {{ getMonthName(selectedAssessmentLanguageMonth) }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showAssessmentLanguageMonthDropdown">
                      <button *ngFor="let month of availableMonths" class="dropdown-item"
                        [class.active]="selectedAssessmentLanguageMonth === month.value"
                        (click)="selectAssessmentLanguageMonth(month.value)">
                        {{ month.name }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="chart-actions-right">
                <div class="filter-button-container ">
                  <button class="filter-toggle-btn"  (click)="toggleAssessmentLanguageFilterPanel($event)">
                    <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor"><path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z"/></svg>
                  </button>
                </div>
                <div class="chart-menu-container">
                  <button class="chart-menu-btn" (click)="toggleAssessmentLanguageChartMenu()">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="6" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="18" r="2"/></svg>
                  </button>
                  <div class="chart-menu-dropdown" [class.show]="showAssessmentLanguageChartMenu">
                    <button class="chart-menu-close-btn" (click)="showAssessmentLanguageChartMenu = false" style="color: black !important;">×</button>
                    <button class="chart-menu-item" (click)="openAssessmentLanguageTableModal()">Show as Table</button>
                    <button class="chart-menu-item" (click)="openAssessmentLanguageCompareDialog()">Compare</button>
                    <div class="menu-item-with-submenu" (mouseenter)="showAssessmentLanguageDownloadSubMenu = true" (mouseleave)="showAssessmentLanguageDownloadSubMenu = false">
                      <button class="chart-menu-item submenu-trigger">Download  <span class="submenu-arrow">›</span></button>
                      <div class="submenu" [class.show]="showAssessmentLanguageDownloadSubMenu">
                        <button class="chart-menu-close-btn" (click)="showAssessmentLanguageDownloadSubMenu = false" style="color: black !important;">×</button>
                        <button class="submenu-item" (click)="exportAssessmentLanguageAsPDF(); showAssessmentLanguageChartMenu = false;">Export as PDF</button>
                        <button class="submenu-item" (click)="exportAssessmentLanguageAsPNG(); showAssessmentLanguageChartMenu = false;">Export as PNG</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showAssessmentLanguageFilterPanel">
              <div class="filter-panel">
                <div class="filter-columns-container">
                  <div class="filter-headers-column">
                    <div class="filter-headers-header">
                      <mat-icon class="filter-icon">tune</mat-icon>
                      <span class="filter-title">Filter</span>
                    </div>
                    <div class="filter-headers-list">
                      <div *ngFor="let header of assessmentLanguageFilterHeaders; let i = index"
                        class="filter-header-item"
                        [class.active]="activeAssessmentLanguageFilterHeader === header.key">
                        <label class="filter-header-checkbox-label" [for]="'assessment-language-header-' + i">
                          <input type="checkbox" class="filter-checkbox-input"
                            [id]="'assessment-language-header-' + i"
                            [checked]="activeAssessmentLanguageFilterHeader === header.key"
                            (click)="activeAssessmentLanguageFilterHeader = header.key"
                            (change)="activeAssessmentLanguageFilterHeader = header.key"
                            style="display: none;" />
                          <span class="filter-checkmark"></span>
                          <span class="filter-header-name">{{ header.name }}</span>
                        </label>
                      </div>
                    </div>
                    <button class="filter-clear-button" (click)="clearAssessmentLanguageFilters()">Clear</button>
                  </div>

                  <div class="filter-content-column">
                    <div class="filter-search" *ngIf="activeAssessmentLanguageFilterHeader === 'course'">
                      <input type="text" placeholder="Search courses..." class="filter-search-input"
                        [(ngModel)]="assessmentInsightCourseSearchTerm" (keyup)="filterAssessmentInsightCoursesFromApi()">
                    </div>
                    <div class="filter-search" *ngIf="activeAssessmentLanguageFilterHeader === 'customer'">
                      <input type="text" placeholder="Search customers..." class="filter-search-input"
                        [(ngModel)]="assessmentInsightCustomerSearchTerm" (keyup)="filterAssessmentInsightCustomersFromApi()">
                    </div>
                    <div class="filter-search" *ngIf="activeAssessmentLanguageFilterHeader === 'language'">
                      <input type="text" placeholder="Search languages..." class="filter-search-input"
                        [(ngModel)]="assessmentInsightLanguageSearchTerm" (keyup)="filterAssessmentInsightLanguages()">
                    </div>

                    <div class="filter-options-container">
                      <div class="filter-options-list">
                        <div *ngIf="activeAssessmentLanguageFilterHeader === 'course'" class="filter-options-group">
                          <div *ngFor="let course of filteredAssessmentInsightCourseList?.length ? filteredAssessmentInsightCourseList : allAssessmentInsightCourses"
                            >
                            <label class="filter-option-item">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="isAssessmentLanguageCourseSelected(course.course || course.name || course)"
                                (change)="toggleAssessmentLanguageFilter('course', course.course || course.name || course)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ course.course || course.name || course }}</span>
                            </label>
                          </div>
                          <div *ngIf="(filteredAssessmentInsightCourseList?.length === 0 && assessmentInsightCourseSearchTerm) || (!filteredAssessmentInsightCourseList?.length)"
                            class="no-results-message">No Data Found</div>
                        </div>

                        <div *ngIf="activeAssessmentLanguageFilterHeader === 'customer'" class="filter-options-group">
                          <div *ngFor="let customer of filteredAssessmentEvaluationCustomerList?.length ? filteredAssessmentEvaluationCustomerList : (customerMasterData?.length ? customerMasterData : customersData)"
                            >
                            <label class="filter-option-item">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="isAssessmentLanguageCustomerSelected(customer.name || customer.customer_name || customer.customer)"
                                (change)="toggleAssessmentLanguageFilter('customer', customer.name || customer.customer_name || customer.customer)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ customer.name || customer.customer_name || customer.customer }}</span>
                            </label>
                          </div>
                          <div *ngIf="(filteredAssessmentEvaluationCustomerList?.length === 0 && assessmentInsightCustomerSearchTerm) || (!filteredAssessmentEvaluationCustomerList?.length && !((customerMasterData?.length || customersData?.length)))"
                            class="no-results-message">No Data Found</div>
                        </div>

                        <div *ngIf="activeAssessmentLanguageFilterHeader === 'language'" class="filter-options-group">
                          <div *ngFor="let language of filteredAssessmentInsightLanguagesList?.length ? filteredAssessmentInsightLanguagesList : languagesData"
                            >
                            <label class="filter-option-item">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="isAssessmentLanguageLanguageSelected(language.name || language)"
                                (change)="toggleAssessmentLanguageFilter('language', language.name || language)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ language.name || language }}</span>
                            </label>
                          </div>
                          <div *ngIf="(filteredAssessmentInsightLanguagesList?.length === 0 && assessmentInsightLanguageSearchTerm) || (!filteredAssessmentInsightLanguagesList?.length && !(languagesData?.length))"
                            class="no-results-message">No Data Found</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="bar-chart-container" style="overflow: hidden !important; margin-top: 15px; position: relative;" *ngIf="showAssessmentLanguageChart && assessmentLanguageChartLabels.length > 0">
              <div class="chart-wrapper" style="position: relative; height: 280px;"><canvas id="assessmentLanguageChart"></canvas></div>
            </div>
            <div *ngIf="!showAssessmentLanguageChart || assessmentLanguageChartLabels.length === 0" class="no-data-message"><p>No assessment language data available for selected filters.</p></div>
            <div class="chart-header-new" style="margin-top: 25px;"><div class="chart-title-bottom"><div class="chart-title-section-center"><span class="analyticslabel">Assessment by Language</span></div></div></div>

            <div *ngIf="showAssessmentLanguageCompareDialog" class="compare-dialog-overlay"
              (click)="closeAssessmentLanguageCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Assessments by Language</h3>
                  <button class="compare-dialog-close" (click)="closeAssessmentLanguageCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <div class="compare-filters">
                    <div class="filter-group">
                      <label>Select Month 1:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleAssessmentLanguageCompareMonth1Dropdown()">
                          {{ selectedAssessmentLanguageCompareMonth1 ? getMonthName(selectedAssessmentLanguageCompareMonth1) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showAssessmentLanguageCompareMonth1Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedAssessmentLanguageCompareMonth1 === month.value"
                            (click)="selectAssessmentLanguageCompareMonth1(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="filter-group">
                      <label>Select Month 2:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleAssessmentLanguageCompareMonth2Dropdown()">
                          {{ selectedAssessmentLanguageCompareMonth2 ? getMonthName(selectedAssessmentLanguageCompareMonth2) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showAssessmentLanguageCompareMonth2Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedAssessmentLanguageCompareMonth2 === month.value"
                            (click)="selectAssessmentLanguageCompareMonth2(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <button class="btn-compare" (click)="loadAssessmentLanguageComparisonData()" [disabled]="!selectedAssessmentLanguageCompareMonth1 || !selectedAssessmentLanguageCompareMonth2">Compare</button>
                  </div>

                  <div class="compare-results" *ngIf="showAssessmentLanguageComparisonResults">
                    <h4 class="results-title">Comparison Results</h4>

                    <!-- Chart View Only -->
                    <div class="chart-container-comparison">
                      <canvas id="assessmentLanguageComparisonChart"></canvas>
                    </div>
                  </div>

                  <div class="no-comparison-results"
                    *ngIf="showAssessmentLanguageComparisonResults && (!currentAssessmentLanguageComparisonData.length || !compareAssessmentLanguageComparisonData.length)">
                    <p>No data available for comparison with selected period.</p>
                  </div>
                </div>

                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeAssessmentLanguageCompareDialog()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="showAssessmentLanguageTableModal" class="table-modal-overlay" (click)="closeAssessmentLanguageTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header"><h3 class="table-modal-title">Assessment by Language - Detailed Report</h3><button class="table-modal-close" (click)="closeAssessmentLanguageTableModal()">×</button></div>
                <div class="table-modal-content"><div class="modal-table-container"><table class="modal-table"><thead><tr><th>Language</th><th>Assessment Count</th></tr></thead><tbody><tr *ngFor="let label of assessmentLanguageChartLabels; let i = index"><td>{{ label }}</td><td>{{ assessmentLanguageChartValues[i] || 0 }}</td></tr></tbody></table></div></div>
                <div class="modal-table-actions"><button class="modal-export-btn secondary" (click)="exportAssessmentLanguageTableAsPDF()">Export as PDF</button></div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- Assessment Section (Only visible when "assessment" is selected) -->
    <div class="section" *ngIf="selectedViewType === 'assessment'">
      <div class="summarypone">
        <div>
          <span class="label">Assessment Planning</span>
        </div>
        <div class="summary-wrapper mt-3 mb-2">

          <div class="librarysummary">
            <div class="header-summary">
              <span class="innertitle">Candidate Insights</span>
              <!--<button class="filter-toggle-btn" (click)="toggleCandidateInsightFilterPanel($event)" style="margin-top: -17px !important;margin-left: 13px;">
                <svg width="20" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                </svg>
              </button>-->
            </div>
            <div class="boxes">
              <div class="details">
                <div class="detaileds">
                    <div class="row-items">
                      <span class="title-rows" ><mat-icon style="margin-top: -2px;">person</mat-icon>Candidates assessed</span>
                      <span class="count">{{ getDisplayTotalAttempts() }}</span>
                    </div>
                </div>
                <div class="detaileds">
                    <div class="row-items">
                      <span class="title-rows" ><mat-icon style="margin-top: -2px;">check_circle</mat-icon>Pass:</span>
                      <span class="count">{{ getDisplayTotalPassCandidates() }}</span>
                    </div>
                </div>
                <div class="detaileds">
                    <div class="row-items">
                      <span class="title-rows" ><mat-icon style="margin-top: -2px;">cancel</mat-icon>Fail:</span>
                      <span class="count" style="color: red;">{{ getDisplayTotalFailCandidates() }}</span>
                    </div>
                </div>
                <div class="detaileds" style="background-color: transparent;border: none;margin-top: -10px;margin-left: -10px;">
                    <div class="row-items">
                      <span class="title-rows" ><span style="color: red;">{{ getDisplayTotalReassessedCandidates() }}</span> Reassessed</span>
                    </div>
                </div>
              </div>
              <div class="detailed-item-divide">
                <div class="detailed-c">
                  <div class="row-item-s">
                    <div *ngIf="showCandidateInsightsDonutChart" style="flex: 1; min-height: 140px; max-width: 140px;">
                      <canvas id="candidateInsightsChart" style="display: block;"></canvas>
                    </div>
                  </div>
                </div>
                <!--<div class="detailed-arrow">
                  <div class="trend-indicator-box" 
                    *ngIf="getPlannedAssessmentsTrendDirection() !== 'neutral'">
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'down'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                      <path d="M10.614013888888888 10.612652777777777c-0.48176944444444436 0 -0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221s0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221h4.354988888888888c0.48176944444444436 0 0.8709972222222221 -0.389225 0.8709972222222221 -0.8709972222222221V7.128661111111111c0 -0.48176944444444436 -0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222221s-0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221v2.250986111111111L9.48716111111111 4.771525c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0L5.388027777777777 7.63765 1.6481805555555553 3.900527777777778c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0s-0.34023333333333333 0.8927722222222222 0 1.2330055555555555l4.354988888888888 4.354988888888888c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l2.8688499999999997 -2.8688499999999997 3.9929777777777775 3.992980555555555h-2.250983333333333Z" fill="#ef4444" stroke-width="0.0278"></path>
                    </svg>
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'up'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                      <path d="M5.385986111111112 5.387347222222222c0.48176944444444436 0 0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221s-0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222222221H1.031998823c-0.48176944444444436 0 -0.8709972222222221 0.389225 -0.8709972222222221 0.8709972222222221v7.737679555555556c0 0.48176944444444436 0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221s0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221v-2.250986111111111l1.126688888888889 1.126688888888889c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l4.099 -4.099 3.739947222222223 3.739947222222223c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0s0.34023333333333333 -0.8927722222222222 0 -1.2330055555555555l-4.354988888888888 -4.354988888888888c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0l-2.8688499999999997 2.8688499999999997 -3.9929777777777775 -3.992980555555556h2.250983333333333Z" fill="#10b981" stroke-width="0.0278"></path>
                    </svg>
                    
                    <span class="trend-percentage">{{ getPlannedAssessmentsTrendPercentage() }}% executed vs last month</span>
                  </div>
                </div>-->
              </div>
              
            </div>
            <div class="legends-visibility">
              <div class="legend-item">
                <span class="legend-color" style="background-color: #005068;"></span>
                <span class="legend-title" style="margin-top: 10px !important;">Pass</span>
              </div>
              <div class="legend-item">
                <span class="legend-color" style="background-color: #C71E1D;"></span>
                <span class="legend-title" style="margin-top: 10px !important;">Fail</span>
              </div>
              <div class="legend-item" style="display: flex; align-items: center; gap: 20px;">
                 <div style="display: flex; align-items: center;">
                  <span style="width: 12px; height: 12px; background-color: #A0A0FF; border-radius: 50%; display: inline-block; margin-right: 5px;"></span>
                  <span>Reassessed</span>
                </div>
                <div style="display: flex; align-items: center; gap: 4px;" *ngIf="getReassessedCandidatesTrendDirection() !== 'neutral'" class="indicator-trend">
                  <svg *ngIf="getReassessedCandidatesTrendDirection() === 'down'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                    <path d="M10.614013888888888 10.612652777777777c-0.48176944444444436 0 -0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221s0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221h4.354988888888888c0.48176944444444436 0 0.8709972222222221 -0.389225 0.8709972222222221 -0.8709972222222221V7.128661111111111c0 -0.48176944444444436 -0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222221s-0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221v2.250986111111111L9.48716111111111 4.771525c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0L5.388027777777777 7.63765 1.6481805555555553 3.900527777777778c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0s-0.34023333333333333 0.8927722222222222 0 1.2330055555555555l4.354988888888888 4.354988888888888c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l2.8688499999999997 -2.8688499999999997 3.9929777777777775 3.992980555555555h-2.250983333333333Z" fill="#ef4444" stroke-width="0.0278"></path>
                  </svg>
                  <svg *ngIf="getReassessedCandidatesTrendDirection() === 'up'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                    <path d="M5.385986111111112 5.387347222222222c0.48176944444444436 0 0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221s-0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222222221H1.031998823c-0.48176944444444436 0 -0.8709972222222221 0.389225 -0.8709972222222221 0.8709972222222221v7.737679555555556c0 0.48176944444444436 0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221s0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221v-2.250986111111111l1.126688888888889 1.126688888888889c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l4.099 -4.099 3.739947222222223 3.739947222222223c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0s0.34023333333333333 -0.8927722222222222 0 -1.2330055555555555l-4.354988888888888 -4.354988888888888c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0l-2.8688499999999997 2.8688499999999997 -3.9929777777777775 -3.992980555555556h2.250983333333333Z" fill="#10b981" stroke-width="0.0278"></path>
                  </svg>
                  <span class="trend-percentage">{{ getReassessedCandidatesTrendPercentage() }}% vs last month</span>
                </div>
              </div>
              <!--<div class="legend-item" style="display: none;">
                <div class="trend-indicator-box" 
                  *ngIf="getReassessedCandidatesTrendDirection() !== 'neutral'">
                  <svg *ngIf="getReassessedCandidatesTrendDirection() === 'down'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                    <path d="M10.614013888888888 10.612652777777777c-0.48176944444444436 0 -0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221s0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221h4.354988888888888c0.48176944444444436 0 0.8709972222222221 -0.389225 0.8709972222222221 -0.8709972222222221V7.128661111111111c0 -0.48176944444444436 -0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222221s-0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221v2.250986111111111L9.48716111111111 4.771525c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0L5.388027777777777 7.63765 1.6481805555555553 3.900527777777778c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0s-0.34023333333333333 0.8927722222222222 0 1.2330055555555555l4.354988888888888 4.354988888888888c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l2.8688499999999997 -2.8688499999999997 3.9929777777777775 3.992980555555555h-2.250983333333333Z" fill="#ef4444" stroke-width="0.0278"></path>
                  </svg>
                  <svg *ngIf="getReassessedCandidatesTrendDirection() === 'up'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                    <path d="M5.385986111111112 5.387347222222222c0.48176944444444436 0 0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221s-0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222222221H1.031998823c-0.48176944444444436 0 -0.8709972222222221 0.389225 -0.8709972222222221 0.8709972222222221v7.737679555555556c0 0.48176944444444436 0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221s0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221v-2.250986111111111l1.126688888888889 1.126688888888889c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l4.099 -4.099 3.739947222222223 3.739947222222223c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0s0.34023333333333333 -0.8927722222222222 0 -1.2330055555555555l-4.354988888888888 -4.354988888888888c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0l-2.8688499999999997 2.8688499999999997 -3.9929777777777775 -3.992980555555556h2.250983333333333Z" fill="#10b981" stroke-width="0.0278"></path>
                  </svg>
                  
                  <span class="trend-percentage">{{ getReassessedCandidatesTrendPercentage() }}% vs last month</span>
                </div>
              </div>-->
            </div>
            <!-- Candidate Insights Filter Panel -->
          <div class="filter-panel-container" style="margin-right: 60px;" [class.active]="showCandidateInsightFilterPanel">
            <div class="filter-panel">
              <div class="filter-columns-container">
                <!-- Left Column - Filter Headers -->
                <div class="filter-headers-column">
                  <!-- Filter Header with Icon -->
                  <div class="filter-headers-header">
                    <mat-icon class="filter-icon">tune</mat-icon>
                    <span class="filter-title">Filter</span>
                  </div>
                  
                  <div class="filter-headers-list">
                    <div *ngFor="let header of candidateInsightFilterHeaders; let i = index" 
                      class="filter-header-item" 
                      [class.active]="activeCandidateInsightFilterHeader === header.key">
                      <label class="filter-header-checkbox-label" [for]="'candidate-insight-header-' + i">
                        <input type="checkbox" class="filter-checkbox-input" 
                          [id]="'candidate-insight-header-' + i"
                          [checked]="activeCandidateInsightFilterHeader === header.key"
                          (click)="setActiveCandidateInsightFilterHeader(header.key)"
                          (change)="setActiveCandidateInsightFilterHeader(header.key)"
                          style="display: none;">
                        <span class="filter-checkmark"></span>
                        <span class="filter-header-name">{{ header.name }}</span>
                      </label>
                    </div>
                  </div>
                  
                  <!-- Clear Button -->
                  <button class="filter-clear-button" (click)="clearCandidateInsightFilters()">
                    Clear
                  </button>
                </div>

                <!-- Right Column - Filter Content -->
                <div class="filter-content-column">
                  <!-- Search Input -->
                  <div class="filter-search" *ngIf="activeCandidateInsightFilterHeader === 'courses'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search courses" 
                        [(ngModel)]="candidateInsightCourseSearchTerm"
                        (keyup)="filterCandidateInsightCoursesFromApi()">
                    </div>

                  <div class="filter-search" *ngIf="activeCandidateInsightFilterHeader === 'geography'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search geography" 
                        [(ngModel)]="candidateInsightFilterSearchTerm"
                        (keyup)="filterCandidateInsightGeography()">
                    </div>

                  <!-- Search Input - Customer -->
                  <div class="filter-search" *ngIf="activeCandidateInsightFilterHeader === 'customer'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search customer" 
                        [(ngModel)]="candidateInsightCustomerSearchTerm"
                        (keyup)="filterCandidateInsightCustomersFromApi()">
                    </div>

                  <!-- Date Range Selector -->
                  <div class="filter-search" *ngIf="activeCandidateInsightFilterHeader === 'date'">
                    <div class="date-dropdown-row">
                      <button class="dropdown-btny" type="button" (click)="toggleCandidateInsightYearDropdown()">
                        {{ selectedCandidateInsightYearRange }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showCandidateInsightYearDropdown">
                        <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                          [class.active]="selectedCandidateInsightYearRange === yearRange.value"
                          (click)="selectCandidateInsightYearRange(yearRange.value)">
                          {{ yearRange.display }}
                        </button>
                      </div>
                    </div>

                    <div class="date-dropdown-row" style="margin-top: 10px;">
                      <button class="dropdown-btny" type="button" (click)="toggleCandidateInsightMonthDropdown()">
                        {{ selectedCandidateInsightMonth ? getMonthName(selectedCandidateInsightMonth) : 'All Months' }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showCandidateInsightMonthDropdown">
                        <button *ngFor="let month of availableMonths" class="dropdown-item"
                          [class.active]="selectedCandidateInsightMonth === month.value"
                          (click)="selectCandidateInsightMonth(month.value)">
                          {{ month.name }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Filter Options - Courses -->
                  <div class="filter-options-container" style="margin-top: 5px;" *ngIf="activeCandidateInsightFilterHeader === 'courses'">
                    <div class="filter-options-list">
                      <label class="filter-option-item" *ngFor="let course of filteredCandidateInsightCourseApiList" >
                        <input type="checkbox" class="filter-checkbox-input" 
                          [checked]="selectedCandidateInsightCourseValues.includes(course.name)"
                          (change)="toggleCandidateInsightFilter('courses', course.name)">
                        <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                        <span class="filter-option-name">{{ course.name }}</span>
                      </label>
                    </div>
                  </div>

                  <!-- Filter Options - Geography -->
                  <div class="filter-options-container" *ngIf="activeCandidateInsightFilterHeader === 'geography'">
                    <div class="filter-options-list">
                      <label class="filter-option-item" *ngFor="let geo of filteredCandidateInsightGeographyList" >
                        <input type="checkbox" class="filter-checkbox-input" 
                          [checked]="selectedCandidateInsightGeographyValues.includes(geo.state)"
                          (change)="toggleCandidateInsightFilter('geography', geo.state)">
                        <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                        <span class="filter-option-name">{{ geo.state }}</span>
                      </label>
                    </div>
                  </div>

                  <!-- Filter Options - Customer -->
                  <div class="filter-options-container" *ngIf="activeCandidateInsightFilterHeader === 'customer'">
                    <div class="filter-options-list">
                      <label class="filter-option-item" *ngFor="let customer of filteredCandidateInsightCustomerApiList">
                        <input type="checkbox" class="filter-checkbox-input" 
                          [checked]="selectedCandidateInsightCustomerValues.includes(customer.name)"
                          (change)="toggleCandidateInsightFilter('customer', customer.name)">
                        <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                        <span class="filter-option-name">{{ customer.name }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>

          

          <!--<div class="librarysummary">
            <span class="innertitle">Assessment Status</span>
            <div class="details">
              <div class="row-item">
                <span>Published</span>
                <span class="count">{{ getDisplayAssessmentPublish() }}</span>
              </div>

              <div class="row-item">
                <span>Draft</span>
                <span class="count">{{ getDisplayAssessmentDraft() }}</span>
              </div>
            </div>
          </div>

          <div class="librarysummary">
            <span class="innertitle">Candidate Status</span>
            <div class="details">
              <div class="row-item">
                <span>Active Candidates</span>
                <span class="count">{{ getDisplayCandidateActive() }}</span>
              </div>

              <div class="row-item">
                <span>Inactive Candidates</span>
                <span class="count">{{ getDisplayCandidateInactive() }}</span>
              </div>
            </div>
          </div>-->

          <div class="librarysummary">
            <div class="header-summary">
              <span class="innertitle">Assessment Insights</span>
              <button class="filter-toggle-btn" (click)="toggleAssessmentInsightFilterPanel($event)" style="margin-top: -17px !important;margin-left: 13px;">
                <svg width="20" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                </svg>
              </button>
            </div>
            <div class="boxes">
              <div class="details">
                <div class="detailed">
                  <div class="row-item">
                    <span class="title-row">Planned: </span>
                    <span class="count">{{ getDisplayTotalPlannedAssessments() }}</span>
                  </div>
                </div>
                <div class="detailed">
                  <div class="row-item">
                    <span class="title-row">Executed: </span>
                    <span class="count">{{ getDisplayTotalExecutedAssessments() }}</span>
                  </div>
                </div>
                <div class="detailed">
                  <div class="row-item">
                    <span class="title-row">Evaluated: </span>
                    <span class="count">{{ getDisplayTotalEvaluatedAssessments() }}</span>
                  </div>
                </div>
                <div class="detailed">
                  <div class="row-item">
                    <span class="title-row">Published: </span>
                    <span class="count">{{ getDisplayAssessmentPublish() }}</span>
                  </div>
                </div>
              </div>
              <div class="detailed-item-divide">
                <div class="detailed-s">
                  <div class="row-item-s">
                    <span class="title-row">Planned for this month: </span>
                    <span class="count-s">{{ getDisplayCurrentMonthPlannedAssessments() }}</span>
                  </div>
                  <!--<div class="trend-indicator-box" 
                    *ngIf="getPlannedAssessmentsTrendDirection() !== 'neutral'">
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'down'" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M7 10l5 5 5-5z"/>
                    </svg>
                    <span class="trend-percentage">{{ getPlannedAssessmentsTrendPercentage() }}% executed vs last month</span>
                  </div>-->
                </div>
                <div class="detailed-s">
                  <div class="row-item-s">
                    <span class="title-row">Planned for next month: </span>
                    <span class="count-s">{{ getDisplayNextMonthPlannedAssessments() }}</span>
                  </div>
                </div>
                <div class="detailed-arrow">
                  <div class="trend-indicator-box" 
                    *ngIf="getPlannedAssessmentsTrendDirection() !== 'neutral'">
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'down'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                      <path d="M10.614013888888888 10.612652777777777c-0.48176944444444436 0 -0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221s0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221h4.354988888888888c0.48176944444444436 0 0.8709972222222221 -0.389225 0.8709972222222221 -0.8709972222222221V7.128661111111111c0 -0.48176944444444436 -0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222221s-0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221v2.250986111111111L9.48716111111111 4.771525c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0L5.388027777777777 7.63765 1.6481805555555553 3.900527777777778c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0s-0.34023333333333333 0.8927722222222222 0 1.2330055555555555l4.354988888888888 4.354988888888888c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l2.8688499999999997 -2.8688499999999997 3.9929777777777775 3.992980555555555h-2.250983333333333Z" fill="#ef4444" stroke-width="0.0278"></path>
                    </svg>
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'up'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                      <path d="M5.385986111111112 5.387347222222222c0.48176944444444436 0 0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221s-0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222222221H1.031998823c-0.48176944444444436 0 -0.8709972222222221 0.389225 -0.8709972222222221 0.8709972222222221v7.737679555555556c0 0.48176944444444436 0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221s0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221v-2.250986111111111l1.126688888888889 1.126688888888889c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l4.099 -4.099 3.739947222222223 3.739947222222223c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0s0.34023333333333333 -0.8927722222222222 0 -1.2330055555555555l-4.354988888888888 -4.354988888888888c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0l-2.8688499999999997 2.8688499999999997 -3.9929777777777775 -3.992980555555556h2.250983333333333Z" fill="#10b981" stroke-width="0.0278"></path>
                    </svg>
                    
                    <span class="trend-percentage">{{ getPlannedAssessmentsTrendPercentage() }}% executed vs last month</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- Assessment Insights Filter Panel -->
          <div class="filter-panel-container" style="margin-right: 60px;margin-top: 0px;" [class.active]="showAssessmentInsightFilterPanel">
            <div class="filter-panel">
              <div class="filter-columns-container">
                <!-- Left Column - Filter Headers -->
                <div class="filter-headers-column">
                  <!-- Filter Header with Icon -->
                  <div class="filter-headers-header">
                    <mat-icon class="filter-icon">tune</mat-icon>
                    <span class="filter-title">Filter</span>
                  </div>
                  
                  <div class="filter-headers-list">
                    <div *ngFor="let header of assessmentInsightFilterHeaders; let i = index" 
                      class="filter-header-item" 
                      [class.active]="activeAssessmentInsightFilterHeader === header.key">
                      <label class="filter-header-checkbox-label" [for]="'assessment-insight-header-' + i">
                        <input type="checkbox" class="filter-checkbox-input" 
                          [id]="'assessment-insight-header-' + i"
                          [checked]="activeAssessmentInsightFilterHeader === header.key"
                          (click)="activeAssessmentInsightFilterHeader = header.key"
                          (change)="activeAssessmentInsightFilterHeader = header.key"
                          style="display: none;">
                        <span class="filter-checkmark"></span>
                        <span class="filter-header-name">{{ header.name }}</span>
                      </label>
                    </div>
                  </div>
                  
                  <!-- Clear Button -->
                  <button class="filter-clear-button" (click)="clearAssessmentInsightFilters()">
                    Clear
                  </button>
                </div>

                <!-- Right Column - Filter Content -->
                <div class="filter-content-column">
                  <!--<div class="filter-content-header">
                    <h4>{{ activeAssessmentInsightFilterHeader === 'language' ? 'Languages' : activeAssessmentInsightFilterHeader === 'courses' ? 'Courses' : 'Customer Names' }}</h4>
                    <div class="filter-actions">
                      <button class="filter-action-btn" (click)="clearAssessmentInsightFilters()">Clear</button>
                      <button class="filter-action-btn" (click)="showAssessmentInsightFilterPanel = false">Done</button>
                    </div>
                  </div>-->

                  <!-- Search Input -->
                  <div class="filter-search" *ngIf="activeAssessmentInsightFilterHeader === 'courses'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search courses" 
                        [(ngModel)]="assessmentInsightCourseSearchTerm"
                        (keyup)="filterAssessmentInsightCoursesFromApi()">
                    </div>



                  <!-- Search Input - Customer -->
                  <div class="filter-search" *ngIf="activeAssessmentInsightFilterHeader === 'customer'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search customer" 
                        [(ngModel)]="assessmentInsightCustomerSearchTerm"
                        (keyup)="filterAssessmentInsightCustomersFromApi()">
                    </div>



                  <!-- Filter Options - Courses -->
                  <div class="filter-options-container" style="margin-top: 5px;" *ngIf="activeAssessmentInsightFilterHeader === 'courses'">
                    
                    <div class="filter-options-list">
                      <label class="filter-option-item" *ngFor="let course of filteredAssessmentInsightCourseApiList" >
                        <input type="checkbox" class="filter-checkbox-input" 
                          [checked]="selectedAssessmentInsightCourseValues.includes(course.name)"
                          (change)="toggleAssessmentInsightFilter('course', course.name)">
                        <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                        <span class="filter-option-name">{{ course.name }}</span>
                      </label>
                    </div>
                  </div>



                  <!-- Filter Options - Customer -->
                  <div class="filter-options-container" *ngIf="activeAssessmentInsightFilterHeader === 'customer'">
                    <div class="filter-options-list">
                      <label class="filter-option-item" *ngFor="let customer of filteredAssessmentInsightCustomerApiList">
                        <input type="checkbox" class="filter-checkbox-input" 
                          [checked]="selectedAssessmentInsightCustomerValues.includes(customer.name)"
                          (change)="toggleAssessmentInsightFilter('customer', customer.name)">
                        <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                        <span class="filter-option-name">{{ customer.name }}</span>
                      </label>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
          </div>

          

        </div>

      </div>
      <div class="summary-section" style="margin-top: 40px;">
        <div class="summary-header">
          <h2 class="summary-title">Analytics Snapshot</h2>
        </div>
      </div>
      <div class="section-content">
        <!-- Show message when no filter is applied -->
        <div *ngIf="!isFilterApplied()" class="no-filter-message">
          <p>Please select a date range to view assessment data</p>
        </div>

        <!-- Assessment charts will be added here -->
        <div class="charts-grid" *ngIf="isFilterApplied()">

          <!-- Geographic Insights - Interactive India Map -->
          <div class="geographic-insights-section">
            <!-- HEADER ROW: Title + Filter Icon -->
            <div class="geo-header">
              <div class="geo-title-left">
                <span class="analyticslabel">Geographic Insights</span>
              </div>
              <button class="geo-filter-btn filter-toggle-btn" (click)="toggleGeographicInsightFilterPanel($event)">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v2.586a1 1 0 0 1-.293.707l-6.414 6.414a1 1 0 0 0-.293.707V17l-4 4v-6.586a1 1 0 0 0-.293-.707L3.293 7.293A1 1 0 0 1 3 6.586V4z"></path>
                </svg>
              </button>
            </div>

            <div class="filter-panel-container" style="margin-right: 70px; margin-top: -35px;" [class.active]="showGeographicInsightFilterPanel">
              <div class="filter-panel">
                <div class="filter-columns-container">
                  <div class="filter-headers-column">
                    <div class="filter-headers-header">
                      <mat-icon class="filter-icon">tune</mat-icon>
                      <span class="filter-title">Filter</span>
                    </div>
                    <div class="filter-headers-list">
                      <ng-container *ngFor="let header of geographicInsightFilterHeaders; let i = index">
                        <div class="filter-header-item" 
                          [class.active]="activeGeographicInsightFilterHeader === header.key">
                          <label class="filter-header-checkbox-label" [for]="'geographic-insight-header-' + i">
                            <input type="checkbox" class="filter-checkbox-input" 
                              [id]="'geographic-insight-header-' + i"
                              [checked]="activeGeographicInsightFilterHeader === header.key"
                              (click)="setActiveGeographicInsightFilterHeader(header.key)"
                              (change)="setActiveGeographicInsightFilterHeader(header.key)"
                              style="display: none;">
                            <span class="filter-checkmark"></span>
                            <span class="filter-header-name">{{ header.name }}</span>
                          </label>
                        </div>
                      </ng-container>
                    </div>
                    <button class="filter-clear-button" (click)="clearGeographicInsightFilters()">
                      Clear
                    </button>
                  </div>
                  <div class="filter-content-column">
                    <div class="filter-search" *ngIf="activeGeographicInsightFilterHeader === 'courses'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search courses" 
                        [(ngModel)]="geographicInsightCourseSearchTerm"
                        (keyup)="filterGeographicInsightCoursesFromApi()">
                    </div>
                    <div class="filter-search" *ngIf="activeGeographicInsightFilterHeader === 'geography'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search geography" 
                        [(ngModel)]="geographicInsightFilterSearchTerm"
                        (keyup)="filterGeographicInsightGeography()">
                    </div>
                    <div class="filter-search" *ngIf="activeGeographicInsightFilterHeader === 'customer'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search customer" 
                        [(ngModel)]="geographicInsightCustomerSearchTerm"
                        (keyup)="filterGeographicInsightCustomersFromApi()">
                    </div>
                    <div class="filter-search" *ngIf="activeGeographicInsightFilterHeader === 'date'">
                      <div class="date-dropdown-row">
                        <button class="dropdown-btny" type="button" (click)="toggleGeographicInsightYearDropdown()">
                          {{ selectedGeographicInsightYearRange }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showGeographicInsightYearDropdown">
                          <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                            [class.active]="selectedGeographicInsightYearRange === yearRange.value"
                            (click)="selectGeographicInsightYearRange(yearRange.value)">
                            {{ yearRange.display }}
                          </button>
                        </div>
                      </div>
                      <div class="date-dropdown-row" style="margin-top: 10px;">
                        <button class="dropdown-btny" type="button" (click)="toggleGeographicInsightMonthDropdown()">
                          {{ selectedGeographicInsightMonth ? getMonthName(selectedGeographicInsightMonth) : 'All Months' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showGeographicInsightMonthDropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedGeographicInsightMonth === month.value"
                            (click)="selectGeographicInsightMonth(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="filter-options-container" style="margin-top: 5px;" *ngIf="activeGeographicInsightFilterHeader === 'courses'">
                      <div class="filter-options-list">
                        <label class="filter-option-item" *ngFor="let course of filteredGeographicInsightCourseApiList" >
                          <input type="checkbox" class="filter-checkbox-input" 
                            [checked]="selectedGeographicInsightCourseValues.includes(course.name)"
                            (change)="toggleGeographicInsightSelection(selectedGeographicInsightCourseValues, course.name)">
                          <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                          <span class="filter-option-name">{{ course.name }}</span>
                        </label>
                      </div>
                    </div>
                    <div class="filter-options-container" *ngIf="activeGeographicInsightFilterHeader === 'geography'">
                      <div class="filter-options-list">
                        <label class="filter-option-item" *ngFor="let geo of filteredGeographicInsightGeographyList" >
                          <input type="checkbox" class="filter-checkbox-input" 
                            [checked]="selectedGeographicInsightGeographyValues.includes(geo.state)"
                            (change)="toggleGeographicInsightSelection(selectedGeographicInsightGeographyValues, geo.state)">
                          <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                          <span class="filter-option-name">{{ geo.state }}</span>
                        </label>
                      </div>
                    </div>
                    <div class="filter-options-container" *ngIf="activeGeographicInsightFilterHeader === 'customer'">
                      <div class="filter-options-list">
                        <label class="filter-option-item" *ngFor="let customer of filteredGeographicInsightCustomerApiList">
                          <input type="checkbox" class="filter-checkbox-input" 
                            [checked]="selectedGeographicInsightCustomerValues.includes(customer.name)"
                            (change)="toggleGeographicInsightSelection(selectedGeographicInsightCustomerValues, customer.name)">
                          <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                          <span class="filter-option-name">{{ customer.name }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- GEOGRAPHIC INSIGHTS BAR CHART -->
            <div id="geographicInsightsMapContainer" class="geo-map-container" style="background-color: #F5FAF6; padding: 15px; border-radius: 8px;">
              <!-- Candidate/Assessment Toggle Buttons -->
              <div class="geo-controls-row" style="display: flex; justify-content: flex-start; gap: 10px; margin-bottom: 15px;">
                <button class="geo-tab-btn" 
                  [class.active]="selectedGeographicInsightsFilter === 'candidates'"
                  (click)="selectedGeographicInsightsFilter = 'candidates'; initializeGeographicChart()"
                  style="padding: 8px 16px; border-radius: 20px; border: none; background: #F5FAF6; cursor: pointer; font-weight: 600; transition: all 0.2s; font-size: 14px; color: #333;"
                  [style.background-color]="selectedGeographicInsightsFilter === 'candidates' ? '#999999' : '#F5FAF6'"
                  [style.color]="selectedGeographicInsightsFilter === 'candidates' ? '#fff' : '#555'">
                  Candidates
                </button>
                <button class="geo-tab-btn" 
                  [class.active]="selectedGeographicInsightsFilter === 'assessments'"
                  (click)="selectedGeographicInsightsFilter = 'assessments'; initializeGeographicChart()"
                  style="padding: 8px 16px; border-radius: 20px; border: none; background: #F5FAF6; cursor: pointer; font-weight: 600; transition: all 0.2s; font-size: 14px; color: #333;"
                  [style.background-color]="selectedGeographicInsightsFilter === 'assessments' ? '#999999' : '#F5FAF6'"
                  [style.color]="selectedGeographicInsightsFilter === 'assessments' ? '#fff' : '#555'">
                  Assessments
                </button>
              </div>

              <div class="" style="overflow: hidden !important; margin-top: -5px; position: relative;">
                <div class="chart-wrapper" style="position: relative; height: 280px;background-color: #F5F6F6;">
                  <canvas id="geographicInsightsBarChart"></canvas>
                </div>
              </div>
              <div *ngIf="!showGeographicInsightsChart" class="no-data-message">
                <p>No geographic insights data available for the selected filters.</p>
              </div>
            </div>          
        </div>
          <!-- Assessments by Course/Job Role Chart -->
          <div class="chart-container">
            <!-- TOP ROW: Month/Year + Filter + Three-dot -->
            <div class="chart-filters-row">
              <div class="month-year-filters">
                <div class="filter-group">
                  <div class="year-dropdown">
                    <button class="dropdown-btny" style="width: 80px !important;"
                      (click)="toggleAssessmentCourseYearDropdown()">
                      {{ selectedAssessmentCourseYearRange }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showAssessmentCourseYearDropdown">
                      <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                        [class.active]="selectedAssessmentCourseYearRange === yearRange.value"
                        (click)="selectAssessmentCourseYearRange(yearRange.value)">
                        {{ yearRange.display }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="filter-group">
                  <div class="month-dropdown">
                    <button class="dropdown-btny" style="width: 100px !important;"
                      (click)="toggleAssessmentCourseMonthDropdown()">
                      {{ getMonthName(selectedAssessmentCourseMonth) }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showAssessmentCourseMonthDropdown">
                      <button *ngFor="let month of availableMonths" class="dropdown-item"
                        [class.active]="selectedAssessmentCourseMonth === month.value"
                        (click)="selectAssessmentCourseMonth(month.value)">
                        {{ month.name }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="chart-actions-right">
                <div class="filter-button-container ">
                  <button class="filter-toggle-btn" 
                    (click)="toggleAssessmentCourseFilterPanel($event)">
                    <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                    </svg>
                  </button>
                </div>

                <div class="chart-menu-container chart-menu-button">
                  <button class="chart-menu-btn" (click)="toggleAssessmentCourseChartMenu()">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <circle cx="12" cy="6" r="2"></circle>
                      <circle cx="12" cy="12" r="2"></circle>
                      <circle cx="12" cy="18" r="2"></circle>
                    </svg>
                  </button>

                  <div class="chart-menu-dropdown" [class.show]="showAssessmentCourseChartMenu">
                    <button class="chart-menu-close-btn" (click)="showAssessmentCourseChartMenu = false">×</button>
                    <button class="chart-menu-item" (click)="openAssessmentCourseTableModal()">
                      <span>Show as Table</span>
                    </button>
                    <button class="chart-menu-item" (click)="openAssessmentCourseCompareDialog()">
                      <span>Compare</span>
                    </button>
                    <div class="menu-item-with-submenu" (mouseenter)="showAssessmentCourseDownloadSubMenu = true"
                      (mouseleave)="showAssessmentCourseDownloadSubMenu = false">
                      <button class="chart-menu-item submenu-trigger">
                        <span>Download</span>
                          <span class="submenu-arrow">›</span>
                      </button>
                      <div class="submenu" [class.show]="showAssessmentCourseDownloadSubMenu">
                        <button class="chart-menu-close-btn" (click)="showAssessmentCourseDownloadSubMenu = false">×</button>
                        <button class="submenu-item"
                          (click)="exportAssessmentCourseAsPDF(); showAssessmentCourseChartMenu = false;">
                          <span>Export as PDF</span>
                        </button>
                        <button class="submenu-item"
                          (click)="exportAssessmentCourseAsPNG(); showAssessmentCourseChartMenu = false;">
                          <span>Export as PNG</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Filter Panel -->
            <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showAssessmentCourseFilterPanel">
              <div class="filter-panel">
                <div class="filter-columns-container">
                  <!-- Left Column - Filter Headers -->
                  <div class="filter-headers-column">
                    <!-- Filter Header with Icon -->
                    <div class="filter-headers-header">
                      <mat-icon class="filter-icon">tune</mat-icon>
                      <span class="filter-title">Filter</span>
                    </div>
                    
                    <div class="filter-headers-list">
                      <div *ngFor="let header of assessmentCourseFilterHeaders; let i = index" 
                        class="filter-header-item" 
                        [class.active]="activeAssessmentCourseFilterHeader === header.key">
                        <label class="filter-header-checkbox-label" [for]="'assessment-course-header-' + i">
                          <input type="checkbox" class="filter-checkbox-input" 
                            [id]="'assessment-course-header-' + i"
                            [checked]="activeAssessmentCourseFilterHeader === header.key"
                            (click)="activeAssessmentCourseFilterHeader = header.key"
                            (change)="activeAssessmentCourseFilterHeader = header.key"
                            style="display: none;">
                          <span class="filter-checkmark"></span>
                          <span class="filter-header-name">{{ header.name }}</span>
                        </label>
                      </div>
                    </div>
                    
                    <!-- Clear Button -->
                    <button class="filter-clear-button" (click)="clearAssessmentCourseFilters()">
                      Clear
                    </button>
                  </div>

                  <!-- Right Column - Filter Content -->
                  <div class="filter-content-column">
                    <div class="filter-search" *ngIf="activeAssessmentCourseFilterHeader === 'course'">
                      <input type="text" placeholder="Search courses..." class="filter-search-input"
                        [(ngModel)]="assessmentCourseSearchTerm" (input)="filterAssessmentCourses()">
                    </div>
                    <div class="filter-search" *ngIf="activeAssessmentCourseFilterHeader === 'geography'">
                      <input type="text" placeholder="Search states..." class="filter-search-input"
                        [(ngModel)]="assessmentCourseGeographySearchTerm" (input)="filterAssessmentCourseGeographies()">
                    </div>
                    <div class="filter-search" *ngIf="activeAssessmentCourseFilterHeader === 'customer'">
                      <input type="text" placeholder="Search customers..." class="filter-search-input"
                        [(ngModel)]="assessmentCourseCustomerSearchTerm" (input)="filterAssessmentCourseCustomers()">
                    </div>
                    <div class="filter-search" *ngIf="activeAssessmentCourseFilterHeader === 'language'">
                      <input type="text" placeholder="Search languages..." class="filter-search-input"
                        [(ngModel)]="assessmentCourseLanguageSearchTerm" (input)="filterAssessmentCourseLanguages()">
                    </div>

                    <div class="filter-options-container" style="margin-top: 5px;">
                      <div class="filter-options-list">
                        <div *ngIf="activeAssessmentCourseFilterHeader === 'course'" class="filter-options-group">
                          <div *ngFor="let course of filteredAssessmentCourseList?.length ? filteredAssessmentCourseList : allAssessmentCourses">
                            <label class="filter-option-item">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="selectedAssessmentCourseFilterValues.includes(course.course_id)"
                                (change)="toggleCourseSelectionForAssessment($event, course.course_id)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ course.course }}</span>
                            </label>
                          </div>

                          <div *ngIf="(filteredAssessmentCourseList?.length === 0 && assessmentCourseSearchTerm) || (!filteredAssessmentCourseList?.length && !(allAssessmentCourses?.length))"
                            class="no-results-message">
                            No Data Found
                          </div>
                        </div>

                        <div *ngIf="activeAssessmentCourseFilterHeader === 'geography'">
                          <div *ngFor="let state of filteredAssessmentCourseGeographyList?.length ? filteredAssessmentCourseGeographyList : allGeographicInsightGeographies"
                           >
                            <label class="filter-option-item">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="selectedAssessmentCourseGeographyValues.includes(state.state)"
                                (change)="toggleAssessmentCourseFilter('geography', state.state)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ state.state }}</span>
                            </label>
                          </div>

                          <div *ngIf="(filteredAssessmentCourseGeographyList?.length === 0 && assessmentCourseGeographySearchTerm) || (!filteredAssessmentCourseGeographyList?.length && !(allGeographicInsightGeographies?.length))"
                            class="no-results-message">
                            No Data Found
                          </div>
                        </div>

                        <div *ngIf="activeAssessmentCourseFilterHeader === 'customer'" class="filter-options-group">
                          <div *ngFor="let customer of filteredAssessmentCourseCustomerList?.length ? filteredAssessmentCourseCustomerList : customerMasterData"
                            >
                            <label class="filter-option-item">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="selectedAssessmentCourseCustomerValues.includes(customer.name)"
                                (change)="toggleAssessmentCourseFilter('customer', customer.name)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ customer.name }}</span>
                            </label>
                          </div>

                          <div *ngIf="(filteredAssessmentCourseCustomerList?.length === 0 && assessmentCourseCustomerSearchTerm) || (!filteredAssessmentCourseCustomerList?.length && !(customerMasterData?.length))"
                            class="no-results-message">
                            No Data Found
                          </div>
                        </div>

                        <div *ngIf="activeAssessmentCourseFilterHeader === 'language'" class="filter-options-group">
                          <div *ngFor="let language of filteredAssessmentCourseLanguageList?.length ? filteredAssessmentCourseLanguageList : languagesData"
                            >
                            <label class="filter-option-item">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="selectedAssessmentCourseLanguageValues.includes(language.name)"
                                (change)="toggleAssessmentCourseFilter('language', language.name)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ language.name }}</span>
                            </label>
                          </div>

                          <div *ngIf="(filteredAssessmentCourseLanguageList?.length === 0 && assessmentCourseLanguageSearchTerm) || (!filteredAssessmentCourseLanguageList?.length && !(languagesData?.length))"
                            class="no-results-message">
                            No Data Found
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- BAR CHART AREA -->
            <div class="bar-chart-container" *ngIf="showAssessmentCourseChart && assessmentCourseChartData.length > 0">
              <div class="chart-wrapper">
                <canvas id="assessmentCourseChart"></canvas>
              </div>
              <div class="chart-legend">
                <div *ngFor="let item of assessmentCourseChartData" class="legend-item">
                  <span class="legend-color" [style.background-color]="item.color"></span>
                  <span class="legend-label">{{ item.name }}</span>
                  <span class="legend-count">{{ item.value }} ({{ getAssessmentCoursePercentage(item) }}%)</span>
                </div>
              </div>
            </div>

            <!-- NO DATA MESSAGE -->
            <div *ngIf="!showAssessmentCourseChart || assessmentCourseChartData.length === 0" class="no-data-message">
              <p>No assessment course data available for the selected filters.</p>
            </div>

            <!-- TITLE AT BOTTOM -->
            <div class="chart-header-new" style="margin-top: 10px;">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">Assessments by Course/Job Role</span>
                </div>
              </div>
            </div>

            <!-- Compare Dialog -->
            <div *ngIf="showAssessmentCourseCompareDialog" class="compare-dialog-overlay"
              (click)="closeAssessmentCourseCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Assessments by Course</h3>
                  <button class="compare-dialog-close" (click)="closeAssessmentCourseCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <div class="compare-filters">
                    <div class="filter-group">
                      <label>Select Month 1:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleAssessmentCourseCompareMonth1Dropdown()">
                          {{ selectedAssessmentCourseCompareMonth1 ? getMonthName(selectedAssessmentCourseCompareMonth1) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showAssessmentCourseCompareMonth1Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedAssessmentCourseCompareMonth1 === month.value"
                            (click)="selectAssessmentCourseCompareMonth1(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="filter-group">
                      <label>Select Month 2:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleAssessmentCourseCompareMonth2Dropdown()">
                          {{ selectedAssessmentCourseCompareMonth2 ? getMonthName(selectedAssessmentCourseCompareMonth2) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showAssessmentCourseCompareMonth2Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedAssessmentCourseCompareMonth2 === month.value"
                            (click)="selectAssessmentCourseCompareMonth2(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <button class="btn-compare" (click)="loadAssessmentCourseComparisonData()" [disabled]="!selectedAssessmentCourseCompareMonth1 || !selectedAssessmentCourseCompareMonth2">Compare</button>
                  </div>

                  <div class="compare-results" *ngIf="showAssessmentCourseComparisonResults">
                    <h4 class="results-title">Comparison Results</h4>

                    <!-- Chart View Only -->
                    <div class="chart-container-comparison">
                      <canvas id="assessmentCourseComparisonChart"></canvas>
                    </div>
                  </div>

                  <div class="no-comparison-results"
                    *ngIf="showAssessmentCourseComparisonResults && (!currentAssessmentCourseComparisonData.length || !compareAssessmentCourseComparisonData.length)">
                    <p>No data available for comparison with selected period.</p>
                  </div>
                </div>

                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeAssessmentCourseCompareDialog()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <!-- Table Modal -->
            <div *ngIf="showAssessmentCourseTableModal" class="table-modal-overlay"
              (click)="closeAssessmentCourseTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Assessments by Course - Detailed Report</h3>
                  <button class="table-modal-close" (click)="closeAssessmentCourseTableModal()">×</button>
                </div>
                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table">
                      <thead>
                        <tr>
                          <th>Course</th>
                          <th>Count</th>
                          <th>Percentage</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of assessmentCourseChartData">
                          <td>{{ item.name }}</td>
                          <td>{{ item.value }}</td>
                          <td>{{ getAssessmentCoursePercentage(item) }}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportAssessmentCourseTableAsPDF()">Export as
                    PDF</button>
                </div>
              </div>
            </div>
          </div>
          <!-- Assessments by Evaluation Status Chart -->
          <div class="chart-container">
            <!-- TOP ROW: Month/Year + Filter + Three-dot -->
            <div class="chart-filters-row">
              <div class="month-year-filters">
                <div class="filter-group">
                  <div class="year-dropdown">
                    <button class="dropdown-btny" style="width: 80px !important;"
                      (click)="toggleAssessmentEvaluationYearDropdown()">
                      {{ selectedAssessmentEvaluationYearRange }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showAssessmentEvaluationYearDropdown">
                      <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                        [class.active]="selectedAssessmentEvaluationYearRange === yearRange.value"
                        (click)="selectAssessmentEvaluationYearRange(yearRange.value)">
                        {{ yearRange.display }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="filter-group">
                  <div class="month-dropdown">
                    <button class="dropdown-btny" style="width: 100px !important;"
                      (click)="toggleAssessmentEvaluationMonthDropdown()">
                      {{ getMonthName(selectedAssessmentEvaluationMonth) }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showAssessmentEvaluationMonthDropdown">
                      <button *ngFor="let month of availableMonths" class="dropdown-item"
                        [class.active]="selectedAssessmentEvaluationMonth === month.value"
                        (click)="selectAssessmentEvaluationMonth(month.value)">
                        {{ month.name }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="chart-actions-right">
                <div class="filter-button-container">
                  <button class="filter-toggle-btn" (click)="toggleAssessmentEvaluationFilterPanel($event)">
                    <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                    </svg>
                  </button>
                </div>

                <div class="chart-menu-container">
                  <button class="chart-menu-btn" (click)="toggleAssessmentEvaluationChartMenu()">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <circle cx="12" cy="6" r="2"></circle>
                      <circle cx="12" cy="12" r="2"></circle>
                      <circle cx="12" cy="18" r="2"></circle>
                    </svg>
                  </button>

                  <div class="chart-menu-dropdown" [class.show]="showAssessmentEvaluationChartMenu">
                    <button class="chart-menu-close-btn" (click)="showAssessmentEvaluationChartMenu = false">×</button>
                    <button class="chart-menu-item" (click)="openAssessmentEvaluationTableModal()">
                      <span>Show as Table</span>
                    </button>
                    <button class="chart-menu-item" (click)="openAssessmentEvaluationCompareDialog()">
                      <span>Compare</span>
                    </button>
                    <div class="menu-item-with-submenu" (mouseenter)="showAssessmentEvaluationDownloadSubMenu = true"
                      (mouseleave)="showAssessmentEvaluationDownloadSubMenu = false">
                      <button class="chart-menu-item submenu-trigger">
                        <span>Download</span>
                          <span class="submenu-arrow">›</span>
                      </button>
                      <div class="submenu" [class.show]="showAssessmentEvaluationDownloadSubMenu">
                        <button class="chart-menu-close-btn" (click)="showAssessmentEvaluationDownloadSubMenu = false">×</button>
                        <button class="submenu-item"
                          (click)="exportAssessmentEvaluationAsPDF(); showAssessmentEvaluationChartMenu = false;">
                          <span>Export as PDF</span>
                        </button>
                        <button class="submenu-item"
                          (click)="exportAssessmentEvaluationAsPNG(); showAssessmentEvaluationChartMenu = false;">
                          <span>Export as PNG</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Filter Panel -->
            <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showAssessmentEvaluationFilterPanel">
              <div class="filter-panel">
                <div class="filter-columns-container">
                  <!-- Left Column - Filter Headers -->
                  <div class="filter-headers-column">
                    <!-- Filter Header with Icon -->
                    <div class="filter-headers-header">
                      <mat-icon class="filter-icon">tune</mat-icon>
                      <span class="filter-title">Filter</span>
                    </div>
                    
                    <div class="filter-headers-list">
                      <div *ngFor="let header of assessmentEvaluationFilterHeaders; let i = index" 
                        class="filter-header-item" 
                        [class.active]="activeAssessmentEvaluationFilterHeader === header.key">
                        <label class="filter-header-checkbox-label" [for]="'assessment-evaluation-header-' + i">
                          <input type="checkbox" class="filter-checkbox-input" 
                            [id]="'assessment-evaluation-header-' + i"
                            [checked]="activeAssessmentEvaluationFilterHeader === header.key"
                            (click)="activeAssessmentEvaluationFilterHeader = header.key"
                            (change)="activeAssessmentEvaluationFilterHeader = header.key"
                            style="display: none;">
                          <span class="filter-checkmark"></span>
                          <span class="filter-header-name">{{ header.name }}</span>
                        </label>
                      </div>
                    </div>
                    
                    <!-- Clear Button -->
                    <button class="filter-clear-button" (click)="clearAssessmentEvaluationFilters()">
                      Clear
                    </button>
                  </div>

                  <!-- Right Column - Filter Content -->
                  <div class="filter-content-column">
                    <div class="filter-search" *ngIf="activeAssessmentEvaluationFilterHeader === 'course'">
                      <input type="text" placeholder="Search courses..." class="filter-search-input"
                        [(ngModel)]="assessmentInsightCourseSearchTerm" (keyup)="filterAssessmentInsightCoursesFromApi()">
                    </div>
                    <div class="filter-search" *ngIf="activeAssessmentEvaluationFilterHeader === 'geography'">
                      <input type="text" placeholder="Search geography..." class="filter-search-input"
                        [(ngModel)]="assessmentEvaluationGeographySearchTerm" (input)="filterAssessmentEvaluationGeographies()">
                    </div>



                    <div class="filter-options-container">
                      <div class="filter-options-list">
                        <div *ngIf="activeAssessmentEvaluationFilterHeader === 'course'" class="filter-options-group">
                          <div *ngFor="let course of filteredAssessmentInsightCourseApiList"
                            class="filter-option-item">
                            <label class="filter-checkbox-label">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="isAssessmentEvaluationCourseSelected(course.name || course.course || course)"
                                (change)="toggleAssessmentEvaluationFilter('course', course.name || course.course || course)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ course.name || course.course || course }}</span>
                            </label>
                          </div>
                          <div *ngIf="(filteredAssessmentInsightCourseApiList?.length === 0 && assessmentInsightCourseSearchTerm) || (!filteredAssessmentInsightCourseApiList?.length)"
                            class="no-results-message">
                            No Data Found
                          </div>
                        </div>

                        <div *ngIf="activeAssessmentEvaluationFilterHeader === 'geography'" class="filter-options-group">
                          <div *ngFor="let geo of filteredAssessmentEvaluationGeographyList?.length ? filteredAssessmentEvaluationGeographyList : (allGeographicInsightGeographies?.length ? allGeographicInsightGeographies : geographyData)"
                            class="filter-option-item">
                            <label class="filter-checkbox-label">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="isAssessmentEvaluationGeographySelected(geo.state || geo)"
                                (change)="toggleAssessmentEvaluationFilter('geography', geo.state || geo)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ geo.state || geo }}</span>
                            </label>
                          </div>
                          <div *ngIf="(filteredAssessmentEvaluationGeographyList?.length === 0 && assessmentEvaluationGeographySearchTerm) || (!filteredAssessmentEvaluationGeographyList?.length && !((allGeographicInsightGeographies?.length || geographyData?.length)))"
                            class="no-results-message">
                            No Data Found
                          </div>
                        </div>




                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- CHART AREA -->
            <div class="doughnut-chart-container" style="overflow: hidden !important;"
              *ngIf="showAssessmentEvaluationChart && assessmentEvaluationChartData.length > 0">
              <div class="chart-wrapper">
                <canvas id="assessmentEvaluationChart"></canvas>
              </div>
              <div class="chart-legend">
                <div *ngFor="let item of assessmentEvaluationChartData" class="legend-item">
                  <span class="legend-color" [style.background-color]="item.color"></span>
                  <span class="legend-label">{{ item.name }}</span>
                  <span class="legend-count">{{ item.value }} ({{ getAssessmentEvaluationPercentage(item) }}%)</span>
                </div>
              </div>
            </div>

            <!-- NO DATA MESSAGE -->
            <div *ngIf="!showAssessmentEvaluationChart || assessmentEvaluationChartData.length === 0"
              class="no-data-message">
              <p>No assessment evaluation data available for the selected filters.</p>
            </div>

            <!-- TITLE AT BOTTOM -->
            <div class="chart-header-new" style="margin-top: 10px;">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">Assessments by Status</span>
                </div>
              </div>
            </div>

            <!-- Compare Dialog -->
            <div *ngIf="showAssessmentEvaluationCompareDialog" class="compare-dialog-overlay"
              (click)="closeAssessmentEvaluationCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Assessments by Status</h3>
                  <button class="compare-dialog-close" (click)="closeAssessmentEvaluationCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <div class="compare-filters">
                    <div class="filter-group">
                      <label>Select Month 1:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleAssessmentEvaluationCompareMonth1Dropdown()">
                          {{ selectedAssessmentEvaluationCompareMonth1 ? getMonthName(selectedAssessmentEvaluationCompareMonth1) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showAssessmentEvaluationCompareMonth1Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedAssessmentEvaluationCompareMonth1 === month.value"
                            (click)="selectAssessmentEvaluationCompareMonth1(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="filter-group">
                      <label>Select Month 2:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleAssessmentEvaluationCompareMonth2Dropdown()">
                          {{ selectedAssessmentEvaluationCompareMonth2 ? getMonthName(selectedAssessmentEvaluationCompareMonth2) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showAssessmentEvaluationCompareMonth2Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedAssessmentEvaluationCompareMonth2 === month.value"
                            (click)="selectAssessmentEvaluationCompareMonth2(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <button class="btn-compare" (click)="loadAssessmentEvaluationComparisonDataMonthWise()" [disabled]="!selectedAssessmentEvaluationCompareMonth1 || !selectedAssessmentEvaluationCompareMonth2">Compare</button>
                  </div>

                  <div class="compare-results" *ngIf="showAssessmentEvaluationComparisonResults">
                    <h4 class="results-title">Comparison Results</h4>

                    <!-- Chart View Only -->
                    <div class="chart-container-comparison" style="position: relative; height: 400px; width: 100%; margin-bottom: 20px;">
                      <canvas id="assessmentEvaluationComparisonChart"></canvas>
                    </div>
                  </div>

                  <div class="no-comparison-results"
                    *ngIf="showAssessmentEvaluationComparisonResults && (!currentAssessmentEvaluationComparisonData.length || !compareAssessmentEvaluationComparisonData.length)">
                    <p>No data available for comparison with selected period.</p>
                  </div>
                </div>

                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeAssessmentEvaluationCompareDialog()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <!-- Table Modal -->
            <div *ngIf="showAssessmentEvaluationTableModal" class="table-modal-overlay"
              (click)="closeAssessmentEvaluationTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Assessments by Evaluation Status - Detailed Report</h3>
                  <button class="table-modal-close" (click)="closeAssessmentEvaluationTableModal()">×</button>
                </div>

                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table">
                      <thead>
                        <tr>
                          <th>Evaluation Status</th>
                          <th>Count</th>
                          <th>Percentage</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of assessmentEvaluationChartData">
                          <td>{{ item.name }}</td>
                          <td>{{ item.value }}</td>
                          <td>{{ getAssessmentEvaluationPercentage(item) }}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportAssessmentEvaluationTableAsPDF()">
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Pass/Fail by Assessment Chart 
          <div *ngIf="(selectedViewType === 'assessment' || selectedViewType === 'all')">
            <div class="chart-container">
              <!-- TOP ROW: Month/Year + Filter + Three-dot 
              <div class="chart-filters-row">
                <div class="month-year-filters">
                  <div class="filter-group">
                    <div class="year-dropdown">
                      <button class="dropdown-btny" style="width: 80px !important;"
                        (click)="togglePassFailYearDropdown()">
                        {{ selectedPassFailYearRange }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showPassFailYearDropdown">
                        <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                          [class.active]="selectedPassFailYearRange === yearRange.value"
                          (click)="selectPassFailYearRange(yearRange.value)">
                          {{ yearRange.display }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="filter-group">
                    <div class="month-dropdown">
                      <button class="dropdown-btny" style="width: 100px !important;"
                        (click)="togglePassFailMonthDropdown()">
                        {{ getMonthName(selectedPassFailMonth) }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showPassFailMonthDropdown">
                        <button *ngFor="let month of availableMonths" class="dropdown-item"
                          [class.active]="selectedPassFailMonth === month.value"
                          (click)="selectPassFailMonth(month.value)">
                          {{ month.name }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="chart-actions-right">
                  <div class="filter-button-container">
                    <button class="filter-toggle-btn" (click)="togglePassFailFilterPanel($event)">
                      <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                      </svg>
                    </button>
                  </div>

                  <div class="chart-menu-container">
                    <button class="chart-menu-btn" (click)="togglePassFailChartMenu()">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <circle cx="12" cy="6" r="2"></circle>
                        <circle cx="12" cy="12" r="2"></circle>
                        <circle cx="12" cy="18" r="2"></circle>
                      </svg>
                    </button>

                    <div class="chart-menu-dropdown" [class.show]="showPassFailChartMenu">
                      <button class="chart-menu-close-btn" (click)="showPassFailChartMenu = false" style="color: black !important;">×</button>
                      <button class="chart-menu-item" (click)="openPassFailTableModal()">
                        <span>Show as Table</span>
                      </button>
                      <button class="chart-menu-item" (click)="openPassFailCompareDialog()">
                        <span>Compare</span>
                      </button>
                      <div class="menu-item-with-submenu" (mouseenter)="showPassFailDownloadSubMenu = true"
                        (mouseleave)="showPassFailDownloadSubMenu = false">
                        <button class="chart-menu-item submenu-trigger">
                          <span>Download</span>
                            <span class="submenu-arrow">›</span>
                        </button>
                        <div class="submenu" [class.show]="showPassFailDownloadSubMenu">
                          <button class="chart-menu-close-btn" (click)="showPassFailDownloadSubMenu = false">×</button>
                          <button class="submenu-item" (click)="exportPassFailAsPDF()">
                            <span>Export as PDF</span>
                          </button>
                          <button class="submenu-item" (click)="exportPassFailAsPNG()">
                            <span>Export as PNG</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Filter Panel 
              <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showPassFailFilterPanel">
                <div class="filter-panel">
                  <div class="filter-columns-container">
                    <!-- Left Column - Filter Headers 
                    <div class="filter-headers-column">
                      <!-- Filter Header with Icon 
                      <div class="filter-headers-header">
                        <mat-icon class="filter-icon">tune</mat-icon>
                        <span class="filter-title">Filter</span>
                      </div>
                      
                      <div class="filter-headers-list">
                        <div *ngFor="let header of passFailFilterHeaders; let i = index" 
                          class="filter-header-item" 
                          [class.active]="activePassFailFilterHeader === header.key">
                          <label class="filter-header-checkbox-label" [for]="'passfail-header-' + i">
                            <input type="checkbox" class="filter-checkbox-input" 
                              [id]="'passfail-header-' + i"
                              [checked]="activePassFailFilterHeader === header.key"
                              (click)="setActivePassFailFilterHeader(header.key)"
                              (change)="setActivePassFailFilterHeader(header.key)"
                              style="display: none;">
                            <span class="filter-checkmark"></span>
                            <span class="filter-header-name">{{ header.name }}</span>
                          </label>
                        </div>
                      </div>
                      
                      <!-- Clear Button 
                      <button class="filter-clear-button" (click)="clearPassFailFilters()">
                        Clear
                      </button>
                    </div>

                    <!-- Right Column - Filter Content 
                    <div class="filter-content-column">
                      <!-- Search Input - Course 
                      <div class="filter-search" *ngIf="activePassFailFilterHeader === 'course'">
                        <input type="text" placeholder="Search courses..." class="filter-search-input"
                          [(ngModel)]="passFailCourseSearchTerm" (input)="filterPassFailCourse()">
                      </div>

                      <!-- Search Input - Geography 
                      <div class="filter-search" *ngIf="activePassFailFilterHeader === 'geography'">
                        <input type="text" placeholder="Search states..." class="filter-search-input"
                          [(ngModel)]="passFailGeographySearchTerm" (input)="filterPassFailGeography()">
                      </div>

                      <!-- Search Input - Customer 
                      <div class="filter-search" *ngIf="activePassFailFilterHeader === 'customer'">
                        <input type="text" placeholder="Search customers..." class="filter-search-input"
                          [(ngModel)]="passFailCustomerSearchTerm" (input)="filterPassFailCustomer()">
                      </div>

                      <!-- Search Input - Language 
                      <div class="filter-search" *ngIf="activePassFailFilterHeader === 'language'">
                        <input type="text" placeholder="Search languages..." class="filter-search-input"
                          [(ngModel)]="passFailLanguageSearchTerm" (input)="filterPassFailLanguage()">
                      </div>

                      <!-- Filter Options - Course 
                      <div class="filter-options-container" style="margin-top: 5px;" *ngIf="activePassFailFilterHeader === 'course'">
                        <div class="filter-options-list">
                          <label class="filter-option-item" *ngFor="let course of filteredPassFailCourseList || allPassFailCourses">
                            <input type="checkbox" class="filter-checkbox-input"
                              [checked]="isPassFailCourseSelected(course)"
                              (change)="togglePassFailCourseFilter(course)">
                            <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                            <span class="filter-option-name">{{ course.course_name }}</span>
                          </label>
                          <div *ngIf="(filteredPassFailCourseList?.length === 0 && passFailCourseSearchTerm) || (!filteredPassFailCourseList?.length && !(allPassFailCourses?.length))"
                            class="no-results-message">No Data Found</div>
                        </div>
                      </div>

                      <!-- Filter Options - Geography (States) 
                      <div class="filter-options-container" *ngIf="activePassFailFilterHeader === 'geography'">
                        <div class="filter-options-list">
                          <label class="filter-option-item" *ngFor="let geography of filteredPassFailGeographyList || allPassFailGeographies">
                            <input type="checkbox" class="filter-checkbox-input"
                              [checked]="isPassFailGeographySelected(geography)"
                              (change)="togglePassFailGeographyFilter(geography)">
                            <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                            <span class="filter-option-name">{{ geography.state }}</span>
                          </label>
                          <div *ngIf="(filteredPassFailGeographyList?.length === 0 && passFailGeographySearchTerm) || (!filteredPassFailGeographyList?.length && !(allPassFailGeographies?.length))"
                            class="no-results-message">No Data Found</div>
                        </div>
                      </div>

                      <!-- Filter Options - Customer 
                      <div class="filter-options-container" *ngIf="activePassFailFilterHeader === 'customer'">
                        <div class="filter-options-list">
                          <label class="filter-option-item" *ngFor="let customer of filteredPassFailCustomerList || allPassFailCustomers">
                            <input type="checkbox" class="filter-checkbox-input"
                              [checked]="isPassFailCustomerSelected(customer)"
                              (change)="togglePassFailCustomerFilter(customer)">
                            <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                            <span class="filter-option-name">{{ customer.name }}</span>
                          </label>
                          <div *ngIf="(filteredPassFailCustomerList?.length === 0 && passFailCustomerSearchTerm) || (!filteredPassFailCustomerList?.length && !(allPassFailCustomers?.length))"
                            class="no-results-message">No Data Found</div>
                        </div>
                      </div>

                      <!-- Filter Options - Language 
                      <div class="filter-options-container" *ngIf="activePassFailFilterHeader === 'language'">
                        <div class="filter-options-list">
                          <label class="filter-option-item" *ngFor="let language of filteredPassFailLanguageList || allPassFailLanguages">
                            <input type="checkbox" class="filter-checkbox-input"
                              [checked]="isPassFailLanguageSelected(language)"
                              (change)="togglePassFailLanguageFilter(language)">
                            <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                            <span class="filter-option-name">{{ language.name }}</span>
                          </label>
                          <div *ngIf="(filteredPassFailLanguageList?.length === 0 && passFailLanguageSearchTerm) || (!filteredPassFailLanguageList?.length && !(allPassFailLanguages?.length))"
                            class="no-results-message">No Data Found</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- HORIZONTAL STACKED BAR CHART AREA 
              <div id="passFailHorizontalBarChart" class="horizontal-bar-chart-container" style="overflow: hidden !important;"
                *ngIf="showPassFailChart && passFailChartLabels.length > 0">
                <div class="chart-wrapper">
                  <canvas id="passFailChart"></canvas>
                </div>
                <div class="chart-legend" style="margin-top: 330px !important;">
                  <div class="legend-item">
                    <span class="legend-color" style="background-color: #015C96;"></span>
                    <span class="legend-label">Passed</span>
                  </div>
                  <div class="legend-item">
                    <span class="legend-color" style="background-color: #FF6F59;"></span>
                    <span class="legend-label">Failed</span>
                  </div>
                  <div class="legend-item">
                    <span class="legend-color" style="background-color: #FFDB93;"></span>
                    <span class="legend-label">Reassessed</span>
                  </div>
                </div>
              </div>

              <!-- NO DATA MESSAGE 
              <div *ngIf="!showPassFailChart || passFailChartLabels.length === 0" class="no-data-message">
                <p>No assessment data available for the selected filters.</p>
              </div>

              <!-- TITLE AT BOTTOM 
              <div class="chart-header-new" style="margin-top: 18px;">
                <div class="chart-title-bottom">
                  <div class="chart-title-section-center">
                    <span class="analyticslabel">Candidate Data by Assessment</span>
                  </div>
                </div>
              </div>

              <!-- Compare Dialog 
              <div *ngIf="showPassFailCompareDialog" class="compare-dialog-overlay"
                (click)="closePassFailCompareDialog()">
                <div class="compare-dialog" (click)="$event.stopPropagation()">
                  <div class="compare-dialog-header">
                    <h3 class="compare-dialog-title">Compare Pass/Fail by Assessment</h3>
                    <button class="compare-dialog-close" (click)="closePassFailCompareDialog()">×</button>
                  </div>

                  <div class="compare-dialog-content">
                    <div class="compare-filters">
                      <div class="filter-group">
                        <label>Select Month 1:</label>
                        <div class="month-dropdown">
                          <button class="dropdown-btny" (click)="togglePassFailCompareMonth1Dropdown()">
                            {{ selectedPassFailCompareMonth1 ? getMonthName(selectedPassFailCompareMonth1) : 'Select Month' }}
                          </button>
                          <div class="dropdown-menu" [class.show]="showPassFailCompareMonth1Dropdown">
                            <button *ngFor="let month of availableMonths" class="dropdown-item"
                              [class.active]="selectedPassFailCompareMonth1 === month.value"
                              (click)="selectPassFailCompareMonth1(month.value)">
                              {{ month.name }}
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="filter-group">
                        <label>Select Month 2:</label>
                        <div class="month-dropdown">
                          <button class="dropdown-btny" (click)="togglePassFailCompareMonth2Dropdown()">
                            {{ selectedPassFailCompareMonth2 ? getMonthName(selectedPassFailCompareMonth2) : 'Select Month' }}
                          </button>
                          <div class="dropdown-menu" [class.show]="showPassFailCompareMonth2Dropdown">
                            <button *ngFor="let month of availableMonths" class="dropdown-item"
                              [class.active]="selectedPassFailCompareMonth2 === month.value"
                              (click)="selectPassFailCompareMonth2(month.value)">
                              {{ month.name }}
                            </button>
                          </div>
                        </div>
                      </div>

                      <button class="btn-compare" (click)="loadPassFailComparisonDataMonthWise()" [disabled]="!selectedPassFailCompareMonth1 || !selectedPassFailCompareMonth2">Compare</button>
                    </div>

                    <div class="compare-results" *ngIf="showPassFailComparisonResults">
                      <h4 class="results-title">Comparison Results</h4>

                      <!-- Chart View Only 
                      <div class="chart-container-comparison" style="position: relative; height: 400px; width: 100%; margin-bottom: 20px;">
                        <canvas id="passFailComparisonChart"></canvas>
                      </div>
                    </div>

                    <div class="no-comparison-results"
                      *ngIf="showPassFailComparisonResults && (!currentPassFailComparisonData.length || !comparePassFailComparisonData.length)">
                      <p>No data available for comparison with selected period.</p>
                    </div>
                  </div>

                  <div class="compare-dialog-actions">
                    <button class="compare-action-btn secondary" (click)="closePassFailCompareDialog()">
                      Cancel
                    </button>
                  </div>
                </div>
              </div>

              <!-- Table Modal 
              <div *ngIf="showPassFailTableModal" class="table-modal-overlay" (click)="closePassFailTableModal()">
                <div class="table-modal" (click)="$event.stopPropagation()">
                  <div class="table-modal-header">
                    <h3 class="table-modal-title">Pass/Fail by Assessment - Detailed Report</h3>
                    <button class="table-modal-close" (click)="closePassFailTableModal()">×</button>
                  </div>

                  <div class="table-modal-content">
                    <div class="modal-table-container">
                      <table class="modal-table">
                        <thead>
                          <tr>
                            <th>Course</th>
                            <th>Passed</th>
                            <th>Failed</th>
                            <th>Reassessed</th>
                            <th>Total Candidates</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let label of passFailChartLabels; let i = index">
                            <td>{{ label }}</td>
                            <td>{{ passFailPassData[i] || 0 }}</td>
                            <td>{{ passFailFailData[i] || 0 }}</td>
                            <td>{{ passFailReassessedData[i] || 0 }}</td>
                            <td>{{ (passFailPassData[i] || 0) + (passFailFailData[i] || 0) + (passFailReassessedData[i] || 0) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div class="modal-table-actions">
                    <button class="modal-export-btn secondary" (click)="exportPassFailTableAsPDF()">
                      Export as PDF
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>         
          <!-- Candidates by Assessment Chart - Bar Chart by Performance 
          <div class="chart-container">
            <!-- TOP ROW: Month/Year + Pass/Fail Toggles + Filter + Three-dot 
            <div class="chart-filters-row">
              <div class="month-year-filters">
                <div class="filter-group">
                  <div class="year-dropdown">
                    <button class="dropdown-btny" style="width: 80px !important;"
                      (click)="toggleCandidateAssessmentYearDropdown()">
                      {{ selectedCandidateAssessmentYearRange }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showCandidateAssessmentYearDropdown">
                      <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                        [class.active]="selectedCandidateAssessmentYearRange === yearRange.value"
                        (click)="selectCandidateAssessmentYearRange(yearRange.value)">
                        {{ yearRange.display }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="filter-group">
                  <div class="month-dropdown">
                    <button class="dropdown-btny" style="width: 100px !important;"
                      (click)="toggleCandidateAssessmentMonthDropdown()">
                      {{ getMonthName(selectedCandidateAssessmentMonth) }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showCandidateAssessmentMonthDropdown">
                      <button *ngFor="let month of availableMonths" class="dropdown-item"
                        [class.active]="selectedCandidateAssessmentMonth === month.value"
                        (click)="selectCandidateAssessmentMonth(month.value)">
                        {{ month.name }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              

              <div class="chart-actions-right">
                <div class="filter-button-container">
                  <button class="filter-toggle-btn" (click)="toggleCandidatePerformanceFilterPanel($event)">
                    <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                    </svg>
                  </button>
                </div>

                <div class="chart-menu-container">
                  <button class="chart-menu-btn" (click)="toggleCandidateAssessmentChartMenu()">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <circle cx="12" cy="6" r="2"></circle>
                      <circle cx="12" cy="12" r="2"></circle>
                      <circle cx="12" cy="18" r="2"></circle>
                    </svg>
                  </button>

                  <div class="chart-menu-dropdown" [class.show]="showCandidateAssessmentChartMenu">
                    <button class="chart-menu-close-btn" (click)="showCandidateAssessmentChartMenu = false" style="color: black !important;">×</button>
                    <button class="chart-menu-item" (click)="openCandidateAssessmentTableModal()">
                      <span>Show as Table</span>
                    </button>
                    <button class="chart-menu-item" (click)="openCandidatePerformanceCompareDialog(); showCandidatePerformanceChartMenu = false;">
                      <span>Compare</span>
                    </button>
                    <div class="menu-item-with-submenu" (mouseenter)="showCandidateAssessmentDownloadSubMenu = true"
                      (mouseleave)="showCandidateAssessmentDownloadSubMenu = false">
                      <button class="chart-menu-item submenu-trigger">
                        <span>Download</span>
                          <span class="submenu-arrow">›</span>
                      </button>
                      <div class="submenu" [class.show]="showCandidateAssessmentDownloadSubMenu">
                        <button class="chart-menu-close-btn" (click)="showCandidateAssessmentDownloadSubMenu = false" style="color: black !important;">×</button>
                        <button class="submenu-item"
                          (click)="exportCandidateAssessmentAsPDF(); showCandidateAssessmentChartMenu = false;">
                          <span>Export as PDF</span>
                        </button>
                        <button class="submenu-item" (click)="exportCandidatePerformanceAsPNG(); showCandidatePerformanceChartMenu = false;">
                          <span>Export as PNG</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <!-- Filter Panel 
            <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showCandidatePerformanceFilterPanel">
              <div class="filter-panel">
                <div class="filter-columns-container">
                  <!-- Left Column - Filter Headers 
                  <div class="filter-headers-column">
                    <!-- Filter Header with Icon 
                    <div class="filter-headers-header">
                      <mat-icon class="filter-icon">tune</mat-icon>
                      <span class="filter-title">Filter</span>
                    </div>
                    
                    <div class="filter-headers-list">
                      <div *ngFor="let header of candidatePerformanceFilterHeaders; let i = index" 
                        class="filter-header-item" 
                        [class.active]="activeCandidatePerformanceFilterHeader === header.key">
                        <label class="filter-header-checkbox-label" [for]="'candidate-performance-header-' + i">
                          <input type="checkbox" class="filter-checkbox-input" 
                            [id]="'candidate-performance-header-' + i"
                            [checked]="activeCandidatePerformanceFilterHeader === header.key"
                            (click)="activeCandidatePerformanceFilterHeader = header.key"
                            (change)="activeCandidatePerformanceFilterHeader = header.key"
                            style="display: none;">
                          <span class="filter-checkmark"></span>
                          <span class="filter-header-name">{{ header.name }}</span>
                        </label>
                      </div>
                    </div>
                    
                    <!-- Clear Button 
                    <button class="filter-clear-button" (click)="clearCandidatePerformanceFilters()">
                      Clear
                    </button>
                  </div>

                  <!-- Right Column - Filter Content 
                  <div class="filter-content-column">
                    <!-- Search Input - Courses 
                    <div class="filter-search" *ngIf="activeCandidatePerformanceFilterHeader === 'courses'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search courses" 
                        [(ngModel)]="candidatePerformanceCourseSearchTerm"
                        (keyup)="filterCandidatePerformanceCoursesFromApi()">
                    </div>

                    <!-- Filter Options - Courses 
                    <div class="filter-options-container" style="margin-top: 5px;" *ngIf="activeCandidatePerformanceFilterHeader === 'courses'">
                      <div class="filter-options-list">
                        <label class="filter-option-item" *ngFor="let course of filteredCandidatePerformanceCourseApiList" >
                          <input type="checkbox" class="filter-checkbox-input" 
                            [checked]="selectedCandidatePerformanceCourseValues.includes(course.name)"
                            (change)="toggleCandidatePerformanceFilter('course', course)">
                          <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                          <span class="filter-option-name">{{ course.name }}</span>
                        </label>
                      </div>
                    </div>

                    <!-- Search Input - Geography 
                    <div class="filter-search" *ngIf="activeCandidatePerformanceFilterHeader === 'geography'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search geography" 
                        [(ngModel)]="candidatePerformanceGeographySearchTerm"
                        (keyup)="filterCandidatePerformanceGeographyFromApi()">
                    </div>

                    <!-- Filter Options - Geography 
                    <div class="filter-options-container" style="margin-top: 5px;" *ngIf="activeCandidatePerformanceFilterHeader === 'geography'">
                      <div class="filter-options-list">
                        <label class="filter-option-item" *ngFor="let geography of filteredCandidatePerformanceGeographyList" >
                          <input type="checkbox" class="filter-checkbox-input" 
                            [checked]="selectedCandidatePerformanceGeographyValues.includes(geography.state || geography.state_name || geography.name)"
                            (change)="toggleCandidatePerformanceFilter('geography', geography)">
                          <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                          <span class="filter-option-name">{{ geography.state || geography.state_name || geography.name }}</span>
                        </label>
                      </div>
                    </div>

                    <!-- Search Input - Customers 
                    <div class="filter-search" *ngIf="activeCandidatePerformanceFilterHeader === 'customers'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search customers" 
                        [(ngModel)]="candidatePerformanceCustomerSearchTerm"
                        (keyup)="filterCandidatePerformanceCustomersFromApi()">
                    </div>

                    <!-- Filter Options - Customers 
                    <div class="filter-options-container" style="margin-top: 5px;" *ngIf="activeCandidatePerformanceFilterHeader === 'customers'">
                      <div class="filter-options-list">
                        <label class="filter-option-item" *ngFor="let customer of filteredCandidatePerformanceCustomerApiList" >
                          <input type="checkbox" class="filter-checkbox-input" 
                            [checked]="selectedCandidatePerformanceCustomerValues.includes(customer.name)"
                            (change)="toggleCandidatePerformanceFilter('customers', customer)">
                          <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                          <span class="filter-option-name">{{ customer.name }}</span>
                        </label>
                      </div>
                    </div>

                    <!-- Search Input - Languages 
                    <div class="filter-search" *ngIf="activeCandidatePerformanceFilterHeader === 'languages'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search languages" 
                        [(ngModel)]="candidatePerformanceLanguageSearchTerm"
                        (keyup)="filterCandidatePerformanceLanguagesFromApi()">
                    </div>

                    <!-- Filter Options - Languages 
                    <div class="filter-options-container" style="margin-top: 5px;" *ngIf="activeCandidatePerformanceFilterHeader === 'languages'">
                      <div class="filter-options-list">
                        <label class="filter-option-item" *ngFor="let language of filteredCandidatePerformanceLanguageList" >
                          <input type="checkbox" class="filter-checkbox-input" 
                            [checked]="selectedCandidatePerformanceLanguageValues.includes(language.name)"
                            (change)="toggleCandidatePerformanceFilter('languages', language)">
                          <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                          <span class="filter-option-name">{{ language.name }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Pass/Fail Toggle Buttons - Controls legend & tooltip display 
              <div class="performance-toggle-group" style="display: flex; gap: 10px; align-items: center; margin: 0 10px;justify-content: flex-end;">
                <button class="performance-toggle-btn" 
                  [class.active]="candidatePerformanceSelectedToggle === 'pass'"
                  (click)="selectCandidatePerformanceToggle('pass')"
                  [style]="candidatePerformanceSelectedToggle === 'pass' ? 'background-color: #E2F0E2; color: #000000; border: 1px solid #CBD8CB;' : 'background-color: #FFFFFF; color: #000000; border: 1px solid #D1D5DB;'"
                  style="padding: 4px 22px; border-radius: 14px; cursor: pointer; font-weight: 600;">
                  Pass
                </button>
                <button class="performance-toggle-btn" 
                  [class.active]="candidatePerformanceSelectedToggle === 'fail'"
                  (click)="selectCandidatePerformanceToggle('fail')"
                  [style]="candidatePerformanceSelectedToggle === 'fail' ? 'background-color: #FBCEB1; color: #000000; border: 1px solid #EF4444;' : 'background-color: #FFFFFF; color: #000000; border: 1px solid #D1D5DB;'"
                  style="padding: 4px 22px; border-radius: 14px; cursor: pointer; font-weight: 600;">
                  Fail
                </button>
              </div>

            <!-- BAR CHART AREA 
            <div class="bar-chart-container" style="overflow: hidden !important; margin-top: 15px; position: relative;"
              *ngIf="showCandidatePerformanceChart && candidatePerformanceChartLabels.length > 0">
              <div class="chart-wrapper" style="position: relative; height: 200px;">
                <canvas id="candidatePerformanceChart" 
                  (mousemove)="onCandidatePerformanceChartHover($event)"
                  (mouseleave)="onCandidatePerformanceChartLeave()"></canvas>
              </div>
            </div>

            <!-- NO DATA MESSAGE 
            <div *ngIf="!showCandidatePerformanceChart || candidatePerformanceChartLabels.length === 0" class="no-data-message">
              <p>No candidate performance data available for the selected filters.</p>
            </div>
            <div *ngIf="showCandidatePerformanceCompareDialog" class="compare-dialog-overlay"
              (click)="closeCandidatePerformanceCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Candidate Data by Performance</h3>
                  <button class="compare-dialog-close" (click)="closeCandidatePerformanceCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <div class="compare-filters">
                    <div class="filter-group">
                      <label>Select Month 1:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleCandidatePerformanceCompareMonth1Dropdown()">
                          {{ selectedCandidatePerformanceCompareMonth1 ? getMonthName(selectedCandidatePerformanceCompareMonth1) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showCandidatePerformanceCompareMonth1Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedCandidatePerformanceCompareMonth1 === month.value"
                            (click)="selectCandidatePerformanceCompareMonth1(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="filter-group">
                      <label>Select Month 2:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleCandidatePerformanceCompareMonth2Dropdown()">
                          {{ selectedCandidatePerformanceCompareMonth2 ? getMonthName(selectedCandidatePerformanceCompareMonth2) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showCandidatePerformanceCompareMonth2Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedCandidatePerformanceCompareMonth2 === month.value"
                            (click)="selectCandidatePerformanceCompareMonth2(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <button class="btn-compare" (click)="loadCandidatePerformanceComparisonData()" 
                      [disabled]="!selectedCandidatePerformanceCompareMonth1 || !selectedCandidatePerformanceCompareMonth2">
                      Compare
                    </button>
                  </div>

                  <div class="compare-results" *ngIf="showCandidatePerformanceComparisonResults">
                    <h4 class="results-title">Comparison Results</h4>

                    <!-- Chart View Only 
                    <div class="chart-container-comparison" style="position: relative; height: 400px; width: 100%; margin-bottom: 20px;">
                      <canvas id="candidatePerformanceComparisonChart"></canvas>
                    </div>
                  </div>

                  <div class="no-comparison-results"
                    *ngIf="showCandidatePerformanceComparisonResults && (!currentCandidatePerformanceComparisonData.length || !compareCandidatePerformanceComparisonData.length)">
                    <p>No data available for comparison with selected period.</p>
                  </div>
                </div>

                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeCandidatePerformanceCompareDialog()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <!-- TITLE AT BOTTOM 
            <div class="chart-header-new" style="margin-top: 30px;">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">Candidate Data by Performance</span>
                </div>
              </div>
            </div>

            <!-- Table Modal 
            <div *ngIf="showCandidateAssessmentTableModal" class="table-modal-overlay"
              (click)="closeCandidateAssessmentTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Candidate Data by Performance - Detailed Report</h3>
                  <button class="table-modal-close" (click)="closeCandidateAssessmentTableModal()">×</button>
                </div>

                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table">
                      <thead>
                        <tr>
                          <th>Course</th>
                          <th>Total Candidates</th>
                          <th *ngIf="candidatePerformanceSelectedToggle === 'pass'">Pass Count</th>
                          <th *ngIf="candidatePerformanceSelectedToggle === 'pass'">Pass %</th>
                          <th *ngIf="candidatePerformanceSelectedToggle === 'fail'">Fail Count</th>
                          <th *ngIf="candidatePerformanceSelectedToggle === 'fail'">Fail %</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let label of candidatePerformanceChartLabels; let i = index">
                          <td>{{ label }}</td>
                          <td>{{ candidatePerformanceTotalCandidateCounts[i] || 0 }}</td>
                          <td *ngIf="candidatePerformanceSelectedToggle === 'pass'">{{ candidatePerformancePassData[i] || 0 }}</td>
                          <td *ngIf="candidatePerformanceSelectedToggle === 'pass'">
                            {{ candidatePerformanceTotalCandidateCounts[i] > 0 ? ((candidatePerformancePassData[i] || 0) / candidatePerformanceTotalCandidateCounts[i] * 100).toFixed(2) : 0 }}%
                          </td>
                          <td *ngIf="candidatePerformanceSelectedToggle === 'fail'">{{ candidatePerformanceFailData[i] || 0 }}</td>
                          <td *ngIf="candidatePerformanceSelectedToggle === 'fail'">
                            {{ candidatePerformanceTotalCandidateCounts[i] > 0 ? ((candidatePerformanceFailData[i] || 0) / candidatePerformanceTotalCandidateCounts[i] * 100).toFixed(2) : 0 }}%
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportCandidatePerformanceTableAsPDF()">
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Assessment by Customers Chart -->
          <ng-container *ngIf="canShowAssessmentCustomerChart && (selectedViewType === 'assessment' || selectedViewType === 'all')">
            <div class="chart-container">
              <!-- TOP ROW: Month/Year + Filter + Three-dot -->
            <div class="chart-filters-row">
              <div class="month-year-filters">
                <div class="filter-group">
                  <div class="year-dropdown">
                    <button class="dropdown-btny" style="width: 80px !important;"
                      (click)="toggleAssessmentCustomerYearDropdown()">
                      {{ selectedAssessmentCustomerYearRange }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showAssessmentCustomerYearDropdown">
                      <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                        [class.active]="selectedAssessmentCustomerYearRange === yearRange.value"
                        (click)="selectAssessmentCustomerYearRange(yearRange.value)">
                        {{ yearRange.display }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="filter-group">
                  <div class="month-dropdown">
                    <button class="dropdown-btny" style="width: 100px !important;"
                      (click)="toggleAssessmentCustomerMonthDropdown()">
                      {{ getMonthName(selectedAssessmentCustomerMonth) }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showAssessmentCustomerMonthDropdown">
                      <button *ngFor="let month of availableMonths" class="dropdown-item"
                        [class.active]="selectedAssessmentCustomerMonth === month.value"
                        (click)="selectAssessmentCustomerMonth(month.value)">
                        {{ month.name }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="chart-actions-right">
                <div class="filter-button-container">
                  <button class="filter-toggle-btn" (click)="toggleAssessmentCustomerFilterPanel($event)">
                    <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                    </svg>
                  </button>
                </div>

                <div class="chart-menu-container">
                  <button class="chart-menu-btn" (click)="toggleAssessmentCustomerChartMenu()">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <circle cx="12" cy="6" r="2"></circle>
                      <circle cx="12" cy="12" r="2"></circle>
                      <circle cx="12" cy="18" r="2"></circle>
                    </svg>
                  </button>

                  <!-- In the chart-actions-right section, update the chart-menu-dropdown -->
                  <div class="chart-menu-dropdown" [class.show]="showAssessmentCustomerChartMenu">
                    <button class="chart-menu-close-btn" (click)="showAssessmentCustomerChartMenu = false" style="color: black !important;">×</button>
                    <button class="chart-menu-item" (click)="openAssessmentCustomerTableModal()">
                      <span>Show as Table</span>
                    </button>
                    
                    <!-- Compare - NEW -->
                    <button class="chart-menu-item" (click)="openAssessmentCustomerCompareDialog(); showAssessmentCustomerChartMenu = false;">
                      <span>Compare</span>
                    </button>
                    
                    <!-- Download Submenu -->
                    <div class="menu-item-with-submenu" (mouseenter)="showAssessmentCustomerDownloadSubMenu = true"
                      (mouseleave)="showAssessmentCustomerDownloadSubMenu = false">
                      <button class="chart-menu-item submenu-trigger">
                        <span>Download</span>
                        <span class="submenu-arrow">›</span>
                      </button>
                      <div class="submenu" [class.show]="showAssessmentCustomerDownloadSubMenu">
                        <button class="chart-menu-close-btn" (click)="showAssessmentCustomerDownloadSubMenu = false" style="color: black !important;">×</button>
                        <button class="submenu-item"
                          (click)="exportAssessmentCustomerAsPDF(); showAssessmentCustomerChartMenu = false;">
                          <span>Export as PDF</span>
                        </button>
                        <button class="submenu-item"
                          (click)="exportAssessmentCustomerAsPNG(); showAssessmentCustomerChartMenu = false;">
                          <span>Export as PNG</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Filter Panel -->
            <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showAssessmentCustomerFilterPanel">
              <div class="filter-panel">
                <div class="filter-columns-container">
                  <!-- Left Column - Filter Headers -->
                  <div class="filter-headers-column">
                    <div class="filter-headers-header">
                      <mat-icon class="filter-icon">tune</mat-icon>
                      <span class="filter-title">Filter</span>
                    </div>
                    
                    <div class="filter-headers-list">
                      <div *ngFor="let header of assessmentCustomerFilterHeaders; let i = index" 
                        class="filter-header-item" 
                        [class.active]="activeAssessmentCustomerFilterHeader === header.key">
                        <label class="filter-header-checkbox-label" [for]="'assessment-customer-header-tab2-' + i">
                          <input type="checkbox" class="filter-checkbox-input" 
                            [id]="'assessment-customer-header-tab2-' + i"
                            [checked]="activeAssessmentCustomerFilterHeader === header.key"
                            (click)="activeAssessmentCustomerFilterHeader = header.key"
                            (change)="activeAssessmentCustomerFilterHeader = header.key"
                            style="display: none;">
                          <span class="filter-checkmark"></span>
                          <span class="filter-header-name">{{ header.name }}</span>
                        </label>
                      </div>
                    </div>
                    
                    <button class="filter-clear-button" (click)="clearAssessmentCustomerFilters()">
                      Clear
                    </button>
                  </div>

                  <!-- Right Column - Filter Content -->
                  <div class="filter-content-column">
                    <div class="filter-search" *ngIf="activeAssessmentCustomerFilterHeader === 'courses'">
                      <input type="text" placeholder="Search courses..." class="filter-search-input"
                        [(ngModel)]="assessmentCustomerCourseSearchTerm" (input)="filterAssessmentCustomerCourses()">
                    </div>
                    <div class="filter-search" *ngIf="activeAssessmentCustomerFilterHeader === 'customer'">
                      <input type="text" placeholder="Search customers..." class="filter-search-input"
                        [(ngModel)]="assessmentCustomerCustomerSearchTerm" (input)="filterAssessmentCustomerCustomers()">
                    </div>

                    <div class="filter-options-container" style="margin-top: 5px;">
                      <div class="filter-options-list">
                        
                        <div *ngIf="activeAssessmentCustomerFilterHeader === 'courses'" class="filter-options-group">
                          <div *ngFor="let course of filteredAssessmentCustomerCourseApiList?.length ? filteredAssessmentCustomerCourseApiList : allAssessmentCourses">
                            <label class="filter-option-item">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="selectedAssessmentCustomerCourseValues.includes(course.course)"
                                (change)="toggleAssessmentCustomerFilter('courses', course.course)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ course.course }}</span>
                            </label>
                          </div>
                          <div *ngIf="(filteredAssessmentCustomerCourseApiList?.length === 0 && assessmentCustomerCourseSearchTerm) || (!filteredAssessmentCustomerCourseApiList?.length && !(allAssessmentCourses?.length))"
                            class="no-results-message">
                            No Data Found
                          </div>
                        </div>

                        <div *ngIf="activeAssessmentCustomerFilterHeader === 'customer'" class="filter-options-group">
                          <div *ngFor="let customer of filteredAssessmentCustomerCustomerApiList?.length ? filteredAssessmentCustomerCustomerApiList : customerMasterData">
                            <label class="filter-option-item">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="selectedAssessmentCustomerCustomerValues.includes(customer.name)"
                                (change)="toggleAssessmentCustomerFilter('customer', customer.name)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ customer.name }}</span>
                            </label>
                          </div>
                          <div *ngIf="(filteredAssessmentCustomerCustomerApiList?.length === 0 && assessmentCustomerCustomerSearchTerm) || (!filteredAssessmentCustomerCustomerApiList?.length && !(customerMasterData?.length))"
                            class="no-results-message">
                            No Data Found
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- BAR CHART AREA -->
            <div class="bar-chart-container" style="overflow: hidden !important; margin-top: 15px; position: relative;"
              *ngIf="showAssessmentCustomerChart && assessmentCustomerChartLabels.length > 0">
              <div class="chart-wrapper" style="position: relative; height: 200px;">
                <canvas id="assessmentCustomerChart"></canvas>
              </div>
            </div>

            <!-- NO DATA MESSAGE -->
            <div *ngIf="!showAssessmentCustomerChart || assessmentCustomerChartLabels.length === 0" class="no-data-message">
              <p>No assessment customer data available for the selected filters.</p>
            </div>

            <!-- TITLE AT BOTTOM -->
              <div class="chart-header-new" style="margin-top: 30px !important;">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">Assessment by Customers</span>
                </div>
              </div>
            </div>

            <!-- Table Modal -->
            <div *ngIf="showAssessmentCustomerTableModal" class="table-modal-overlay"
              (click)="closeAssessmentCustomerTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Assessment by Customers - Detailed Report</h3>
                  <button class="table-modal-close" (click)="closeAssessmentCustomerTableModal()">×</button>
                </div>

                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table">
                      <thead>
                        <tr>
                          <th>Customer</th>
                          <th>Assessment Count</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let label of assessmentCustomerChartLabels; let i = index">
                          <td>{{ label }}</td>
                          <td>{{ assessmentCustomerChartValues[i] || 0 }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportAssessmentCustomerTableAsPDF()">
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
          </div>
          <!-- Assessment Customer Compare Dialog -->
            <div *ngIf="showAssessmentCustomerCompareDialog" class="compare-dialog-overlay"
              (click)="closeAssessmentCustomerCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Assessment by Customers</h3>
                  <button class="compare-dialog-close" (click)="closeAssessmentCustomerCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <!-- Month Selection Filters -->
                  <div class="compare-filters">
                    <!-- Month 1 -->
                    <div class="filter-group">
                      <label>Select Month 1:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleAssessmentCustomerCompareMonth1Dropdown()">
                          {{ selectedAssessmentCustomerCompareMonth1 ? getMonthName(selectedAssessmentCustomerCompareMonth1) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showAssessmentCustomerCompareMonth1Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedAssessmentCustomerCompareMonth1 === month.value"
                            (click)="selectAssessmentCustomerCompareMonth1(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Month 2 -->
                    <div class="filter-group">
                      <label>Select Month 2:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleAssessmentCustomerCompareMonth2Dropdown()">
                          {{ selectedAssessmentCustomerCompareMonth2 ? getMonthName(selectedAssessmentCustomerCompareMonth2) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showAssessmentCustomerCompareMonth2Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedAssessmentCustomerCompareMonth2 === month.value"
                            (click)="selectAssessmentCustomerCompareMonth2(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Compare Button -->
                    <button class="btn-compare" (click)="loadAssessmentCustomerComparisonData()" 
                      [disabled]="!selectedAssessmentCustomerCompareMonth1 || !selectedAssessmentCustomerCompareMonth2">
                      Compare
                    </button>
                  </div>

                  <!-- Comparison Results -->
                  <div class="compare-results" *ngIf="showAssessmentCustomerComparisonResults">
                    <h4 class="results-title">Comparison Results</h4>

                    <!-- Chart View -->
                    <div class="chart-container-comparison" style="position: relative; height: 400px; width: 100%; margin-bottom: 20px;">
                      <canvas id="assessmentCustomerComparisonChart"></canvas>
                    </div>
                  </div>
                </div>

                <!-- Dialog Actions -->
                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeAssessmentCustomerCompareDialog()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Assessment by Language Chart -->
          <div class="chart-container">
            <div class="chart-filters-row">
              <div class="month-year-filters">
                <div class="filter-group">
                  <div class="year-dropdown">
                    <button class="dropdown-btny" style="width: 80px !important;" (click)="toggleAssessmentLanguageYearDropdown()">
                      {{ selectedAssessmentLanguageYearRange }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showAssessmentLanguageYearDropdown">
                      <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                        [class.active]="selectedAssessmentLanguageYearRange === yearRange.value"
                        (click)="selectAssessmentLanguageYearRange(yearRange.value)">
                        {{ yearRange.display }}
                      </button>
                    </div>
                  </div>
                </div>
                <div class="filter-group">
                  <div class="month-dropdown">
                    <button class="dropdown-btny" style="width: 100px !important;" (click)="toggleAssessmentLanguageMonthDropdown()">
                      {{ getMonthName(selectedAssessmentLanguageMonth) }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showAssessmentLanguageMonthDropdown">
                      <button *ngFor="let month of availableMonths" class="dropdown-item"
                        [class.active]="selectedAssessmentLanguageMonth === month.value"
                        (click)="selectAssessmentLanguageMonth(month.value)">
                        {{ month.name }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="chart-actions-right">
                <div class="filter-button-container">
                  <button class="filter-toggle-btn" (click)="toggleAssessmentLanguageFilterPanel($event)">
                    <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor"><path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z"/></svg>
                  </button>
                </div>
                <div class="chart-menu-container">
                  <button class="chart-menu-btn" (click)="toggleAssessmentLanguageChartMenu()">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="6" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="18" r="2"/></svg>
                  </button>
                  <div class="chart-menu-dropdown" [class.show]="showAssessmentLanguageChartMenu">
                    <button class="chart-menu-close-btn" (click)="showAssessmentLanguageChartMenu = false" style="color: black !important;">×</button>
                    <button class="chart-menu-item" (click)="openAssessmentLanguageTableModal()">Show as Table</button>
                    <button class="chart-menu-item" (click)="openAssessmentLanguageCompareDialog()">Compare</button>
                    <div class="menu-item-with-submenu" (mouseenter)="showAssessmentLanguageDownloadSubMenu = true" (mouseleave)="showAssessmentLanguageDownloadSubMenu = false">
                      <button class="chart-menu-item submenu-trigger">Download  <span class="submenu-arrow">›</span></button>
                      <div class="submenu" [class.show]="showAssessmentLanguageDownloadSubMenu">
                        <button class="chart-menu-close-btn" (click)="showAssessmentLanguageDownloadSubMenu = false" style="color: black !important;">×</button>
                        <button class="submenu-item" (click)="exportAssessmentLanguageAsPDF(); showAssessmentLanguageChartMenu = false;">Export as PDF</button>
                        <button class="submenu-item" (click)="exportAssessmentLanguageAsPNG(); showAssessmentLanguageChartMenu = false;">Export as PNG</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showAssessmentLanguageFilterPanel">
              <div class="filter-panel">
                <div class="filter-columns-container">
                  <div class="filter-headers-column">
                    <div class="filter-headers-header">
                      <mat-icon class="filter-icon">tune</mat-icon>
                      <span class="filter-title">Filter</span>
                    </div>
                    <div class="filter-headers-list">
                      <div *ngFor="let header of assessmentLanguageFilterHeaders; let i = index"
                        class="filter-header-item"
                        [class.active]="activeAssessmentLanguageFilterHeader === header.key">
                        <label class="filter-header-checkbox-label" [for]="'assessment-language-header-' + i">
                          <input type="checkbox" class="filter-checkbox-input"
                            [id]="'assessment-language-header-' + i"
                            [checked]="activeAssessmentLanguageFilterHeader === header.key"
                            (click)="activeAssessmentLanguageFilterHeader = header.key"
                            (change)="activeAssessmentLanguageFilterHeader = header.key"
                            style="display: none;" />
                          <span class="filter-checkmark"></span>
                          <span class="filter-header-name">{{ header.name }}</span>
                        </label>
                      </div>
                    </div>
                    <button class="filter-clear-button" (click)="clearAssessmentLanguageFilters()">Clear</button>
                  </div>

                  <div class="filter-content-column">
                    <div class="filter-search" *ngIf="activeAssessmentLanguageFilterHeader === 'course'">
                      <input type="text" placeholder="Search courses..." class="filter-search-input"
                        [(ngModel)]="assessmentInsightCourseSearchTerm" (keyup)="filterAssessmentInsightCoursesFromApi()">
                    </div>
                    <div class="filter-search" *ngIf="activeAssessmentLanguageFilterHeader === 'customer'">
                      <input type="text" placeholder="Search customers..." class="filter-search-input"
                        [(ngModel)]="assessmentInsightCustomerSearchTerm" (keyup)="filterAssessmentInsightCustomersFromApi()">
                    </div>
                    <div class="filter-search" *ngIf="activeAssessmentLanguageFilterHeader === 'language'">
                      <input type="text" placeholder="Search languages..." class="filter-search-input"
                        [(ngModel)]="assessmentInsightLanguageSearchTerm" (keyup)="filterAssessmentInsightLanguages()">
                    </div>

                    <div class="filter-options-container">
                      <div class="filter-options-list">
                        <div *ngIf="activeAssessmentLanguageFilterHeader === 'course'" class="filter-options-group">
                          <div *ngFor="let course of filteredAssessmentInsightCourseList?.length ? filteredAssessmentInsightCourseList : allAssessmentInsightCourses"
                            class="filter-option-item">
                            <label class="filter-checkbox-label">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="isAssessmentLanguageCourseSelected(course.course || course.name || course)"
                                (change)="toggleAssessmentLanguageFilter('course', course.course || course.name || course)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ course.course || course.name || course }}</span>
                            </label>
                          </div>
                          <div *ngIf="(filteredAssessmentInsightCourseList?.length === 0 && assessmentInsightCourseSearchTerm) || (!filteredAssessmentInsightCourseList?.length)"
                            class="no-results-message">No Data Found</div>
                        </div>

                        <div *ngIf="activeAssessmentLanguageFilterHeader === 'customer'" class="filter-options-group">
                          <div *ngFor="let customer of filteredAssessmentEvaluationCustomerList?.length ? filteredAssessmentEvaluationCustomerList : (customerMasterData?.length ? customerMasterData : customersData)"
                            class="filter-option-item">
                            <label class="filter-checkbox-label">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="isAssessmentLanguageCustomerSelected(customer.name || customer.customer_name || customer.customer)"
                                (change)="toggleAssessmentLanguageFilter('customer', customer.name || customer.customer_name || customer.customer)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ customer.name || customer.customer_name || customer.customer }}</span>
                            </label>
                          </div>
                          <div *ngIf="(filteredAssessmentEvaluationCustomerList?.length === 0 && assessmentInsightCustomerSearchTerm) || (!filteredAssessmentEvaluationCustomerList?.length && !((customerMasterData?.length || customersData?.length)))"
                            class="no-results-message">No Data Found</div>
                        </div>

                        <div *ngIf="activeAssessmentLanguageFilterHeader === 'language'" class="filter-options-group">
                          <div *ngFor="let language of filteredAssessmentInsightLanguagesList?.length ? filteredAssessmentInsightLanguagesList : languagesData"
                            class="filter-option-item">
                            <label class="filter-checkbox-label">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="isAssessmentLanguageLanguageSelected(language.name || language)"
                                (change)="toggleAssessmentLanguageFilter('language', language.name || language)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ language.name || language }}</span>
                            </label>
                          </div>
                          <div *ngIf="(filteredAssessmentInsightLanguagesList?.length === 0 && assessmentInsightLanguageSearchTerm) || (!filteredAssessmentInsightLanguagesList?.length && !(languagesData?.length))"
                            class="no-results-message">No Data Found</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="bar-chart-container" style="overflow: hidden !important; margin-top: 15px; position: relative;" *ngIf="showAssessmentLanguageChart && assessmentLanguageChartLabels.length > 0">
              <div class="chart-wrapper" style="position: relative; height: 280px;"><canvas id="assessmentLanguageChart"></canvas></div>
            </div>
            <div *ngIf="!showAssessmentLanguageChart || assessmentLanguageChartLabels.length === 0" class="no-data-message"><p>No assessment language data available for selected filters.</p></div>
            <div class="chart-header-new" style="margin-top: 25px;"><div class="chart-title-bottom"><div class="chart-title-section-center"><span class="analyticslabel">Assessment by Language</span></div></div></div>

            <div *ngIf="showAssessmentLanguageCompareDialog" class="compare-dialog-overlay"
              (click)="closeAssessmentLanguageCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Assessments by Language</h3>
                  <button class="compare-dialog-close" (click)="closeAssessmentLanguageCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <div class="compare-filters">
                    <div class="filter-group">
                      <label>Select Month 1:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleAssessmentLanguageCompareMonth1Dropdown()">
                          {{ selectedAssessmentLanguageCompareMonth1 ? getMonthName(selectedAssessmentLanguageCompareMonth1) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showAssessmentLanguageCompareMonth1Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedAssessmentLanguageCompareMonth1 === month.value"
                            (click)="selectAssessmentLanguageCompareMonth1(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="filter-group">
                      <label>Select Month 2:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleAssessmentLanguageCompareMonth2Dropdown()">
                          {{ selectedAssessmentLanguageCompareMonth2 ? getMonthName(selectedAssessmentLanguageCompareMonth2) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showAssessmentLanguageCompareMonth2Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedAssessmentLanguageCompareMonth2 === month.value"
                            (click)="selectAssessmentLanguageCompareMonth2(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <button class="btn-compare" (click)="loadAssessmentLanguageComparisonData()" [disabled]="!selectedAssessmentLanguageCompareMonth1 || !selectedAssessmentLanguageCompareMonth2">Compare</button>
                  </div>

                  <div class="compare-results" *ngIf="showAssessmentLanguageComparisonResults">
                    <h4 class="results-title">Comparison Results</h4>

                    <!-- Chart View Only -->
                    <div class="chart-container-comparison">
                      <canvas id="assessmentLanguageComparisonChart"></canvas>
                    </div>
                  </div>

                  <div class="no-comparison-results"
                    *ngIf="showAssessmentLanguageComparisonResults && (!currentAssessmentLanguageComparisonData.length || !compareAssessmentLanguageComparisonData.length)">
                    <p>No data available for comparison with selected period.</p>
                  </div>
                </div>

                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeAssessmentLanguageCompareDialog()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="showAssessmentLanguageTableModal" class="table-modal-overlay" (click)="closeAssessmentLanguageTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header"><h3 class="table-modal-title">Assessment by Language - Detailed Report</h3><button class="table-modal-close" (click)="closeAssessmentLanguageTableModal()">×</button></div>
                <div class="table-modal-content"><div class="modal-table-container"><table class="modal-table"><thead><tr><th>Language</th><th>Assessment Count</th></tr></thead><tbody><tr *ngFor="let label of assessmentLanguageChartLabels; let i = index"><td>{{ label }}</td><td>{{ assessmentLanguageChartValues[i] || 0 }}</td></tr></tbody></table></div></div>
                <div class="modal-table-actions"><button class="modal-export-btn secondary" (click)="exportAssessmentLanguageTableAsPDF()">Export as PDF</button></div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>



    <!-- Library Section (Only visible when "library" or default is selected) -->
    <div class="section" *ngIf="selectedViewType === 'library' || selectedViewType === ''">
      <div class="summarypone">
        <div>
          <span class="label">Content Library</span>
        </div>
        <div class="summary-wrapper mt-3 mb-2">

          <!--<div class="librarysummary">
            <span class="innertitle">Question Matric</span>
            <div class="details">
              <div class="row-item">
                <span>Total Questions</span>
                <span class="count">{{ getDisplayTotalQuestions() }}</span>
              </div>

              <div class="row-item">
                <span>Active Questions</span>
                <span class="count">{{ getDisplayActiveQuestions() }}</span>
              </div>
            </div>
          </div>

          <div class="librarysummary">
            <span class="innertitle">Question Paper Matric</span>
            <div class="details">
              <div class="row-item">
                <span>Total Question Papers</span>
                <span class="count">{{ getDisplayTotalQuestionPapers() }}</span>
              </div>

              <div class="row-item">
                <span>Active Question Papers</span>
                <span class="count">{{ getDisplayActiveQuestionPapers() }}</span>
              </div>
            </div>
          </div>

          <div class="librarysummary tag-label-insights">
            <div class="tag-label-title-row">
              <span class="innertitle">Tag & Label Usage Insights</span>
            </div>
            <div class="tag-label-panels">
              <div class="tag-label-panel">
                <div class="tag-label-panel-header">Tagging</div>
                <div class="tag-label-panel-content">
                  <div class="metric-row">
                    <span>Questions tagged properly:</span>
                    <span class="metric-value">{{ getDisplayQuestionsWithTag() }}</span>
                  </div>
                  <div class="metric-row">
                    <span>Untagged Questions:</span>
                    <span class="metric-value">{{ getDisplayQuestionsWithoutTag() }}</span>
                  </div>
                </div>
                <div class="metric-trend">⬊ 2% untagged vs last month</div>
              </div>

              <div class="tag-label-panel">
                <div class="tag-label-panel-header">Labeling</div>
                <div class="tag-label-panel-content">
                  <div class="metric-row">
                    <span>Questions labeled properly:</span>
                    <span class="metric-value">{{ getDisplayQuestionsWithLabel() }}</span>
                  </div>
                  <div class="metric-row">
                    <span>Unlabeled Questions:</span>
                    <span class="metric-value">{{ getDisplayQuestionsWithoutLabel() }}</span>
                  </div>
                </div>
                <div class="metric-trend">⬊ 17% unlabeled vs last month</div>
              </div>
            </div>
          </div>-->

          <div class="librarysummary" style="overflow: hidden !important;">
            <div class="header-summary">
              <span class="innertitle">Question Paper Insights</span>
              <button class="filter-toggle-btn" (click)="toggleQuestionPaperInsightFilterPanels($event)" style="margin-top: -17px !important;margin-left: 13px;">
                <svg width="20" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                </svg>
              </button>
            </div>
            <div class="boxes">
              <div class="details">
                <div class="detaileds">
                    <div class="row-items">
                      <span class="title-rows"><mat-icon class="insight-icon insight-active" matTooltip="Total number of active questions available">question_mark</mat-icon>Active Questions</span>
                      <span class="count count-active">{{ getDisplayActiveQuestions() }}</span>
                    </div>
                </div>
                <div style="margin-bottom: -6px !important;">
                  <div class="tl-row">
                    <span class="title-rows"><mat-icon class="insight-icon insight-underperforming" style="margin-left: 4px !important;" matTooltip="Inactive questions in the question bank">question_mark</mat-icon>Inactive Questions</span>
                    <span class="count count-underperforming" style="margin-right: 3px !important;">{{ getDisplayInactiveQuestions() }}</span>
                  </div>
                </div>
                <div class="detaileds">
                    <div class="row-items">
                      <span class="title-rows"><mat-icon class="insight-icon insight-flagged" matTooltip="Questions marked as flagged">question_mark</mat-icon>Flagged Questions</span>
                      <span class="count count-flagged">{{ getDisplayQuestionPaperFlaggedQuestions() }}</span>
                    </div>
                </div>
                <div class="detaileds">
                    <div class="row-items">
                      <span class="title-rows"><mat-icon class="insight-icon insight-total" matTooltip="Total number of questions">question_mark</mat-icon>Total Questions</span>
                      <span class="count">{{ getDisplayTotalQuestions() }}</span>
                    </div>
                </div>
              </div>
              <div class="detailed-item-divide" style="margin-top: 20px;">
                <div class="detailed-c">
                  <div class="row-item-s">
                    <div [hidden]="!showQuestionPaperInsightsDonutChart" style="flex: 1; min-height: 140px; max-width: 140px;">
                      <canvas id="questionPaperInsightsChart" style="display: block;"></canvas>
                    </div>
                  </div>
                </div>
                <!--<div class="detailed-arrow">
                  <div class="trend-indicator-box" 
                    *ngIf="getPlannedAssessmentsTrendDirection() !== 'neutral'">
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'down'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                      <path d="M10.614013888888888 10.612652777777777c-0.48176944444444436 0 -0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221s0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221h4.354988888888888c0.48176944444444436 0 0.8709972222222221 -0.389225 0.8709972222222221 -0.8709972222222221V7.128661111111111c0 -0.48176944444444436 -0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222221s-0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221v2.250986111111111L9.48716111111111 4.771525c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0L5.388027777777777 7.63765 1.6481805555555553 3.900527777777778c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0s-0.34023333333333333 0.8927722222222222 0 1.2330055555555555l4.354988888888888 4.354988888888888c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l2.8688499999999997 -2.8688499999999997 3.9929777777777775 3.992980555555555h-2.250983333333333Z" fill="#ef4444" stroke-width="0.0278"></path>
                    </svg>
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'up'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                      <path d="M5.385986111111112 5.387347222222222c0.48176944444444436 0 0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221s-0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222222221H1.031998823c-0.48176944444444436 0 -0.8709972222222221 0.389225 -0.8709972222222221 0.8709972222222221v7.737679555555556c0 0.48176944444444436 0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221s0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221v-2.250986111111111l1.126688888888889 1.126688888888889c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l4.099 -4.099 3.739947222222223 3.739947222222223c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0s0.34023333333333333 -0.8927722222222222 0 -1.2330055555555555l-4.354988888888888 -4.354988888888888c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0l-2.8688499999999997 2.8688499999999997 -3.9929777777777775 -3.992980555555556h2.250983333333333Z" fill="#10b981" stroke-width="0.0278"></path>
                    </svg>
                    
                    <span class="trend-percentage">{{ getPlannedAssessmentsTrendPercentage() }}% executed vs last month</span>
                  </div>
                </div>-->
              </div>
              
            </div>
            <!-- Candidate Insights Filter Panel -->
          <div class="filter-panel-container" style="margin-right: 60px;" [class.active]="showQuestionPaperInsightFilterPanels">
           <div class="filter-panel">
              <div class="filter-columns-container">
                <!-- Left Column - Filter Headers -->
                <div class="filter-headers-column">
                  <!-- Filter Header with Icon -->
                  <div class="filter-headers-header">
                    <mat-icon class="filter-icon">tune</mat-icon>
                    <span class="filter-title">Filter</span>
                  </div>
                  
                  <div class="filter-headers-list">
                    <div *ngFor="let header of questionPaperInsightFilterHeaders; let i = index" 
                      class="filter-header-item" 
                      [class.active]="activeQuestionPaperInsightFilterHeader === header.key">
                      <label class="filter-header-checkbox-label" [for]="'question-paper-insight-header-' + i">
                        <input type="checkbox" class="filter-checkbox-input" 
                          [id]="'question-paper-insight-header-' + i"
                          [checked]="activeQuestionPaperInsightFilterHeader === header.key"
                          (click)="setActiveQuestionPaperInsightFilterHeader(header.key)"
                          (change)="setActiveQuestionPaperInsightFilterHeader(header.key)"
                          style="display: none;">
                        <span class="filter-checkmark"></span>
                        <span class="filter-header-name">{{ header.name }}</span>
                      </label>
                    </div>
                  </div>
                  
                  <!-- Clear Button -->
                  <button class="filter-clear-button" (click)="clearQuestionPaperInsightFilters()">
                    Clear
                  </button>
                </div>

                <!-- Right Column - Filter Content -->
                <div class="filter-content-column">
                  <!-- Search Input -->
                  <div class="filter-search" *ngIf="activeQuestionPaperInsightFilterHeader === 'courses'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search courses" 
                        [(ngModel)]="questionPaperInsightCourseSearchTerm"
                        (keyup)="filterQuestionPaperInsightCoursesFromApi()">
                    </div>

                  <div class="filter-search" *ngIf="activeQuestionPaperInsightFilterHeader === 'geography'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search geography" 
                        [(ngModel)]="questionPaperInsightFilterSearchTerm"
                        (keyup)="filterQuestionPaperInsightGeography()">
                    </div>

                  <!-- Search Input - Customer -->
                  <div class="filter-search" *ngIf="activeQuestionPaperInsightFilterHeader === 'customer'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search customer" 
                        [(ngModel)]="questionPaperInsightCustomerSearchTerm"
                        (keyup)="filterQuestionPaperInsightCustomersFromApi()">
                    </div>

                  <!-- Date Range Selector -->
                  <div class="filter-search" *ngIf="activeQuestionPaperInsightFilterHeader === 'date'">
                    <div class="date-dropdown-row">
                      <button class="dropdown-btny" type="button" (click)="toggleQuestionPaperInsightYearDropdown()">
                        {{ selectedQuestionPaperInsightYearRange }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showQuestionPaperInsightYearDropdown">
                        <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                          [class.active]="selectedQuestionPaperInsightYearRange === yearRange.value"
                          (click)="selectQuestionPaperInsightYearRange(yearRange.value)">
                          {{ yearRange.display }}
                        </button>
                      </div>
                    </div>

                    <div class="date-dropdown-row" style="margin-top: 10px;">
                      <button class="dropdown-btny" type="button" (click)="toggleQuestionPaperInsightMonthDropdown()">
                        {{ selectedQuestionPaperInsightMonth ? getMonthName(selectedQuestionPaperInsightMonth) : 'All Months' }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showQuestionPaperInsightMonthDropdown">
                        <button *ngFor="let month of availableMonths" class="dropdown-item"
                          [class.active]="selectedQuestionPaperInsightMonth === month.value"
                          (click)="selectQuestionPaperInsightMonth(month.value)">
                          {{ month.name }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Filter Options - Courses -->
                  <div class="filter-options-container" style="margin-top: 5px;" *ngIf="activeQuestionPaperInsightFilterHeader === 'courses'">
                    <div class="filter-options-list">
                      <label class="filter-option-item" *ngFor="let course of filteredQuestionPaperInsightCourseApiList" >
                        <input type="checkbox" class="filter-checkbox-input" 
                          [checked]="selectedQuestionPaperInsightCourseValues.includes(course.name)"
                          (change)="toggleQuestionPaperInsightFilter('courses', course.name)">
                        <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                        <span class="filter-option-name">{{ course.name }}</span>
                      </label>
                    </div>
                  </div>

                  <!-- Filter Options - Geography -->
                  <div class="filter-options-container" *ngIf="activeQuestionPaperInsightFilterHeader === 'geography'">
                    <div class="filter-options-list">
                      <label class="filter-option-item" *ngFor="let geo of filteredQuestionPaperInsightGeographyList" >
                        <input type="checkbox" class="filter-checkbox-input" 
                          [checked]="selectedQuestionPaperInsightGeographyValues.includes(geo.state)"
                          (change)="toggleQuestionPaperInsightFilter('geography', geo.state)">
                        <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                        <span class="filter-option-name">{{ geo.state }}</span>
                      </label>
                    </div>
                  </div>

                  <!-- Filter Options - Customer -->
                  <div class="filter-options-container" *ngIf="activeQuestionPaperInsightFilterHeader === 'customer'">
                    <div class="filter-options-list">
                      <label class="filter-option-item" *ngFor="let customer of filteredQuestionPaperInsightCustomerApiList">
                        <input type="checkbox" class="filter-checkbox-input" 
                          [checked]="selectedQuestionPaperInsightCustomerValues.includes(customer.name)"
                          (change)="toggleQuestionPaperInsightFilter('customer', customer.name)">
                        <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                        <span class="filter-option-name">{{ customer.name }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>

          
          <div class="tl-card">
            <div class="tl-header">Tag & Label Usage Insights</div>

            <div class="tl-body">

              <!-- TAGGING -->
              <div class="tl-block">
                <div class="tl-heading">Tagging</div>

                <div class="tl-row">
                  <span>Questions tagged properly:</span>
                  <span class="tl-num">{{ getDisplayQuestionsWithTag() }}</span>
                </div>

                <div class="tl-row">
                  <span>Untagged Questions:</span>
                  <span class="tl-num tl-red">{{ getDisplayQuestionsWithoutTag() }}</span>
                </div>

                <div class="detailed-arrow">
                  <div class="trend-indicator-box" 
                    *ngIf="getTaggingTrendDirection() !== 'neutral'">
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'down'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                      <path d="M10.614013888888888 10.612652777777777c-0.48176944444444436 0 -0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221s0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221h4.354988888888888c0.48176944444444436 0 0.8709972222222221 -0.389225 0.8709972222222221 -0.8709972222222221V7.128661111111111c0 -0.48176944444444436 -0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222221s-0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221v2.250986111111111L9.48716111111111 4.771525c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0L5.388027777777777 7.63765 1.6481805555555553 3.900527777777778c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0s-0.34023333333333333 0.8927722222222222 0 1.2330055555555555l4.354988888888888 4.354988888888888c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l2.8688499999999997 -2.8688499999999997 3.9929777777777775 3.992980555555555h-2.250983333333333Z" fill="#ef4444" stroke-width="0.0278"></path>
                    </svg>
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'up'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                      <path d="M5.385986111111112 5.387347222222222c0.48176944444444436 0 0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221s-0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222222221H1.031998823c-0.48176944444444436 0 -0.8709972222222221 0.389225 -0.8709972222222221 0.8709972222222221v7.737679555555556c0 0.48176944444444436 0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221s0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221v-2.250986111111111l1.126688888888889 1.126688888888889c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l4.099 -4.099 3.739947222222223 3.739947222222223c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0s0.34023333333333333 -0.8927722222222222 0 -1.2330055555555555l-4.354988888888888 -4.354988888888888c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0l-2.8688499999999997 2.8688499999999997 -3.9929777777777775 -3.992980555555556h2.250983333333333Z" fill="#10b981" stroke-width="0.0278"></path>
                    </svg>
                    
                    <span class="trend-percentage">{{ getPlannedAssessmentsTrendPercentage() }}% executed vs last month</span>
                  </div>
                </div>
              </div>
              <!-- LABELLING -->
              <div class="tl-block">
                <div class="tl-heading">Labelling</div>

                <div class="tl-row">
                  <span>Questions labelled properly:</span>
                  <span class="tl-num">{{ getDisplayQuestionsWithLabel() }}</span>
                </div>

                <div class="tl-row">
                  <span>Unlabelled Questions:</span>
                  <span class="tl-num tl-red">{{ getDisplayQuestionsWithoutLabel() }}</span>
                </div>

                <div class="detailed-arrow">
                  <div class="trend-indicator-box" 
                    *ngIf="getPlannedAssessmentsTrendDirection() !== 'neutral'">
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'down'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                      <path d="M10.614013888888888 10.612652777777777c-0.48176944444444436 0 -0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221s0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221h4.354988888888888c0.48176944444444436 0 0.8709972222222221 -0.389225 0.8709972222222221 -0.8709972222222221V7.128661111111111c0 -0.48176944444444436 -0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222221s-0.8709972222222221 0.38922777777777773 -0.8709972222222221 0.8709972222222221v2.250986111111111L9.48716111111111 4.771525c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0L5.388027777777777 7.63765 1.6481805555555553 3.900527777777778c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0s-0.34023333333333333 0.8927722222222222 0 1.2330055555555555l4.354988888888888 4.354988888888888c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l2.8688499999999997 -2.8688499999999997 3.9929777777777775 3.992980555555555h-2.250983333333333Z" fill="#ef4444" stroke-width="0.0278"></path>
                    </svg>
                    <svg *ngIf="getPlannedAssessmentsTrendDirection() === 'up'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="24" height="24">
                      <path d="M5.385986111111112 5.387347222222222c0.48176944444444436 0 0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221s-0.38922777777777773 -0.8709972222222221 -0.8709972222222221 -0.8709972222222221H1.031998823c-0.48176944444444436 0 -0.8709972222222221 0.389225 -0.8709972222222221 0.8709972222222221v7.737679555555556c0 0.48176944444444436 0.38922777777777773 0.8709972222222221 0.8709972222222221 0.8709972222222221s0.8709972222222221 -0.38922777777777773 0.8709972222222221 -0.8709972222222221v-2.250986111111111l1.126688888888889 1.126688888888889c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0l4.099 -4.099 3.739947222222223 3.739947222222223c0.34023333333333333 0.34023333333333333 0.8927722222222222 0.34023333333333333 1.2330055555555555 0s0.34023333333333333 -0.8927722222222222 0 -1.2330055555555555l-4.354988888888888 -4.354988888888888c-0.34023333333333333 -0.34023333333333333 -0.8927722222222222 -0.34023333333333333 -1.2330055555555555 0l-2.8688499999999997 2.8688499999999997 -3.9929777777777775 -3.992980555555556h2.250983333333333Z" fill="#10b981" stroke-width="0.0278"></path>
                    </svg>
                    
                    <span class="trend-percentage">{{ getPlannedAssessmentsTrendPercentage() }}% executed vs last month</span>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <!-- Assessment Insights Filter Panel -->
          <div class="filter-panel-container" style="margin-right: 150px;margin-top: 10px;" [class.active]="showAssessmentInsightFilterPanel">
            <div class="filter-panel">
              <div class="filter-columns-container">
                <!-- Left Column - Filter Headers -->
                <div class="filter-headers-column">
                  <!-- Filter Header with Icon -->
                  <div class="filter-headers-header">
                    <mat-icon class="filter-icon">tune</mat-icon>
                    <span class="filter-title">Filter</span>
                  </div>
                  
                  <div class="filter-headers-list">
                    <div *ngFor="let header of assessmentInsightFilterHeaders; let i = index" 
                      class="filter-header-item" 
                      [class.active]="activeAssessmentInsightFilterHeader === header.key">
                      <label class="filter-header-checkbox-label" [for]="'assessment-insight-header-' + i">
                        <input type="checkbox" class="filter-checkbox-input" 
                          [id]="'assessment-insight-header-' + i"
                          [checked]="activeAssessmentInsightFilterHeader === header.key"
                          (click)="activeAssessmentInsightFilterHeader = header.key"
                          (change)="activeAssessmentInsightFilterHeader = header.key"
                          style="display: none;">
                        <span class="filter-checkmark"></span>
                        <span class="filter-header-name">{{ header.name }}</span>
                      </label>
                    </div>
                  </div>
                  
                  <!-- Clear Button -->
                  <button class="filter-clear-button" (click)="clearAssessmentInsightFilters()">
                    Clear
                  </button>
                </div>

                <!-- Right Column - Filter Content -->
                <div class="filter-content-column">
                  <!--<div class="filter-content-header">
                    <h4>{{ activeAssessmentInsightFilterHeader === 'language' ? 'Languages' : activeAssessmentInsightFilterHeader === 'courses' ? 'Courses' : 'Customer Names' }}</h4>
                    <div class="filter-actions">
                      <button class="filter-action-btn" (click)="clearAssessmentInsightFilters()">Clear</button>
                      <button class="filter-action-btn" (click)="showAssessmentInsightFilterPanel = false">Done</button>
                    </div>
                  </div>-->

                  <!-- Search Input -->
                  <div class="filter-search" *ngIf="activeAssessmentInsightFilterHeader === 'courses'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search courses" 
                        [(ngModel)]="assessmentInsightCourseSearchTerm"
                        (keyup)="filterAssessmentInsightCoursesFromApi()">
                    </div>



                  <!-- Search Input - Customer -->
                  <div class="filter-search" *ngIf="activeAssessmentInsightFilterHeader === 'customer'">
                      <input type="text" class="filter-search-input" 
                        placeholder="Search customer" 
                        [(ngModel)]="assessmentInsightCustomerSearchTerm"
                        (keyup)="filterAssessmentInsightCustomersFromApi()">
                    </div>



                  <!-- Filter Options - Courses -->
                  <div class="filter-options-container" style="margin-top: 5px;" *ngIf="activeAssessmentInsightFilterHeader === 'courses'">
                    
                    <div class="filter-options-list">
                      <label class="filter-option-item" *ngFor="let course of filteredAssessmentInsightCourseApiList" >
                        <input type="checkbox" class="filter-checkbox-input" 
                          [checked]="selectedAssessmentInsightCourseValues.includes(course.name)"
                          (change)="toggleAssessmentInsightFilter('course', course.name)">
                        <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                        <span class="filter-option-name">{{ course.name }}</span>
                      </label>
                    </div>
                  </div>



                  <!-- Filter Options - Customer -->
                  <div class="filter-options-container" *ngIf="activeAssessmentInsightFilterHeader === 'customer'">
                    <div class="filter-options-list">
                      <label class="filter-option-item" *ngFor="let customer of filteredAssessmentInsightCustomerApiList">
                        <input type="checkbox" class="filter-checkbox-input" 
                          [checked]="selectedAssessmentInsightCustomerValues.includes(customer.name)"
                          (change)="toggleAssessmentInsightFilter('customer', customer.name)">
                        <span class="filter-checkmark" style="background: #E9ECEE;"></span>
                        <span class="filter-option-name">{{ customer.name }}</span>
                      </label>
                    </div>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
      <div class="summary-section" style="margin-top: 40px;">
        <div class="summary-header">
          <h2 class="summary-title">Analytics Snapshot</h2>
        </div>
      </div>
      <div class="section-content">
        <!-- Show message when no filter is applied -->
        <div *ngIf="!isFilterApplied()" class="no-filter-message">
          <p>Please select a date range to view question data</p>
        </div>

        <!-- Question Distribution Charts (Only show when filter is applied) -->
        <div class="charts-grid"
          *ngIf="isFilterApplied() && (selectedViewType === 'library' || selectedViewType === '')">
          <!-- Language Distribution Chart - Same Design as Difficulty Level -->
          <div class="chart-container">
            <!-- New Chart Header Structure -->

            <div class="chart-filters-row">

              <!-- Left: Month/Year Filters -->
              <div class="month-year-filters">
                <div class="filter-group">
                  <div class="year-dropdown">
                    <button class="dropdown-btny" style="width: 40px !important;"
                      (click)="toggleDifficultyYearDropdown()">
                      {{ selectedDifficultyYearRange }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showDifficultyYearDropdown">
                      <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                        [class.active]="selectedDifficultyYearRange === yearRange.value"
                        (click)="selectDifficultyYearRange(yearRange.value)">
                        {{ yearRange.display }}
                      </button>
                    </div>
                  </div>
                </div>

                <div class="filter-group">
                  <div class="month-dropdown">
                    <button class="dropdown-btny" style="width: 80px !important;"
                      (click)="toggleDifficultyMonthDropdown()">
                      {{ getMonthName(selectedDifficultyMonth) }}
                    </button>
                    <div class="dropdown-menu" [class.show]="showDifficultyMonthDropdown">
                      <button *ngFor="let month of availableMonths" class="dropdown-item"
                        [class.active]="selectedDifficultyMonth === month.value"
                        (click)="selectDifficultyMonth(month.value)">
                        {{ month.name }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Right: Filter Button + Three-dot Menu -->
              <div class="chart-actions-right">
                <!-- Filter Button -->
                <div class="filter-button-container ">
                  <button class="filter-toggle-btn"  (click)="toggleFilterPanel()">
                    <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                    </svg>
                  </button>
                </div>

                <!-- Three-dot Menu -->
                <div class="chart-menu-container chart-menu-button" >
                  <button class="chart-menu-btn" (click)="toggleChartMenu()">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <circle cx="12" cy="6" r="2"></circle>
                      <circle cx="12" cy="12" r="2"></circle>
                      <circle cx="12" cy="18" r="2"></circle>
                    </svg>
                  </button>

                  <div class="chart-menu-dropdown" [class.show]="showChartMenu">
                    <button class="chart-menu-close-btn" (click)="showChartMenu = false" style="color: black !important;">×</button>
                    <button class="chart-menu-item" (click)="showTableModal(); showChartMenu = false;">
                      <span>Show as Table</span>
                    </button>
                    <button class="chart-menu-item" (click)="openDifficultyLevelMonthCompareDialog(); showChartMenu = false;">
                      <span>Compare</span>
                    </button>
                    <div class="menu-item-with-submenu" (mouseenter)="showDownloadSubMenu = true"
                      (mouseleave)="showDownloadSubMenu = false">
                      <button class="chart-menu-item submenu-trigger">
                        <span>Download</span>
                          <span class="submenu-arrow">›</span>
                      </button>
                      <div class="submenu" [class.show]="showDownloadSubMenu">
                        <button class="chart-menu-close-btn" (click)="showDownloadSubMenu = false">×</button>
                        <button class="submenu-item" (click)="exportChartAsPDF(); showChartMenu = false;">
                          <span>Export as PDF</span>
                        </button>
                        <button class="submenu-item" (click)="exportChartAsPNG(); showChartMenu = false;">
                          <span>Export as PNG</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Filter Panel -->
            <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showFilterPanel">
              <div class="filter-panel">
                <div class="filter-columns-container">
                  <!-- Left Column - Filter Headers -->
                  <div class="filter-headers-column">
                    <!-- Filter Header with Icon -->
                    <div class="filter-headers-header">
                      <mat-icon class="filter-icon">tune</mat-icon>
                      <span class="filter-title">Filter</span>
                    </div>
                    
                    <div class="filter-headers-list">
                      <div *ngFor="let filter of filterHeaders; let i = index" 
                        class="filter-header-item" 
                        [class.active]="activeFilterHeader === filter.key">
                        <label class="filter-header-checkbox-label" [for]="'difficulty-filter-header-' + i">
                          <input type="checkbox" class="filter-checkbox-input" 
                            [id]="'difficulty-filter-header-' + i"
                            [checked]="activeFilterHeader === filter.key"
                            (click)="setActiveFilterHeader(filter.key)"
                            (change)="setActiveFilterHeader(filter.key)"
                            style="display: none;">
                          <span class="filter-checkmark"></span>
                          <span class="filter-header-name">{{ filter.name }}</span>
                        </label>
                      </div>
                    </div>
                    
                    <!-- Clear Button -->
                    <button class="filter-clear-button" (click)="clearDifficultyFilters()">
                      Clear
                    </button>
                  </div>

                  <!-- Right Column - Filter Content -->
                  <div class="filter-content-column">
                    <div class="filter-search" *ngIf="activeFilterHeader === 'courses'">
                      <input type="text" placeholder="Search courses..." class="filter-search-input"
                        [(ngModel)]="courseSearchTerm" (input)="filterCourses()">
                    </div>

                    <div class="filter-search" *ngIf="activeFilterHeader === 'difficulty'">
                      <input type="text" placeholder="Search difficulty..." class="filter-search-input"
                        [(ngModel)]="difficultySearchTerm" (input)="filterDifficultyLevels()">
                    </div>

                    <div class="filter-search" *ngIf="activeFilterHeader === 'questionTypes'">
                      <input type="text" placeholder="Search question types..." class="filter-search-input"
                        [(ngModel)]="questionTypeSearchTerm" (input)="filterQuestionTypes()">
                    </div>

                    <div class="filter-search" *ngIf="activeFilterHeader === 'language'">
                      <input type="text" placeholder="Search language..." class="filter-search-input"
                        [(ngModel)]="difficultyLanguageSearchTerm" (input)="filterDifficultyLanguages()">
                    </div>

                    <div class="filter-options-container" style="margin-top: 5px;">
                      <div class="filter-options-list">

                        <!-- Difficulty Chart - Courses Section -->
                        <div *ngIf="activeFilterHeader === 'courses'">
                          <div *ngFor="let course of filteredCourseList" class="filter-option-item">
                            <label class="filter-option-item">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="isCourseSelectedForDifficulty(course.course_id)"
                                (change)="toggleCourseSelectionForDifficulty(course.course_id)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ course.course_name }}</span>
                            </label>
                          </div>

                          <div *ngIf="filteredCourseList?.length === 0 && courseSearchTerm" class="no-results-message">
                            No Data Found
                          </div>
                        </div>

                        <!-- Difficulty Chart - Difficulty Levels Section -->
                        <div *ngIf="activeFilterHeader === 'difficulty'">
                          <div *ngFor="let difficulty of filteredDifficultyLevels" class="filter-option-item">
                            <label class="filter-option-item">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="isDifficultySelected(difficulty.value)"
                                (change)="toggleDifficultySelection(difficulty.value)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ difficulty.label }}</span>
                            </label>
                          </div>

                          <div *ngIf="filteredDifficultyLevels?.length === 0 && difficultySearchTerm" class="no-results-message">
                            No Data Found
                          </div>
                        </div>

                        <!-- Difficulty Chart - Question Types Section -->
                        <div *ngIf="activeFilterHeader === 'questionTypes'">

                          <div *ngFor="let type of filteredQuestionTypeList" class="filter-option-item">
                            <label class="filter-option-item">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="isQuestionTypeSelected(type.value)"
                                (change)="toggleQuestionTypeSelection(type.value)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ type.label }}</span>
                            </label>
                          </div>

                          <div *ngIf="filteredQuestionTypeList?.length === 0 && questionTypeSearchTerm" class="no-results-message">
                            No Data Found
                          </div>
                        </div>

                        <!-- Difficulty Chart - Language Section -->
                        <div *ngIf="activeFilterHeader === 'language'">
                          <div *ngFor="let language of filteredDifficultyLanguagesList" class="filter-option-item">
                            <label class="filter-option-item">
                              <input type="checkbox" class="filter-checkbox-input"
                                [checked]="selectedDifficultyLanguages.includes(language.name)"
                                (change)="toggleDifficultyLanguageFilter(language.name)">
                              <span class="filter-checkmark"></span>
                              <span class="filter-option-name">{{ language.name }}</span>
                            </label>
                          </div>

                          <div *ngIf="filteredDifficultyLanguagesList?.length === 0 && difficultyLanguageSearchTerm" class="no-results-message">
                            No Data Found
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Donut Chart Container -->
            <!-- Donut Chart Container -->
            <div class="donut-chart-container" *ngIf="showDonutChart">
              <div class="chart-wrapper">
                <canvas id="difficultyDoughnutChart"></canvas>
              </div>
              <div class="chart-legend">
                <div *ngFor="let item of difficultyChartData" class="legend-item" [class.zero-data]="item.value === 0">
                  <span class="legend-color" [style.background-color]="item.color"></span>
                  <span class="legend-label">
                    <span class="course-name" *ngIf="!shouldShowOverallDifficulty()">{{ item.courseName }} - </span>
                    {{ item.name }}
                  </span>
                  <span class="legend-count" [class.zero-count]="item.value === 0">
                    {{ item.value }} ({{ getDifficultyPercentage(item) }}%)
                  </span>
                </div>
              </div>
            </div>

            <div *ngIf="!showDonutChart" class="no-data-message">
              <p>No question data available for the selected filters.</p>
            </div>

            <div class="chart-header-new">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">{{ getDifficultyChartTitle() }}</span>
                </div>
              </div>
            </div>
            <!-- Month-wise Compare Dialog for Content Library - Difficulty Level -->
            <div *ngIf="showDifficultyLevelMonthCompareDialog" class="compare-dialog-overlay"
              (click)="closeDifficultyLevelMonthCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Questions by Difficulty Level</h3>
                  <button class="compare-dialog-close" (click)="closeDifficultyLevelMonthCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <div class="compare-filters">
                    <div class="filter-group">
                      <label>Select Month 1:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleDifficultyLevelCompareMonth1Dropdown()">
                          {{ selectedDifficultyLevelCompareMonth1 ? getMonthName(selectedDifficultyLevelCompareMonth1) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showDifficultyLevelCompareMonth1Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedDifficultyLevelCompareMonth1 === month.value"
                            (click)="selectDifficultyLevelCompareMonth1(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="filter-group">
                      <label>Select Month 2:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleDifficultyLevelCompareMonth2Dropdown()">
                          {{ selectedDifficultyLevelCompareMonth2 ? getMonthName(selectedDifficultyLevelCompareMonth2) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showDifficultyLevelCompareMonth2Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedDifficultyLevelCompareMonth2 === month.value"
                            (click)="selectDifficultyLevelCompareMonth2(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <button class="btn-compare" (click)="loadDifficultyLevelMonthComparisonData()" [disabled]="!selectedDifficultyLevelCompareMonth1 || !selectedDifficultyLevelCompareMonth2">Compare</button>
                  </div>

                  <div class="compare-results" *ngIf="showDifficultyLevelMonthComparisonResults && (currentDifficultyLevelMonthComparisonData.length > 0 || compareDifficultyLevelMonthComparisonData.length > 0)">
                    <h4 class="results-title">Comparison Results</h4>

                    <!-- Chart View Only -->
                    <div class="chart-container-comparison" style="position: relative; height: 400px; width: 100%; margin-bottom: 20px;">
                      <canvas id="difficultyLevelMonthComparisonChart"></canvas>
                    </div>
                  </div>

                  
                </div>

                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeDifficultyLevelMonthCompareDialog()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <!-- Table Modal -->
            <div *ngIf="showTableModalFlag" class="table-modal-overlay" (click)="closeTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Question Difficulty Distribution</h3>
                  <button class="table-modal-close" (click)="closeTableModal()">×</button>
                </div>

                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table">
                      <thead>
                        <tr>
                          <th>Course Name</th>
                          <th>Difficulty Level</th>
                          <th>Question Count</th>
                          <th>Percentage</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of difficultyChartData; let i = index"
                          [class.zero-data]="item.value === 0">
                          <td>{{ item.courseName }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.value }}</td>
                          <td>{{ getDifficultyPercentage(item) }}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportTableAsPDF()">
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="chart-container">
            <div>
              <div class="chart-filters-row">

                <!-- Left: Month/Year Filters -->
                <div class="month-year-filters">
                  <div class="filter-group">
                    <div class="year-dropdown">
                      <button class="dropdown-btny" style="width: 40px !important;" (click)="toggleTypeYearDropdown()">
                        {{ selectedTypeYearRange }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showTypeYearDropdown">
                        <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                          [class.active]="selectedTypeYearRange === yearRange.value"
                          (click)="selectTypeYearRange(yearRange.value)">
                          {{ yearRange.display }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="filter-group">
                    <div class="month-dropdown">
                      <button class="dropdown-btny" style="width:80px !important;" (click)="toggleTypeMonthDropdown()">
                        {{ getMonthName(selectedTypeMonth) }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showTypeMonthDropdown">
                        <button *ngFor="let month of availableMonths" class="dropdown-item"
                          [class.active]="selectedTypeMonth === month.value" (click)="selectTypeMonth(month.value)">
                          {{ month.name }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="chart-actions-right">

                  <!-- Filter Button -->
                  <div class="filter-button-container">
                    <button class="filter-toggle-btn" (click)="toggleTypeFilterPanel($event)">
                      <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                      </svg>
                    </button>
                  </div>

                  <!-- Three Dot Menu -->
                  <div class="chart-menu-container">
                    <button class="chart-menu-btn" (click)="toggleTypeChartMenu()">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <circle cx="12" cy="6" r="2"></circle>
                        <circle cx="12" cy="12" r="2"></circle>
                        <circle cx="12" cy="18" r="2"></circle>
                      </svg>
                    </button>

                    <div class="chart-menu-dropdown" [class.show]="showTypeChartMenu">
                      <button class="chart-menu-close-btn" (click)="showTypeChartMenu = false">×</button>
                      <button class="chart-menu-item" (click)="showTypeTableModal()">
                        <span>Show as Table</span>
                      </button>

                      <button class="chart-menu-item" (click)="openTypeMonthCompareDialog()">
                        <span>Compare</span>
                      </button>

                      <div class="menu-item-with-submenu" (mouseenter)="showTypeDownloadSubMenu = true"
                        (mouseleave)="showTypeDownloadSubMenu = false">

                        <button class="chart-menu-item submenu-trigger">
                          <span>Download</span>
                            <span class="submenu-arrow">›</span>
                        </button>

                        <div class="submenu" [class.show]="showTypeDownloadSubMenu">
                          <button class="chart-menu-close-btn" (click)="showTypeDownloadSubMenu = false">×</button>
                          <button class="submenu-item" (click)="exportTypeChartAsPDF(); showTypeChartMenu=false;">
                            <span>Export as PDF</span>
                          </button>
                          <button class="submenu-item" (click)="exportTypeChartAsPNG(); showTypeChartMenu=false;">
                            <span>Export as PNG</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <!-- Type Filter Panel -->
              <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showTypeFilterPanel">
                <div class="filter-panel">
                  <div class="filter-columns-container">
                    <!-- Left Column - Filter Headers -->
                    <div class="filter-headers-column">
                      <!-- Filter Header with Icon -->
                      <div class="filter-headers-header">
                        <mat-icon class="filter-icon">tune</mat-icon>
                        <span class="filter-title">Filter</span>
                      </div>
                      
                      <div class="filter-headers-list">
                        <div *ngFor="let filter of typeFilterHeaders; let i = index" 
                          class="filter-header-item" 
                          [class.active]="activeTypeFilterHeader === filter.key">
                          <label class="filter-header-checkbox-label" [for]="'type-filter-header-' + i">
                            <input type="checkbox" class="filter-checkbox-input" 
                              [id]="'type-filter-header-' + i"
                              [checked]="activeTypeFilterHeader === filter.key"
                              (click)="setActiveTypeFilterHeader(filter.key)"
                              (change)="setActiveTypeFilterHeader(filter.key)"
                              style="display: none;">
                            <span class="filter-checkmark"></span>
                            <span class="filter-header-name">{{ filter.name }}</span>
                          </label>
                        </div>
                      </div>
                      
                      <!-- Clear Button -->
                      <button class="filter-clear-button" (click)="clearTypeFilters()">
                        Clear
                      </button>
                    </div>

                    <!-- Right Column - Filter Content -->
                    <div class="filter-content-column">
                      <!-- Search for Courses -->
                      <div class="filter-search" *ngIf="activeTypeFilterHeader === 'courses'">
                        <input type="text" placeholder="Search courses..." class="filter-search-input"
                          [(ngModel)]="typeCourseSearchTerm" (input)="filterTypeCourses()">
                      </div>

                      <!-- Search for Question Types -->
                      <div class="filter-search" *ngIf="activeTypeFilterHeader === 'questionTypes'">
                        <input type="text" placeholder="Search question types..." class="filter-search-input"
                          [(ngModel)]="questionTypeSearchTerm" (input)="filterQuestionTypes()">
                      </div>

                      <!-- Search for Language -->
                      <div class="filter-search" *ngIf="activeTypeFilterHeader === 'language'">
                        <input type="text" placeholder="Search language..." class="filter-search-input"
                          [(ngModel)]="typeLanguageSearchTerm" (input)="filterTypeLanguages()">
                      </div>

                      <!-- Search for Evaluation Mode -->
                      <div class="filter-search" *ngIf="activeTypeFilterHeader === 'evaluationMode'">
                        <input type="text" placeholder="Search evaluation mode..." class="filter-search-input"
                          [(ngModel)]="typeEvaluationModeSearchTerm" (input)="filterTypeEvaluationModes()">
                      </div>

                      <div class="filter-options-container" style="margin-top: 5px;">
                        <div class="filter-options-list">
                          <!-- Type Chart - Courses Section -->
                          <div *ngIf="activeTypeFilterHeader === 'courses'" class="filter-options-group">
                            <div *ngFor="let course of filteredTypeCourseList">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="isCourseSelectedForType(course.course_id)"
                                  (change)="toggleCourseSelectionForType(course.course_id)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ course.course_name }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredTypeCourseList?.length === 0 && typeCourseSearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>

                          <!-- Type Chart - Question Types Section -->
                          <div *ngIf="activeTypeFilterHeader === 'questionTypes'">
                            <div *ngFor="let type of filteredQuestionTypeList" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="isQuestionTypeSelectedForType(type.value)"
                                  (change)="toggleQuestionTypeSelectionForType(type.value)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ type.label }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredQuestionTypeList?.length === 0 && questionTypeSearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>

                          <!-- Type Chart - Language Section -->
                          <div *ngIf="activeTypeFilterHeader === 'language'">
                            <div *ngFor="let language of filteredTypeLanguagesList" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="selectedTypeLanguages.includes(language.name)"
                                  (change)="toggleTypeLanguageFilter(language.name)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ language.name }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredTypeLanguagesList?.length === 0 && typeLanguageSearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>

                          <!-- Type Chart - Evaluation Mode Section -->
                          <div *ngIf="activeTypeFilterHeader === 'evaluationMode'">
                            <div *ngFor="let mode of filteredTypeEvaluationModesList" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="selectedTypeEvaluationModes.includes(mode)"
                                  (change)="toggleTypeEvaluationModeFilter(mode)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ mode }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredTypeEvaluationModesList?.length === 0 && typeEvaluationModeSearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>

                          <!-- Type Chart - Difficulty Level Section -->
                          <div *ngIf="activeTypeFilterHeader === 'difficultyLevel'">
                            <div *ngFor="let level of filteredTypeDifficultyLevels" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="selectedTypeDifficultyLevels.includes(level.value)"
                                  (change)="toggleTypeDifficultyLevelFilter(level.value)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ level.label }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredTypeDifficultyLevels?.length === 0 && typeDifficultyLevelSearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Type Table Modal -->
            <div *ngIf="showTypeTableModalFlag" class="table-modal-overlay" (click)="closeTypeTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Question Type Breakdown</h3>
                  <button class="table-modal-close" (click)="closeTypeTableModal()">×</button>
                </div>

                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table type-modal-table">
                      <thead>
                        <tr>
                          <th>Course Name</th>
                          <th>Question Type</th>
                          <th>Question Count</th>
                          <th>Percentage</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of typeBarChartData; let i = index" [class.zero-data]="item.value === 0">
                          <td>{{ item.courseName || 'All Courses' }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.value }}</td>
                          <td>{{ getTypePercentage(item) }}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportTypeTableAsPDF()">
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>
            <!-- Type Month Compare Dialog -->
            <div *ngIf="showTypeMonthCompareDialog" class="compare-dialog-overlay"
              (click)="closeTypeMonthCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Questions by Type</h3>
                  <button class="compare-dialog-close" (click)="closeTypeMonthCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <div class="compare-filters">
                    <div class="filter-group">
                      <label>Select Month 1:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleTypeCompareMonth1Dropdown()">
                          {{ selectedTypeCompareMonth1 ? getMonthName(selectedTypeCompareMonth1) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showTypeCompareMonth1Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedTypeCompareMonth1 === month.value"
                            (click)="selectTypeCompareMonth1(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="filter-group">
                      <label>Select Month 2:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleTypeCompareMonth2Dropdown()">
                          {{ selectedTypeCompareMonth2 ? getMonthName(selectedTypeCompareMonth2) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showTypeCompareMonth2Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedTypeCompareMonth2 === month.value"
                            (click)="selectTypeCompareMonth2(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <button class="btn-compare" (click)="loadTypeMonthComparisonData()" [disabled]="!selectedTypeCompareMonth1 || !selectedTypeCompareMonth2">Compare</button>
                  </div>

                  <div class="compare-results" *ngIf="showTypeMonthComparisonResults && (currentTypeMonthComparisonData.length > 0 || compareTypeMonthComparisonData.length > 0)">
                    <h4 class="results-title">Comparison Results</h4>

                    <!-- Chart View Only -->
                    <div class="chart-container-comparison" style="position: relative; height: 400px; width: 100%; margin-bottom: 20px;">
                      <canvas id="typeMonthComparisonChart"></canvas>
                    </div>
                  </div>

                  <div class="no-comparison-results"
                    *ngIf="showTypeMonthComparisonResults && currentTypeMonthComparisonData.length === 0 && compareTypeMonthComparisonData.length === 0">
                    <p>No data available for comparison with selected period.</p>
                  </div>
                </div>

                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeTypeMonthCompareDialog()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <!-- Type Bar Chart Container -->
            <div class="bar-chart-container type-bar-chart-container" *ngIf="showTypeBarChart">
              <div class="chart-wrapper">
                <canvas id="typeBarChart"></canvas>
              </div>
              <div class="chart-legend">
                <div *ngFor="let item of typeBarChartData" class="legend-item" [class.zero-data]="item.value === 0">
                  <span class="legend-color" [style.background-color]="item.color"></span>
                  <span class="legend-label">
                    <span class="course-name" *ngIf="!shouldShowOverallType()">{{ item.courseName }} - </span>
                    {{ item.name }}
                  </span>
                  <span class="legend-count" [class.zero-count]="item.value === 0">
                    {{ item.value }} ({{ getTypePercentage(item) }}%)
                  </span>
                </div>
              </div>
            </div>

            <div *ngIf="!showTypeBarChart" class="no-data-message" style="margin-bottom: 60px !important;">
              <p>No question paper data available for the selected filters.</p>
            </div>

            <div class="chart-header-new" style="margin-top: -30px !important;">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">Questions by Type</span>
                </div>
              </div>
            </div>

          </div>
          <div class="chart-container">
            <div>
              <div class="chart-filters-row">
                <div class="month-year-filters">
                  <div class="filter-group">
                    <div class="year-dropdown">
                      <button class="dropdown-btny" style="width: 40px !important;"
                        (click)="toggleLanguageYearDropdown()">
                        {{ selectedLanguageYearRange }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showLanguageYearDropdown">
                        <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                          [class.active]="selectedLanguageYearRange === yearRange.value"
                          (click)="selectLanguageYearRange(yearRange.value)">
                          {{ yearRange.display }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="filter-group">
                    <div class="month-dropdown">
                      <button class="dropdown-btny" style="width: 80px !important;"
                        (click)="toggleLanguageMonthDropdown()">
                        {{ getMonthName(selectedLanguageMonth) }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showLanguageMonthDropdown">
                        <button *ngFor="let month of availableMonths" class="dropdown-item"
                          [class.active]="selectedLanguageMonth === month.value"
                          (click)="selectLanguageMonth(month.value)">
                          {{ month.name }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="chart-actions-right">
                  <div class="filter-button-container">
                    <button class="filter-toggle-btn" (click)="toggleLanguageFilterPanel($event)">
                      <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                      </svg>
                    </button>
                  </div>

                  <div class="chart-menu-container">
                    <button class="chart-menu-btn" (click)="toggleLanguageChartMenu()">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <circle cx="12" cy="6" r="2"></circle>
                        <circle cx="12" cy="12" r="2"></circle>
                        <circle cx="12" cy="18" r="2"></circle>
                      </svg>
                    </button>

                    <div class="chart-menu-dropdown" [class.show]="showLanguageChartMenu">
                      <button class="chart-menu-close-btn" (click)="showLanguageChartMenu = false">×</button>
                      <button class="chart-menu-item" (click)="showLanguageTableModal()">
                        <span>Show as Table</span>
                      </button>

                      <button class="chart-menu-item" (click)="openLanguageMonthCompareDialog()">
                        <span>Compare</span>
                      </button>

                      <div class="menu-item-with-submenu" (mouseenter)="showLanguageDownloadSubMenu = true"
                        (mouseleave)="showLanguageDownloadSubMenu = false">
                        <button class="chart-menu-item submenu-trigger">
                          <span>Download</span>
                          <span class="submenu-arrow">›</span>
                        </button>

                        <div class="submenu" [class.show]="showLanguageDownloadSubMenu">
                          <button class="chart-menu-close-btn" (click)="showLanguageDownloadSubMenu = false">×</button>
                          <button class="submenu-item"
                            (click)="exportLanguageChartAsPDF(); showLanguageChartMenu=false;">
                            <span>Export as PDF</span>
                          </button>
                          <button class="submenu-item"
                            (click)="exportLanguageChartAsPNG(); showLanguageChartMenu=false;">
                            <span>Export as PNG</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showLanguageFilterPanel">
                <div class="filter-panel">
                  <div class="filter-columns-container">
                    <div class="filter-headers-column">
                      <div class="filter-headers-header">
                        <mat-icon class="filter-icon">tune</mat-icon>
                        <span class="filter-title">Filter</span>
                      </div>
                      <div class="filter-headers-list">
                        <div *ngFor="let filter of languageFilterHeaders; let i = index"
                          class="filter-header-item"
                          [class.active]="activeLanguageFilterHeader === filter.key">
                          <label class="filter-header-checkbox-label" [for]="'language-filter-header-' + i">
                            <input type="checkbox" class="filter-checkbox-input"
                              [id]="'language-filter-header-' + i"
                              [checked]="activeLanguageFilterHeader === filter.key"
                              (click)="setActiveLanguageFilterHeader(filter.key)"
                              (change)="setActiveLanguageFilterHeader(filter.key)"
                              style="display: none;">
                            <span class="filter-checkmark"></span>
                            <span class="filter-header-name">{{ filter.name }}</span>
                          </label>
                        </div>
                      </div>
                      <button class="filter-clear-button" (click)="clearLanguageFilters()">
                        Clear
                      </button>
                    </div>

                    <div class="filter-content-column">
                      <div class="filter-search" *ngIf="activeLanguageFilterHeader === 'courses'">
                        <input type="text" placeholder="Search courses..." class="filter-search-input"
                          [(ngModel)]="courseSearchTerm" (input)="filterCourses()">
                      </div>

                      <div class="filter-search" *ngIf="activeLanguageFilterHeader === 'languages'">
                        <input type="text" placeholder="Search language..." class="filter-search-input"
                          [(ngModel)]="languageSearchTerm" (input)="filterLanguages()">
                      </div>

                      <div class="filter-search" *ngIf="activeLanguageFilterHeader === 'questionTypes'">
                        <input type="text" placeholder="Search question types..." class="filter-search-input"
                          [(ngModel)]="languageTypeSearchTerm" (input)="filterLanguageTypes()">
                      </div>

                      <div class="filter-search" *ngIf="activeLanguageFilterHeader === 'difficulty'">
                        <input type="text" placeholder="Search difficulty levels..." class="filter-search-input"
                          [(ngModel)]="languageDifficultySearchTerm" (input)="filterLanguageDifficultyLevels()">
                      </div>

                      <div class="filter-search" *ngIf="activeLanguageFilterHeader === 'evaluationMode'">
                        <input type="text" placeholder="Search evaluation mode..." class="filter-search-input"
                          [(ngModel)]="languageEvaluationModeSearchTerm" (input)="filterLanguageEvaluationModes()">
                      </div>

                      <div class="filter-options-container" style="margin-top: 5px;">
                        <div class="filter-options-list">
                          <div *ngIf="activeLanguageFilterHeader === 'courses'">
                           

                            <div *ngFor="let course of filteredCourseList" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="isCourseSelectedForLanguage(course.course_id)"
                                  (change)="toggleCourseSelectionForLanguage(course.course_id)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ course.course_name }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredCourseList?.length === 0 && courseSearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>

                          <div *ngIf="activeLanguageFilterHeader === 'languages'">
                            <div *ngFor="let language of filteredLanguageList" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="isLanguageSelected(language.code)"
                                  (change)="toggleLanguageSelection(language.code)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ language.name }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredLanguageList?.length === 0 && languageSearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>

                          <div *ngIf="activeLanguageFilterHeader === 'questionTypes'">
                            <div *ngFor="let type of filteredLanguageTypeList" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="isLanguageTypeSelected(type.value)"
                                  (change)="toggleLanguageTypeSelection(type.value)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ type.label }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredLanguageTypeList?.length === 0 && languageTypeSearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>

                          <div *ngIf="activeLanguageFilterHeader === 'difficulty'">
                            <div *ngFor="let level of filteredLanguageDifficultyLevels" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="isLanguageDifficultySelected(level.value)"
                                  (change)="toggleLanguageDifficultySelection(level.value)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ level.label }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredLanguageDifficultyLevels?.length === 0 && languageDifficultySearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>

                          <div *ngIf="activeLanguageFilterHeader === 'evaluationMode'">
                            <div *ngFor="let mode of filteredLanguageEvaluationModesList" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="selectedLanguageEvaluationModes.includes(mode)"
                                  (change)="toggleLanguageEvaluationModeSelection(mode)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ mode }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredLanguageEvaluationModesList?.length === 0 && languageEvaluationModeSearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="showLanguageTableModalFlag" class="table-modal-overlay" (click)="closeLanguageTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Question Language Distribution</h3>
                  <button class="table-modal-close" (click)="closeLanguageTableModal()">Ã—</button>
                </div>

                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table language-modal-table">
                      <thead>
                        <tr>
                          <th>Course Name</th>
                          <th>Language</th>
                          <th>Question Count</th>
                          <th>Percentage</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of languageBarChartData; let i = index"
                          [class.zero-data]="item.value === 0">
                          <td>{{ item.courseName || 'All Courses' }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.value }}</td>
                          <td>{{ getLanguagePercentage(item) }}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportLanguageTableAsPDF()">
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="showLanguageMonthCompareDialog" class="compare-dialog-overlay"
              (click)="closeLanguageMonthCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Questions by Language</h3>
                  <button class="compare-dialog-close" (click)="closeLanguageMonthCompareDialog()">Ã—</button>
                </div>

                <div class="compare-dialog-content">
                  <div class="compare-filters">
                    <div class="filter-group">
                      <label>Select Month 1:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleLanguageCompareMonth1Dropdown()">
                          {{ selectedLanguageCompareMonth1 ? getMonthName(selectedLanguageCompareMonth1) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showLanguageCompareMonth1Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedLanguageCompareMonth1 === month.value"
                            (click)="selectLanguageCompareMonth1(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="filter-group">
                      <label>Select Month 2:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleLanguageCompareMonth2Dropdown()">
                          {{ selectedLanguageCompareMonth2 ? getMonthName(selectedLanguageCompareMonth2) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showLanguageCompareMonth2Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedLanguageCompareMonth2 === month.value"
                            (click)="selectLanguageCompareMonth2(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <button class="btn-compare" (click)="loadLanguageMonthComparisonData()" [disabled]="!selectedLanguageCompareMonth1 || !selectedLanguageCompareMonth2">Compare</button>
                  </div>

                  <div class="compare-results" *ngIf="showLanguageMonthComparisonResults && (currentLanguageMonthComparisonData.length > 0 || compareLanguageMonthComparisonData.length > 0)">
                    <h4 class="results-title">Comparison Results</h4>

                    <!-- Chart View Only -->
                    <div class="chart-container-comparison" style="position: relative; height: 400px; width: 100%; margin-bottom: 20px;">
                      <canvas id="languageMonthComparisonChart"></canvas>
                    </div>
                  </div>

                  <div class="no-comparison-results"
                    *ngIf="showLanguageMonthComparisonResults && currentLanguageMonthComparisonData.length === 0 && compareLanguageMonthComparisonData.length === 0">
                    <p>No data available for comparison with selected period.</p>
                  </div>
                </div>

                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeLanguageMonthCompareDialog()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <div class="donut-chart-container" *ngIf="showLanguageBarChart">
              <div class="chart-wrapper" style="margin-top: 40px;">
                <canvas id="languageBarChart"></canvas>
              </div>
              <div class="chart-legend">
                <div *ngFor="let item of languageBarChartData" class="legend-item" [class.zero-data]="item.value === 0">
                  <span class="legend-color" [style.background-color]="item.color"></span>
                  <span class="legend-label">
                    <span class="course-name" *ngIf="!shouldShowOverallLanguage()">{{ item.courseName }} - </span>
                    {{ item.name }}
                  </span>
                  <span class="legend-count" [class.zero-count]="item.value === 0">
                    {{ item.value }} ({{ getLanguagePercentage(item) }}%)
                  </span>
                </div>
              </div>
            </div>

            <div *ngIf="!showLanguageBarChart" class="no-data-message">
              <p>No question paper data available for the selected filters.</p>
            </div>

            <div class="chart-header-new" style="margin-top: 25px;">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">Questions by Language</span>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Question Category Breakdown Section -->
          <div class="chart-container">
            <div>
              <div class="chart-filters-row">
                <div class="month-year-filters">
                  <div class="filter-group">
                    <div class="year-dropdown">
                      <button class="dropdown-btny" style="width: 40px !important;"
                        (click)="toggleCategoryYearDropdown()">
                        {{ selectedCategoryYearRange }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showCategoryYearDropdown">
                        <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                          [class.active]="selectedCategoryYearRange === yearRange.value"
                          (click)="selectCategoryYearRange(yearRange.value)">
                          {{ yearRange.display }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="filter-group">
                    <div class="month-dropdown">
                      <button class="dropdown-btny" style="width: 80px !important;"
                        (click)="toggleCategoryMonthDropdown()">
                        {{ getMonthName(selectedCategoryMonth) }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showCategoryMonthDropdown">
                        <button *ngFor="let month of availableMonths" class="dropdown-item"
                          [class.active]="selectedCategoryMonth === month.value"
                          (click)="selectCategoryMonth(month.value)">
                          {{ month.name }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="chart-actions-right">
                  <div class="filter-button-container">
                    <button class="filter-toggle-btn" (click)="toggleCategoryFilterPanel($event)">
                      <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                      </svg>
                    </button>
                  </div>

                  <div class="chart-menu-container">
                    <button class="chart-menu-btn" (click)="toggleCategoryChartMenu()">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <circle cx="12" cy="6" r="2"></circle>
                        <circle cx="12" cy="12" r="2"></circle>
                        <circle cx="12" cy="18" r="2"></circle>
                      </svg>
                    </button>

                    <div class="chart-menu-dropdown" [class.show]="showCategoryChartMenu">
                      <button class="chart-menu-close-btn" (click)="showCategoryChartMenu = false">×</button>
                      <button class="chart-menu-item" (click)="showCategoryTableModal()">
                        <span>Show as Table</span>
                      </button>

                      <button class="chart-menu-item" (click)="openCategoryCompareDialog(); showCategoryChartMenu=false;">
                        <span>Compare</span>
                      </button>

                      <div class="menu-item-with-submenu" (mouseenter)="showCategoryDownloadSubMenu = true"
                        (mouseleave)="showCategoryDownloadSubMenu = false">
                        <button class="chart-menu-item submenu-trigger">
                          <span>Download</span>
                          <span class="submenu-arrow">›</span>
                        </button>

                        <div class="submenu" [class.show]="showCategoryDownloadSubMenu">
                          <button class="chart-menu-close-btn" (click)="showCategoryDownloadSubMenu = false">×</button>
                          <button class="submenu-item"
                            (click)="exportCategoryChartAsPDF(); showCategoryChartMenu=false;">
                            <span>Export as PDF</span>
                          </button>
                          <button class="submenu-item"
                            (click)="exportCategoryChartAsPNG(); showCategoryChartMenu=false;">
                            <span>Export as PNG</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showCategoryFilterPanel">
                <div class="filter-panel">
                  <div class="filter-columns-container">
                    <div class="filter-headers-column">
                      <div class="filter-headers-header">
                        <mat-icon class="filter-icon">tune</mat-icon>
                        <span class="filter-title">Filter</span>
                      </div>
                      <div class="filter-headers-list">
                        <div *ngFor="let filter of categoryFilterHeaders; let i = index"
                          class="filter-header-item"
                          [class.active]="activeCategoryFilterHeader === filter.key">
                          <label class="filter-header-checkbox-label" [for]="'category-filter-header-' + i">
                            <input type="checkbox" class="filter-checkbox-input"
                              [id]="'category-filter-header-' + i"
                              [checked]="activeCategoryFilterHeader === filter.key"
                              (click)="setActiveCategoryFilterHeader(filter.key)"
                              (change)="setActiveCategoryFilterHeader(filter.key)"
                              style="display: none;">
                            <span class="filter-checkmark"></span>
                            <span class="filter-header-name">{{ filter.name }}</span>
                          </label>
                        </div>
                      </div>
                      <button class="filter-clear-button" (click)="clearCategoryFilters()">
                        Clear
                      </button>
                    </div>

                    <div class="filter-content-column">
                      <div class="filter-search" *ngIf="activeCategoryFilterHeader === 'courses'">
                        <input type="text" placeholder="Search courses..." class="filter-search-input"
                          [(ngModel)]="categoryCourseSearchTerm" (input)="filterCategoryCourses()">
                      </div>

                      <div class="filter-search" *ngIf="activeCategoryFilterHeader === 'languages'">
                        <input type="text" placeholder="Search languages..." class="filter-search-input"
                          [(ngModel)]="categoryLanguageSearchTerm" (input)="filterCategoryLanguages()">
                      </div>

                      <div class="filter-search" *ngIf="activeCategoryFilterHeader === 'difficulty'">
                        <input type="text" placeholder="Search difficulty..." class="filter-search-input"
                          [(ngModel)]="categoryDifficultySearchTerm" (input)="filterCategoryDifficultyLevels()">
                      </div>

                      <div class="filter-search" *ngIf="activeCategoryFilterHeader === 'types'">
                        <input type="text" placeholder="Search type..." class="filter-search-input"
                          [(ngModel)]="categoryTypeSearchTerm" (input)="filterCategoryTypes()">
                      </div>

                      <div class="filter-search" *ngIf="activeCategoryFilterHeader === 'categories'">
                        <input type="text" placeholder="Search category..." class="filter-search-input"
                          [(ngModel)]="categorySearchTerm" (input)="filterCategories()">
                      </div>

                      <div class="filter-options-container" style="margin-top: 5px;">
                        <div class="filter-options-list">
                          <div *ngIf="activeCategoryFilterHeader === 'courses'" class="filter-options-group">
                           

                            <div *ngFor="let course of filteredCategoryCourseList" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="isCourseSelectedForCategory(course.course_id)"
                                  (change)="toggleCourseSelectionForCategory(course.course_id)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ course.course_name }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredCategoryCourseList?.length === 0 && categoryCourseSearchTerm"
                              class="no-results-message">
                              No Data Found
                            </div>
                          </div>


                          <div *ngIf="activeCategoryFilterHeader === 'difficulty'" class="filter-options-group">
                           
                            <div *ngFor="let level of filteredCategoryDifficultyList" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="isCategoryDifficultyLevelSelected(level.value)"
                                  (change)="toggleCategoryDifficultyLevelSelection(level.value)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ level.label }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredCategoryDifficultyList?.length === 0 && categoryDifficultySearchTerm"
                              class="no-results-message">
                              No Data Found
                            </div>
                          </div>

                         

                          <div *ngIf="activeCategoryFilterHeader === 'categories'" class="filter-options-group">
                           
                            <div *ngFor="let category of filteredCategoryList" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="isCategorySelected(category.value)"
                                  (change)="toggleCategorySelection(category.value)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ category.label }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredCategoryList?.length === 0 && categorySearchTerm"
                              class="no-results-message">
                              No Data Found
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="showCategoryTableModalFlag" class="table-modal-overlay" (click)="closeCategoryTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Question Category Distribution</h3>
                  <button class="table-modal-close" (click)="closeCategoryTableModal()">×</button>
                </div>

                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table category-modal-table">
                      <thead>
                        <tr>
                          <th>Course Name</th>
                          <th>Category</th>
                          <th>Question Count</th>
                          <th>Percentage</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of categoryChartData; let i = index" [class.zero-data]="item.value === 0">
                          <td>{{ item.courseName || 'All Courses' }}</td>
                          <td>{{ item.name }}</td>
                          <td>{{ item.value }}</td>
                          <td>{{ getCategoryPercentage(item) }}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportCategoryTableAsPDF()">
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="showCategoryCompareDialog" class="compare-dialog-overlay"
              (click)="closeCategoryCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Questions by Category</h3>
                  <button class="compare-dialog-close" (click)="closeCategoryCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <div class="compare-filters">
                    <div class="filter-group">
                      <label>Select Month 1:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleCategoryCompareMonth1Dropdown()">
                          {{ selectedCategoryCompareMonth1 ? getMonthName(selectedCategoryCompareMonth1) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showCategoryCompareMonth1Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedCategoryCompareMonth1 === month.value"
                            (click)="selectCategoryCompareMonth1(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="filter-group">
                      <label>Select Month 2:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleCategoryCompareMonth2Dropdown()">
                          {{ selectedCategoryCompareMonth2 ? getMonthName(selectedCategoryCompareMonth2) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showCategoryCompareMonth2Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedCategoryCompareMonth2 === month.value"
                            (click)="selectCategoryCompareMonth2(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <button class="btn-compare" (click)="loadCategoryMonthComparisonData()" [disabled]="!selectedCategoryCompareMonth1 || !selectedCategoryCompareMonth2">Compare</button>
                  </div>

                  <div class="compare-results" *ngIf="showCategoryMonthComparisonResults && (currentCategoryMonthComparisonData.length > 0 || compareCategoryMonthComparisonData.length > 0)">
                    <h4 class="results-title">Comparison Results</h4>

                    <!-- Chart View Only -->
                    <div class="chart-container-comparison" style="position: relative; height: 400px; width: 100%; margin-bottom: 20px;">
                      <canvas id="categoryMonthComparisonChart"></canvas>
                    </div>
                  </div>

                  <div class="no-comparison-results"
                    *ngIf="showCategoryMonthComparisonResults && currentCategoryMonthComparisonData.length === 0 && compareCategoryMonthComparisonData.length === 0">
                    <p>No data available for comparison with selected period.</p>
                  </div>
                </div>

                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeCategoryCompareDialog()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
            
            <!-- BAR CHART AREA -->
            <div class="bar-chart-container" *ngIf="categoryBarChartData && categoryBarChartData.length > 0" style="margin-left: 0px; height: 250px;">
              <div class="chart-wrapper" style="position: relative; height: 100%;">
                <canvas id="categoryBarChart" style="display: block; max-height: 100%;"></canvas>
              </div>

              <div class="chart-legend">
                <div *ngFor="let item of categoryBarChartData" class="legend-item" 
                    [class.zero-data]="(item.question_count || item.value) === 0">
                  <span class="legend-color" [style.background-color]="item.color"></span>
                  <span class="legend-label">{{ item.category_name || item.name }}</span>
                  <span class="legend-count" [class.zero-count]="(item.question_count || item.value) === 0">
                    {{ item.question_count || item.value }} 
                    ({{ getCategoryPercentage(item) }}%)
                  </span>
                </div>
              </div>
            </div>

            <!-- NO DATA MESSAGE -->
            <div *ngIf="!showCategoryBarChart || !categoryBarChartData || categoryBarChartData.length === 0" class="no-data-message"
              style="margin-bottom: 30px;">
              <p>No data available for the selected filters.</p>
            </div>
            <div class="chart-header-new" style="margin-top: 30px;">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">Questions by Category</span>
                </div>
              </div>
            </div>
          </div>
          <!--Questions by Course/Job Role Section -->
          <div class="chart-container" *ngIf="selectedViewType === 'library' || selectedViewType === 'all'">
            <div>
              <div class="chart-filters-row">
                <div class="month-year-filters">
                  <div class="filter-group">
                    <div class="year-dropdown">
                      <button class="dropdown-btny" style="width: 40px !important;"
                        (click)="toggleCourseYearDropdown()">
                        {{ selectedCourseYearRange }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showCourseYearDropdown">
                        <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                          [class.active]="selectedCourseYearRange === yearRange.value"
                          (click)="selectCourseYearRange(yearRange.value)">
                          {{ yearRange.display }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="filter-group">
                    <div class="month-dropdown">
                      <button class="dropdown-btny" style="width: 80px !important;"
                        (click)="toggleCourseMonthDropdown()">
                        {{ getMonthName(selectedCourseMonth) }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showCourseMonthDropdown">
                        <button *ngFor="let month of availableMonths" class="dropdown-item"
                          [class.active]="selectedCourseMonth === month.value" (click)="selectCourseMonth(month.value)">
                          {{ month.name }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="chart-actions-right">
                  <div class="filter-button-container">
                    <button class="filter-toggle-btn" (click)="toggleCourseFilterPanel($event)">
                      <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                      </svg>
                    </button>
                  </div>

                  <div class="chart-menu-container">
                    <button class="chart-menu-btn" (click)="toggleCourseChartMenu()">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <circle cx="12" cy="6" r="2"></circle>
                        <circle cx="12" cy="12" r="2"></circle>
                        <circle cx="12" cy="18" r="2"></circle>
                      </svg>
                    </button>

                    <div class="chart-menu-dropdown" [class.show]="showCourseChartMenu">
                      <button class="chart-menu-close-btn" (click)="showCourseChartMenu = false" style="color: black !important;">×</button>
                      <button class="chart-menu-item" (click)="showCourseTableModal()">
                        <span>Show as Table</span>
                      </button>

                      <button class="chart-menu-item" (click)="openCourseCompareDialog()">
                        <span>Compare</span>
                      </button>

                      <div class="menu-item-with-submenu" (mouseenter)="showCourseDownloadSubMenu = true"
                        (mouseleave)="showCourseDownloadSubMenu = false">
                        <button class="chart-menu-item submenu-trigger">
                          <span>Download</span>
                            <span class="submenu-arrow">›</span>
                        </button>

                        <div class="submenu" [class.show]="showCourseDownloadSubMenu">
                          <button class="chart-menu-close-btn" (click)="showCourseDownloadSubMenu = false" style="color: black !important;">×</button>
                          <button class="submenu-item" (click)="exportCourseChartAsPDF(); showCourseChartMenu=false;">
                            <span>Export as PDF</span>
                          </button>
                          <button class="submenu-item" (click)="exportCourseChartAsPNG(); showCourseChartMenu=false;">
                            <span>Export as PNG</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showCourseFilterPanel">
                <div class="filter-panel">
                  <div class="filter-columns-container">
                    <!-- Left Column - Filter Headers -->
                    <div class="filter-headers-column">
                      <!-- Filter Header with Icon -->
                      <div class="filter-headers-header">
                        <mat-icon class="filter-icon">tune</mat-icon>
                        <span class="filter-title">Filter</span>
                      </div>
                      
                      <div class="filter-headers-list">
                        <div *ngFor="let filter of courseFilterHeaders; let i = index" 
                          class="filter-header-item" 
                          [class.active]="activeCourseFilterHeader === filter.key">
                          <label class="filter-header-checkbox-label" [for]="'course-lib-header-' + i">
                            <input type="checkbox" class="filter-checkbox-input" 
                              [id]="'course-lib-header-' + i"
                              [checked]="activeCourseFilterHeader === filter.key"
                              (click)="activeCourseFilterHeader = filter.key"
                              (change)="activeCourseFilterHeader = filter.key"
                              style="display: none;">
                            <span class="filter-checkmark"></span>
                            <span class="filter-header-name">{{ filter.name }}</span>
                          </label>
                        </div>
                      </div>
                      
                      <!-- Clear Button -->
                      <button class="filter-clear-button" (click)="clearCourseFilters()">
                        Clear
                      </button>
                    </div>

                    <!-- Right Column - Filter Content -->
                    <div class="filter-content-column">
                      <div class="filter-search" *ngIf="activeCourseFilterHeader === 'courses'">
                        <input type="text" placeholder="Search courses..." class="filter-search-input"
                          [(ngModel)]="courseSearchTerm" (input)="filterCourseFilterCourses()">
                      </div>

                      <div class="filter-search" *ngIf="activeCourseFilterHeader === 'difficulty'">
                        <input type="text" placeholder="Search difficulty levels..." class="filter-search-input"
                          [(ngModel)]="courseDifficultySearchTerm" (input)="filterCourseDifficultyLevels()">
                      </div>

                      <div class="filter-search" *ngIf="activeCourseFilterHeader === 'types'">
                        <input type="text" placeholder="Search types..." class="filter-search-input"
                          [(ngModel)]="courseTypeSearchTerm" (input)="filterCourseTypes()">
                      </div>

                      <div class="filter-search" *ngIf="activeCourseFilterHeader === 'evaluationMode'">
                        <input type="text" placeholder="Search evaluation modes..." class="filter-search-input"
                          [(ngModel)]="courseEvaluationModeSearchTerm" (input)="filterCourseEvaluationModes()">
                      </div>

                      <div class="filter-search" *ngIf="activeCourseFilterHeader === 'language'">
                        <input type="text" placeholder="Search languages..." class="filter-search-input"
                          [(ngModel)]="courseLanguageSearchTerm" (input)="filterCourseLanguages()">
                      </div>

                      <div class="filter-options-container" style="margin-top: 5px;">
                        <div class="filter-options-list">
                          <div *ngIf="activeCourseFilterHeader === 'courses'" class="filter-options-group">
                            <div *ngFor="let course of filteredCourseFilterList" >
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="isCourseSelectedForCourseFilter(course.course_id)"
                                  (change)="toggleCourseSelectionForCourseFilter(course.course_id)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ course.course_name }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredCourseFilterList.length === 0 && courseSearchTerm"
                              class="no-results-message">
                              No Data Found
                            </div>
                          </div>

                          <!-- Course Chart - Difficulty Level Section -->
                          <div *ngIf="activeCourseFilterHeader === 'difficulty'" class="filter-options-group">
                            <div *ngFor="let level of filteredCourseDifficultyList" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="selectedCourseFilterDifficultyLevels.includes(level.value)"
                                  (change)="toggleCourseDifficultyFilter(level.value)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ level.label }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredCourseDifficultyList?.length === 0 && courseDifficultySearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>

                          <!-- Course Chart - Type Section -->
                          <div *ngIf="activeCourseFilterHeader === 'types'" class="filter-options-group">
                            <div *ngFor="let type of filteredCourseTypeList" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="selectedCourseFilterTypes.includes(type.value)"
                                  (change)="toggleCourseTypeFilter(type.value)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ type.label }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredCourseTypeList?.length === 0 && courseTypeSearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>

                          <!-- Course Chart - Evaluation Mode Section -->
                          <div *ngIf="activeCourseFilterHeader === 'evaluationMode'" class="filter-options-group">
                            <div *ngFor="let mode of filteredCourseEvaluationModeList" class="filter-option-item">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="selectedCourseFilterEvaluationModes.includes(mode)"
                                  (change)="toggleCourseEvaluationModeFilter(mode)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ mode }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredCourseEvaluationModeList?.length === 0 && courseEvaluationModeSearchTerm" class="no-results-message">
                              No Data Found
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Course Table Modal -->
            <div *ngIf="showCourseTableModalFlag" class="table-modal-overlay" (click)="closeCourseTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Question Course Distribution</h3>
                  <button class="table-modal-close" (click)="closeCourseTableModal()">×</button>
                </div>

                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table course-modal-table">
                      <thead>
                        <tr>
                          <th>Course Name</th>
                          <th>Question Count</th>
                          <th>Percentage</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of courseBarChartData; let i = index" [class.zero-data]="item.value === 0">
                          <td>{{ item.name }}</td>
                          <td>{{ item.value }}</td>
                          <td>{{ getCoursePercentage(item) }}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportCourseTableAsPDF()">
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="showCourseCompareDialog" class="compare-dialog-overlay" (click)="closeCourseCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Course Distribution</h3>
                  <button class="compare-dialog-close" (click)="closeCourseCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <div class="compare-section">
                    <h4 class="compare-section-title">Select Financial Year</h4>
                    <div class="compare-year-range">
                      <div class="year-range-dropdown">
                        <button class="dropdown-btn" (click)="toggleCourseCompareYearDropdown()">
                          {{ selectedCourseCompareYearRange || 'Select Year Range' }}
                          <span class="dropdown-arrow">▼</span>
                        </button>
                        <div class="dropdown-menu" [class.show]="showCourseCompareYearDropdown">
                          <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                            [class.active]="selectedCourseCompareYearRange === yearRange.value"
                            (click)="selectCourseCompareYearRange(yearRange.value)">
                            {{ yearRange.display }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="compare-section">
                    <h4 class="compare-section-title">Select Month</h4>
                    <div class="compare-month-selection">
                      <div class="month-dropdown">
                        <button class="dropdown-btn" (click)="toggleCourseCompareMonthDropdown()">
                          {{ getMonthName(selectedCourseCompareMonth) || 'All Months' }}
                          <span class="dropdown-arrow">▼</span>
                        </button>
                        <div class="dropdown-menu" [class.show]="showCourseCompareMonthDropdown">
                          <button class="dropdown-item" [class.active]="selectedCourseCompareMonth === null"
                            (click)="selectCourseCompareMonth(null)">
                            All Months
                          </button>
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedCourseCompareMonth === month.value"
                            (click)="selectCourseCompareMonth(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="compare-results" *ngIf="showCourseComparisonResults">
                    <h4 class="results-title">Comparison Results</h4>

                    <div class="comparison-row">
                      <div class="comparison-item current">
                        <div class="comparison-header">
                          <span class="comparison-label">Current</span>
                          <span class="comparison-period">{{ selectedCourseYearRange }} • {{
                            getMonthName(selectedCourseMonth) }}</span>
                        </div>
                        <div class="comparison-stats">
                          <div class="stat-item" *ngFor="let item of currentCourseComparisonData">
                            <span class="stat-label">{{ item.name }}</span>
                            <span class="stat-value">{{ item.value }}</span>
                            <span class="stat-percentage">{{ item.percentage }}%</span>
                          </div>
                        </div>
                        <div class="total-questions">
                          Total: {{ getCurrentCourseTotalQuestions() }}
                        </div>
                      </div>

                      <div class="vs-separator">
                        <span>VS</span>
                      </div>

                      <div class="comparison-item compare">
                        <div class="comparison-header">
                          <span class="comparison-label">Compare</span>
                          <span class="comparison-period">{{ selectedCourseCompareYearRange }} • {{
                            getMonthName(selectedCourseCompareMonth) }}</span>
                        </div>
                        <div class="comparison-stats">
                          <div class="stat-item" *ngFor="let item of compareCourseComparisonData"
                            [class.positive]="item.trend === 'positive'" [class.negative]="item.trend === 'negative'"
                            [class.neutral]="item.trend === 'neutral'">
                            <span class="stat-label">{{ item.name }}</span>
                            <span class="stat-value">{{ item.value }}</span>
                            <span class="stat-percentage">{{ item.percentage }}%</span>
                            <span class="trend-indicator" *ngIf="item.trend !== 'neutral'">
                              {{ item.trend === 'positive' ? '↗' : '↘' }}
                            </span>
                          </div>
                        </div>
                        <div class="total-questions">
                          Total: {{ getCompareCourseTotalQuestions() }}
                        </div>
                      </div>
                    </div>

                    <div class="trend-summary" *ngIf="courseTrendSummary">
                      <h5>Summary</h5>
                      <div class="trend-item" *ngFor="let trend of courseTrendSummary">
                        <span class="trend-category">{{ trend.category }}</span>
                        <span class="trend-value" [class.positive]="trend.trend === 'positive'"
                          [class.negative]="trend.trend === 'negative'">
                          {{ trend.value }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="no-comparison-results"
                    *ngIf="showCourseComparisonResults && (!currentCourseComparisonData.length || !compareCourseComparisonData.length)">
                    <p>No data available for comparison with selected period.</p>
                  </div>
                </div>

                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeCourseCompareDialog()">
                    Cancel
                  </button>
                  <button class="compare-action-btn primary" (click)="loadCourseComparisonData()"
                    [disabled]="!selectedCourseCompareYearRange">
                    Compare
                  </button>
                </div>
              </div>
            </div>
            <div class="bar-chart-container" *ngIf="showCourseBarChart" style="margin-left: -20px;">
              <div class="chart-wrapper">
                <canvas id="courseBarChart"></canvas>
              </div>
              <div class="chart-legend">
                <div *ngFor="let item of courseBarChartData" class="legend-item" [class.zero-data]="item.value === 0">
                  <span class="legend-color" [style.background-color]="item.color"></span>
                  <span class="legend-label">{{ item.name }}</span>
                  <span class="legend-count" [class.zero-count]="item.value === 0">
                    {{ item.value }} ({{ getCoursePercentage(item) }}%)
                  </span>
                </div>
              </div>
            </div>

            <div *ngIf="!showCourseBarChart" class="no-data-message">
              <p>No question paper data available for the selected filters.</p>
            </div>

            <div class="chart-header-new" style="margin-top:35px;">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">Questions by Course/Job Role</span>
                </div>
              </div>
            </div>
          </div>
          <!-- Course Table Modal -->
          <div *ngIf="showCourseTableModalFlag" class="table-modal-overlay" (click)="closeCourseTableModal()">
            <div class="table-modal" (click)="$event.stopPropagation()">
              <div class="table-modal-header">
                <h3 class="table-modal-title">Questions by Course/Job Role - Detailed View</h3>
                <button class="table-modal-close" (click)="closeCourseTableModal()">×</button>
              </div>

              <div class="table-modal-content">
                <div class="modal-table-container">
                  <table class="modal-table">
                    <thead>
                      <tr>
                        <th>Course/Job Role</th>
                        <th>Question Count</th>
                        <th>Percentage</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of courseBarChartData" [class.zero-data]="item.value === 0">
                        <td>{{ item.name }}</td>
                        <td>{{ item.value }}</td>
                        <td>{{ getCoursePercentage(item) }}%</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="modal-table-actions">
                <button class="modal-export-btn secondary" (click)="exportCourseTableAsPDF()">
                  Export as PDF
                </button>
                <button class="modal-export-btn" (click)="exportCourseTableAsPNG()">
                  Export as PNG
                </button>
              </div>
            </div>
          </div>

          <!-- Question Papers by Course/Job Role Chart -->
          <div class="chart-container" *ngIf="selectedViewType === 'library' || selectedViewType === 'all'">
            <div>
              <div class="chart-filters-row">
                <div class="month-year-filters">
                  <div class="filter-group">
                    <div class="year-dropdown">
                      <button class="dropdown-btny" style="width: 40px !important;"
                        (click)="toggleQuestionPaperCourseYearDropdown()">
                        {{ selectedQuestionPaperCourseYearRange }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showQuestionPaperCourseYearDropdown">
                        <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                          [class.active]="selectedQuestionPaperCourseYearRange === yearRange.value"
                          (click)="selectQuestionPaperCourseYearRange(yearRange.value)">
                          {{ yearRange.display }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="filter-group">
                    <div class="month-dropdown">
                      <button class="dropdown-btny" style="width: 80px !important;"
                        (click)="toggleQuestionPaperCourseMonthDropdown()">
                        {{ getMonthName(selectedQuestionPaperCourseMonth) }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showQuestionPaperCourseMonthDropdown">
                        <button *ngFor="let month of availableMonths" class="dropdown-item"
                          [class.active]="selectedQuestionPaperCourseMonth === month.value"
                          (click)="selectQuestionPaperCourseMonth(month.value)">
                          {{ month.name }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="chart-actions-right">
                  <div class="filter-button-container">
                    <button class="filter-toggle-btn" (click)="toggleQuestionPaperCourseFilterPanel($event)">
                      <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                      </svg>
                    </button>
                  </div>

                  <div class="chart-menu-container">
                    <button class="chart-menu-btn" (click)="toggleQuestionPaperCourseChartMenu()">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <circle cx="12" cy="6" r="2"></circle>
                        <circle cx="12" cy="12" r="2"></circle>
                        <circle cx="12" cy="18" r="2"></circle>
                      </svg>
                    </button>

                    <div class="chart-menu-dropdown" [class.show]="showQuestionPaperCourseChartMenu">
                      <button class="chart-menu-close-btn" (click)="showQuestionPaperCourseChartMenu = false" style="color: black !important;">×</button>
                      <button class="chart-menu-item" (click)="showQuestionPaperCourseTableModal()">
                        <span>Show as Table</span>
                      </button>

                      <button class="chart-menu-item" (click)="openQuestionPaperCourseCompareDialog()">
                        <span>Compare</span>
                      </button>

                      <div class="menu-item-with-submenu" (mouseenter)="showQuestionPaperCourseDownloadSubMenu = true"
                        (mouseleave)="showQuestionPaperCourseDownloadSubMenu = false">
                        <button class="chart-menu-item submenu-trigger">
                          <span>Download</span>
                            <span class="submenu-arrow">›</span>
                        </button>

                        <div class="submenu" [class.show]="showQuestionPaperCourseDownloadSubMenu">
                          <button class="chart-menu-close-btn" (click)="showQuestionPaperCourseDownloadSubMenu = false">×</button>
                          <button class="submenu-item"
                            (click)="exportQuestionPaperByCourseChartAsPDF(); showQuestionPaperCourseChartMenu=false;">
                            <span>Export as PDF</span>
                          </button>
                          <button class="submenu-item"
                            (click)="exportQuestionPaperByCourseChartAsPNG(); showQuestionPaperCourseChartMenu=false;">
                            <span>Export as PNG</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="filter-panel-container" style="margin-right: 110px; margin-top: -40px;" [class.active]="showQuestionPaperCourseFilterPanel">
                <div class="filter-panel">
                  <div class="filter-columns-container">
                    <div class="filter-headers-column">
                      <div class="filter-headers-header">
                        <mat-icon class="filter-icon">tune</mat-icon>
                        <span class="filter-title">Filter</span>
                      </div>

                      <div class="filter-headers-list">
                        <div *ngFor="let filter of questionPaperCourseFilterHeaders; let i = index" class="filter-header-item"
                          [class.active]="activeQuestionPaperCourseFilterHeader === filter.key">
                          <label class="filter-header-checkbox-label" [for]="'question-paper-course-filter-header-' + i">
                            <input type="checkbox" class="filter-checkbox-input"
                              [id]="'question-paper-course-filter-header-' + i"
                              [checked]="activeQuestionPaperCourseFilterHeader === filter.key"
                              (click)="setActiveQuestionPaperCourseFilterHeader(filter.key)"
                              (change)="setActiveQuestionPaperCourseFilterHeader(filter.key)"
                              style="display: none;">
                            <span class="filter-checkmark"></span>
                            <span class="filter-header-name">{{ filter.name }}</span>
                          </label>
                        </div>
                      </div>

                      <button class="filter-clear-button" (click)="clearQuestionPaperCourseFilters()">
                        Clear
                      </button>
                    </div>

                    <div class="filter-content-column">
                      <div class="filter-search" *ngIf="activeQuestionPaperCourseFilterHeader === 'courses'">
                        <input type="text" class="filter-search-input" placeholder="Search courses..."
                          [(ngModel)]="questionPaperCourseSearchTerm" (input)="filterQuestionPaperCourses()">
                      </div>

                      <div class="filter-search" *ngIf="activeQuestionPaperCourseFilterHeader === 'customers'">
                        <input type="text" class="filter-search-input" placeholder="Search customers..."
                          [(ngModel)]="questionPaperCustomerSearchTerm" (input)="filterQuestionPaperCustomers()">
                      </div>


                      <div class="filter-options-container">
                        <div class="filter-options-list">
                          <div *ngIf="activeQuestionPaperCourseFilterHeader === 'courses'" class="filter-options-group">

                            <div *ngFor="let course of filteredQuestionPaperCourseList">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="isCourseSelectedForQuestionPaperFilter(course.course_id)"
                                  (change)="toggleCourseSelectionForQuestionPaperFilter(course.course_id)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ course.course_name }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredQuestionPaperCourseList.length === 0 && questionPaperCourseSearchTerm"
                              class="no-options">
                              No matching courses found.
                            </div>
                          </div>

                          <div *ngIf="activeQuestionPaperCourseFilterHeader === 'customers'" class="filter-options-group">
                            

                            <div *ngFor="let customer of filteredQuestionPaperCustomerList">
                              <label class="filter-option-item">
                                <input type="checkbox" class="filter-checkbox-input"
                                  [checked]="isCustomerSelectedForQuestionPaperFilter(customer.id)"
                                  (change)="toggleCustomerSelectionForQuestionPaperFilter(customer.id)">
                                <span class="filter-checkmark"></span>
                                <span class="filter-option-name">{{ customer.name }}</span>
                              </label>
                            </div>

                            <div *ngIf="filteredQuestionPaperCustomerList.length === 0 && questionPaperCustomerSearchTerm"
                              class="no-options">
                              No matching customers found.
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Question Paper Table Modal -->
            <div *ngIf="showQuestionPaperCourseTableModalFlag" class="table-modal-overlay"
              (click)="closeQuestionPaperCourseTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Question Papers Distribution</h3>
                  <button class="table-modal-close" (click)="closeQuestionPaperCourseTableModal()">×</button>
                </div>

                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table questionpaper-course-modal-table">
                      <thead>
                        <tr>
                          <th>Course Name</th>
                          <th>Question Papers</th>
                          <th>Percentage</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of questionPaperByCourseChartData" [class.zero-data]="item.value === 0">
                          <td>{{ item.name }}</td>
                          <td>{{ item.value }}</td>
                          <td>{{ getQuestionPaperCoursePercentage(item) }}%</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportQuestionPaperByCourseTableAsPDF()">
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>

            <div *ngIf="showQuestionPaperCourseCompareDialog" class="compare-dialog-overlay"
              (click)="closeQuestionPaperCourseCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Question Papers by Course/Job Role</h3>
                  <button class="compare-dialog-close" (click)="closeQuestionPaperCourseCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <div class="compare-filters">
                    <div class="filter-group">
                      <label>Select Month 1:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleQuestionPaperCompareMonth1Dropdown()">
                          {{ selectedQuestionPaperCompareMonth1 ? getMonthName(selectedQuestionPaperCompareMonth1) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showQuestionPaperCompareMonth1Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedQuestionPaperCompareMonth1 === month.value"
                            (click)="selectQuestionPaperCompareMonth1(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="filter-group">
                      <label>Select Month 2:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleQuestionPaperCompareMonth2Dropdown()">
                          {{ selectedQuestionPaperCompareMonth2 ? getMonthName(selectedQuestionPaperCompareMonth2) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showQuestionPaperCompareMonth2Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedQuestionPaperCompareMonth2 === month.value"
                            (click)="selectQuestionPaperCompareMonth2(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <button class="btn-compare" (click)="loadQuestionPaperCourseComparisonData()" [disabled]="!selectedQuestionPaperCompareMonth1 || !selectedQuestionPaperCompareMonth2">Compare</button>
                  </div>

                  <div class="compare-results" *ngIf="showQuestionPaperCourseComparisonResults">
                    <h4 class="results-title">Comparison Results</h4>

                    <!-- Chart View Only -->
                    <div class="chart-container-comparison" style="position: relative; height: 400px; width: 100%; margin-bottom: 20px;">
                      <canvas id="questionPaperComparisonChart"></canvas>
                    </div>
                  </div>

                  <div class="no-comparison-results"
                    *ngIf="showQuestionPaperCourseComparisonResults && (!currentQuestionPaperCourseComparisonData.length || !compareQuestionPaperCourseComparisonData.length)">
                    <p>No data available for comparison with selected period.</p>
                  </div>
                </div>

                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeQuestionPaperCourseCompareDialog()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <div class="donut-chart-container" *ngIf="showQuestionPaperDonutChart">
              <div class="chart-wrapper">
                <canvas id="questionPaperByCourseDonutChart"></canvas>
              </div>
              <div class="chart-legend">
                <div *ngFor="let item of questionPaperDonutChartData" class="legend-item">
                  <span class="legend-color" [style.background-color]="item.color"></span>
                  <span class="legend-label">{{ item.name }}</span>
                  <span class="legend-count">{{ item.value }} ({{ getQuestionPaperCoursePercentage(item) }}%)</span>
                </div>
              </div>
            </div>

            <!-- No Data Message -->
            <div *ngIf="!showQuestionPaperDonutChart" class="no-data-message" style="margin-bottom: 30px;">
              <p>No question paper data available for the selected filters.</p>
            </div>

            <div class="chart-header-new" style="margin-top: 35px;">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">Question Papers by Course/Job Role</span>
                </div>
              </div>
            </div>
          </div>
          <!-- Top 10 Courses/Job Roles Chart -->
          <div class="chart-container" *ngIf="selectedViewType === 'library' || selectedViewType === 'all'">
            <div>
              <div class="chart-filters-row">
                <div class="month-year-filters">
                  <div class="filter-group">
                    <div class="year-dropdown">
                      <button class="dropdown-btny" style="width: 40px !important;"
                        (click)="toggleTop10CourseYearDropdown()">
                        {{ selectedTop10CourseYearRange }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showTop10CourseYearDropdown">
                        <button *ngFor="let yearRange of availableYearRanges" class="dropdown-item"
                          [class.active]="selectedTop10CourseYearRange === yearRange.value"
                          (click)="selectTop10CourseYearRange(yearRange.value)">
                          {{ yearRange.display }}
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="filter-group">
                    <div class="month-dropdown">
                      <button class="dropdown-btny" style="width: 80px !important;"
                        (click)="toggleTop10CourseMonthDropdown()">
                        {{ getMonthName(selectedTop10CourseMonth) }}
                      </button>
                      <div class="dropdown-menu" [class.show]="showTop10CourseMonthDropdown">
                        <button *ngFor="let month of availableMonths" class="dropdown-item"
                          [class.active]="selectedTop10CourseMonth === month.value"
                          (click)="selectTop10CourseMonth(month.value)">
                          {{ month.name }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="chart-actions-right">
                  <div class="filter-button-container">
                    <button class="filter-toggle-btn" (click)="toggleTop10CourseFilterPanel($event)">
                      <svg width="20" height="26" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M3 4h18l-6.5 8v6l-5 2v-8L3 4z" />
                      </svg>
                      <span class="active-filter-indicator" *ngIf="selectedTop10CourseFilterValues.length > 0">
                        {{ selectedTop10CourseFilterValues.length }}
                      </span>
                    </button>
                  </div>

                  <div class="chart-menu-container">
                    <button class="chart-menu-btn" (click)="toggleTop10CourseChartMenu()">
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                        <circle cx="12" cy="6" r="2"></circle>
                        <circle cx="12" cy="12" r="2"></circle>
                        <circle cx="12" cy="18" r="2"></circle>
                      </svg>
                    </button>

                    <div class="chart-menu-dropdown" [class.show]="showTop10CourseChartMenu">
                      <button class="chart-menu-close-btn" (click)="showTop10CourseChartMenu = false" style="color: black !important;">×</button>
                      <button class="chart-menu-item" (click)="showTop10CourseTableModal()">
                        <span>Show as Table</span>
                      </button>

                      <button class="chart-menu-item" (click)="openTop10CourseCompareDialog()">
                        <span>Compare</span>
                      </button>

                      <div class="menu-item-with-submenu" (mouseenter)="showTop10CourseDownloadSubMenu = true"
                        (mouseleave)="showTop10CourseDownloadSubMenu = false">
                        <button class="chart-menu-item submenu-trigger">
                          <span>Download</span>
                            <span class="submenu-arrow">›</span>
                        </button>

                        <div class="submenu" [class.show]="showTop10CourseDownloadSubMenu">
                          <button class="chart-menu-close-btn" (click)="showTop10CourseDownloadSubMenu = false" style="color: black !important;">×</button>
                          <button class="submenu-item"
                            (click)="exportTop10CourseChartAsPDF(); showTop10CourseChartMenu=false;">
                            <span>Export as PDF</span>
                          </button>
                          <button class="submenu-item"
                            (click)="exportTop10CourseChartAsPNG(); showTop10CourseChartMenu=false;">
                            <span>Export as PNG</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Top 10 Course Filter Panel -->
             <div class="top-filter-dropdown" style="margin-right: 110px;" [class.show]="showTop10CourseFilterPanel">

  <!-- Search -->
  <div class="top-filter-header">
    <input type="text" placeholder="Search Filter">
  </div>

  <!-- Options -->
  <div class="top-filter-body">

    <div class="top-filter-item">
      <label class="top-filter-label">
        <input
          type="radio"
          name="top10Metric"
          [checked]="selectedTop10Metric === 'questions'"
          (change)="selectTop10Metric('questions')">
        Questions
      </label>
    </div>

    <div class="top-filter-item">
      <label class="top-filter-label">
        <input
          type="radio"
          name="top10Metric"
          [checked]="selectedTop10Metric === 'questionPapers'"
          (change)="selectTop10Metric('questionPapers')">
        Question Papers
      </label>
    </div>

    <div class="top-filter-item">
      <label class="top-filter-label multi-line">
        <input
          type="radio"
          name="top10Metric"
          [checked]="selectedTop10Metric === 'assessments'"
          (change)="selectTop10Metric('assessments')">
        <span>
          Count of Assessments
          <small>(Most Assessments)</small>
        </span>
      </label>
    </div>

    <div class="top-filter-item">
      <label class="top-filter-label multi-line">
        <input
          type="radio"
          name="top10Metric"
          [checked]="selectedTop10Metric === 'least-assessments'"
          (change)="selectTop10Metric('least-assessments')">
        <span>
          Count of Assessments
          <small>(Least Assessments)</small>
        </span>
      </label>
    </div>

    <div class="top-filter-item">
      <label class="top-filter-label multi-line">
        <input
          type="radio"
          name="top10Metric"
          [checked]="selectedTop10Metric === 'language-breakdown'"
          (change)="selectTop10Metric('language-breakdown')">
        <span>
          Language by Regional Language
        </span>
      </label>
    </div>

    <!--<div class="top-filter-item">
      <label class="top-filter-label">
        <input type="checkbox" disabled>
        Average Pass %
      </label>
    </div>

    <div class="top-filter-item">
      <label class="top-filter-label">
        <input type="checkbox" disabled>
        Average Fail %
      </label>
    </div>-->

  </div>
</div>
            </div>

            <!-- Top 10 Course Table Modal -->
            <div *ngIf="showTop10CourseTableModalFlag" class="table-modal-overlay"
              (click)="closeTop10CourseTableModal()">
              <div class="table-modal" (click)="$event.stopPropagation()">
                <div class="table-modal-header">
                  <h3 class="table-modal-title">Top 10 Courses/Job Roles</h3>
                  <button class="table-modal-close" (click)="closeTop10CourseTableModal()">×</button>
                </div>

                <div class="table-modal-content">
                  <div class="modal-table-container">
                    <table class="modal-table top10-course-modal-table">
                      <thead>
                        <tr>
                          <th (click)="sortTop10CourseTable('rank')" class="sortable">
                            Rank
                          </th>
                          <th (click)="sortTop10CourseTable('courseName')" class="sortable">
                            Course/Job Role
                          </th>
                          <th (click)="sortTop10CourseTable('questionCount')" class="sortable">
                            {{ selectedTop10Metric === 'language-breakdown' ? 'Total Questions' : 'Question Count' }}
                          </th>
                          <th *ngIf="selectedTop10Metric === 'language-breakdown'" class="sortable">
                            Primary Language
                          </th>
                          <th (click)="sortTop10CourseTable('percentage')" class="sortable">
                            Percentage
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of getTop10CourseTableData()" (click)="onTop10CourseTableRowClick(item)"
                          class="clickable-row">
                          <td class="rank-cell">
                            <span class="rank-badge" [style.background-color]="getRankColor(item.rank)">
                              {{ item.rank }}
                            </span>
                          </td>
                          <td class="course-name-cell">{{ item.courseName }}</td>
                          <td class="count-cell">{{ item.questionCount }}</td>
                          <td *ngIf="selectedTop10Metric === 'language-breakdown'" class="language-breakdown-cell"
                              [title]="item.languageBreakdown">
                            {{ item.dominantLanguage }}
                          </td>
                          <td class="percentage-cell">{{ item.percentage }}%</td>
                        </tr>
                      </tbody>
                      <tfoot *ngIf="getTop10CourseTableData().length > 0">
                        <tr class="table-total-row">
                          <td [attr.colspan]="selectedTop10Metric === 'language-breakdown' ? '3' : '2'"><strong>Total</strong></td>
                          <td><strong>{{ getTotalTop10CourseQuestions() }}</strong></td>
                          <td *ngIf="selectedTop10Metric === 'language-breakdown'"><strong>Primary Language</strong></td>
                          <td><strong>100%</strong></td>
                        </tr>
                      </tfoot>
                    </table>

                    <div *ngIf="getTop10CourseTableData().length === 0" class="empty-table-message">
                      <div class="empty-state">
                        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                          <polyline points="9 22 9 12 15 12 15 22"></polyline>
                        </svg>
                        <h4>No Data Available</h4>
                        <p>No course data found for the selected filters and date range.</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="modal-table-actions">
                  <button class="modal-export-btn secondary" (click)="exportTop10CourseTableAsPDF()">
                    Export as PDF
                  </button>
                </div>
              </div>
            </div>

            <!-- Top 10 Course Compare Dialog -->
            <div *ngIf="showTop10CourseCompareDialog" class="compare-dialog-overlay"
              (click)="closeTop10CourseCompareDialog()">
              <div class="compare-dialog" (click)="$event.stopPropagation()">
                <div class="compare-dialog-header">
                  <h3 class="compare-dialog-title">Compare Top 10 Courses</h3>
                  <button class="compare-dialog-close" (click)="closeTop10CourseCompareDialog()">×</button>
                </div>

                <div class="compare-dialog-content">
                  <div class="compare-filters">
                    <div class="filter-group">
                      <label>Select Month 1:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleTop10CourseCompareMonth1Dropdown()">
                          {{ selectedTop10CourseCompareMonth1 ? getMonthName(selectedTop10CourseCompareMonth1) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showTop10CourseCompareMonth1Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedTop10CourseCompareMonth1 === month.value"
                            (click)="selectTop10CourseCompareMonth1(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div class="filter-group">
                      <label>Select Month 2:</label>
                      <div class="month-dropdown">
                        <button class="dropdown-btny" (click)="toggleTop10CourseCompareMonth2Dropdown()">
                          {{ selectedTop10CourseCompareMonth2 ? getMonthName(selectedTop10CourseCompareMonth2) : 'Select Month' }}
                        </button>
                        <div class="dropdown-menu" [class.show]="showTop10CourseCompareMonth2Dropdown">
                          <button *ngFor="let month of availableMonths" class="dropdown-item"
                            [class.active]="selectedTop10CourseCompareMonth2 === month.value"
                            (click)="selectTop10CourseCompareMonth2(month.value)">
                            {{ month.name }}
                          </button>
                        </div>
                      </div>
                    </div>

                    <button class="btn-compare" (click)="loadTop10CourseComparisonDataMonthWise()" [disabled]="!selectedTop10CourseCompareMonth1 || !selectedTop10CourseCompareMonth2">Compare</button>
                  </div>

                  <div class="compare-results" *ngIf="showTop10CourseComparisonResults">
                    <h4 class="results-title">Comparison Results</h4>

                    <!-- Chart View Only -->
                    <div class="chart-container-comparison" style="position: relative; height: 400px; width: 100%; margin-bottom: 20px;">
                      <canvas id="top10CourseComparisonChart"></canvas>
                    </div>
                  </div>

                  <div class="no-comparison-results"
                    *ngIf="showTop10CourseComparisonResults && (!currentTop10CourseComparisonData.length || !compareTop10CourseComparisonData.length)">
                    <p>No data available for comparison with selected period.</p>
                  </div>
                </div>

                <div class="compare-dialog-actions">
                  <button class="compare-action-btn secondary" (click)="closeTop10CourseCompareDialog()">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <div class="bar-chart-container" [class.language-breakdown-chart]="selectedTop10Metric === 'language-breakdown'" *ngIf="showTop10CourseBarChart">
              <div class="chart-wrapper">
                <canvas id="top10CourseBarChart"></canvas>
              </div>
              <div class="chart-legend" *ngIf="selectedTop10Metric !== 'language-breakdown'">
                <div *ngFor="let item of top10CourseBarChartData" class="legend-item"
                  [class.zero-data]="item.value === 0">
                  <span class="legend-color" [style.background-color]="item.color"></span>
                  <span class="legend-label">#{{ item.rank }} - {{ item.name }}</span>
                  <span class="legend-count" [class.zero-count]="item.value === 0">
                    {{ item.value }} ({{ getTop10CoursePercentage(item) }}%)
                  </span>
                </div>
              </div>
            </div>

            <!-- No Data Message -->
            <div *ngIf="!showTop10CourseBarChart" class="no-data-message">
              <p>No question data available for the selected filters.</p>
            </div>

            <div class="chart-header-new" style="margin-top: 10px;">
              <div class="chart-title-bottom">
                <div class="chart-title-section-center">
                  <span class="analyticslabel">Top 10 Courses/Job Roles</span>
                </div>
              </div>
            </div>

            <!-- Detailed Question Breakdown Table -->
            <div class="detailed-table"
              *ngIf="isFilterApplied() && showDetailedTable && questionCounts && questionCounts.length > 0">
              <h4>Detailed Question Breakdown by Course/Job Role</h4>
              <div class="table-container">
                <table class="question-breakdown-table">
                  <thead>
                    <tr>
                      <th>Course/Job Role</th>
                      <th>Total</th>
                      <th>Easy</th>
                      <th>Medium</th>
                      <th>Hard</th>
                      <th>MCQ</th>
                      <th>Coding</th>
                      <th>Descriptive</th>
                      <th>English</th>
                      <th>Hindi</th>
                      <th>Regional</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let course of getTopCourses()">
                      <td class="course-name">{{ course.course_name }}</td>
                      <td class="total-count">{{ course.question_count }}</td>
                      <td>{{ course.difficulty_breakdown?.easy || 0 }}</td>
                      <td>{{ course.difficulty_breakdown?.medium || 0 }}</td>
                      <td>{{ course.difficulty_breakdown?.hard || 0 }}</td>
                      <td>{{ course.type_breakdown?.mcq || 0 }}</td>
                      <td>{{ course.type_breakdown?.coding || 0 }}</td>
                      <td>{{ course.type_breakdown?.descriptive || 0 }}</td>
                      <td>{{ course.language_breakdown?.english || 0 }}</td>
                      <td>{{ course.language_breakdown?.hindi || 0 }}</td>
                      <td>{{ course.language_breakdown?.regional || 0 }}</td>
                      <td class="status-cell">
                        <span class="status-active">A: {{ course.status_breakdown?.active || 0 }}</span>
                        <span class="status-archived">Ar: {{ course.status_breakdown?.archived || 0 }}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- No Data Message -->
            <div *ngIf="isFilterApplied() && (!questionCounts || questionCounts.length === 0) && !isLoading"
              class="no-data-message">
              <p>No question data available for the selected date range.</p>
            </div>
          </div>
